var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErpOffer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 449,
    height: 410,
    viewBox: "0 0 449 410",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_293_11642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.182 198.946C439.182 198.946 438.906 214.42 438.906 215.526C438.906 226.994 429.787 234.316 425.78 236.527L198.496 368.752C191.726 372.621 181.917 380.634 166.995 380.22C159.257 380.082 150 377.457 139.085 370.963L44.0266 315.834C38.6381 312.657 33.1115 303.952 32.697 298.84C32.4207 294.142 32.9733 277.701 32.9733 277.701L80.917 271.069L116.426 250.344L297.423 144.923C283.745 153.213 321.326 138.567 331.274 144.37L418.181 194.939L439.182 198.946Z",
    fill: "#49E0B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.182 198.67C439.182 198.67 438.905 214.421 438.905 215.526C438.905 226.994 429.786 234.317 425.78 236.527L198.496 368.752C195.457 370.548 191.588 373.174 187.028 375.522C178.6 379.806 167.271 382.845 151.796 377.18C147.789 375.799 143.644 373.726 139.085 370.963L44.0264 315.835C38.6379 312.657 33.1113 303.952 32.6968 298.84C32.5586 297.597 32.5586 292.761 32.5586 290.55C32.5586 291.656 32.6968 292.623 32.6968 293.314C32.5586 301.742 38.6379 309.893 44.0264 313.071L139.085 368.2C143.644 370.963 147.789 372.897 151.796 374.417C167.271 380.082 178.6 377.042 187.028 372.759C191.588 370.41 195.457 367.785 198.496 365.989L425.78 233.764C429.786 231.553 439.182 225.336 438.905 209.861C438.905 209.308 439.044 203.091 439.182 198.67Z",
    fill: "#73FFD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.995 250.344V308.926H151.796V377.18C147.789 375.799 143.644 373.726 139.085 370.963L44.0266 315.835C38.6381 312.657 33.1115 303.952 32.697 298.84C32.4207 294.142 32.9733 277.701 32.9733 277.701L80.917 271.069L116.426 250.344H166.995Z",
    fill: "#49E0B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.029 324.401V375.523C178.601 379.806 167.271 382.845 151.796 377.181V324.401H187.029Z",
    fill: "#49E0B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.529 144.37L298.391 144.508C298.391 144.37 298.391 144.37 298.529 144.37Z",
    fill: "#006986"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.691 354.659L39.8812 290.274C30.7622 285.023 30.7622 271.898 39.8812 266.647L288.58 121.987C298.805 116.046 311.378 116.046 321.602 121.987L432.411 186.373C441.53 191.623 441.53 204.749 432.411 209.999L183.712 354.659C173.488 360.6 160.915 360.6 150.691 354.659Z",
    fill: "#097A57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.655 192.452C433.655 192.314 433.655 192.176 433.517 192.038C433.379 191.485 433.241 190.933 432.965 190.518C432.826 190.242 432.826 190.104 432.688 189.827C432.55 189.551 432.412 189.413 432.274 189.274C432.135 188.998 431.859 188.722 431.721 188.584C431.583 188.445 431.445 188.307 431.306 188.169C431.03 188.031 430.892 187.755 430.616 187.617C430.339 187.478 430.063 187.202 429.787 187.064L418.595 180.57L364.296 148.93L345.643 138.153L319.392 122.955C314.971 120.468 310.549 120.053 305.575 120.053C300.601 120.053 295.765 120.882 291.344 123.369L221.57 164.128L67.653 253.66L43.4739 267.753C40.5724 269.411 38.0854 272.036 38.0854 275.49C38.0854 278.944 39.8816 281.984 42.7831 283.642L48.7242 287.096L87.9635 309.894L121.676 329.513L153.178 347.889C153.454 348.027 153.731 348.166 154.007 348.304C154.56 348.58 155.112 348.856 155.527 349.133C156.079 349.409 156.632 349.547 157.185 349.824C157.737 349.962 158.29 350.238 158.705 350.376C158.843 350.376 158.981 350.514 159.119 350.514C160.501 350.929 161.882 351.205 163.264 351.482C164.646 351.62 166.027 351.758 167.547 351.758C168.376 351.758 169.067 351.758 169.896 351.62C170.311 351.62 170.587 351.482 171.001 351.482C171.416 351.343 171.692 351.343 172.107 351.343C172.659 351.205 173.212 351.067 173.903 350.929C174.179 350.791 174.456 350.791 174.732 350.653C175.285 350.514 175.837 350.238 176.39 350.1C177.495 349.685 178.6 349.133 179.706 348.58C180.258 348.304 180.811 348.027 181.364 347.751L262.329 300.636L281.258 289.721L338.044 256.7L416.108 211.243L429.096 203.644C429.787 203.229 430.478 202.677 431.03 202.124C431.307 201.848 431.445 201.709 431.583 201.433C431.721 201.157 431.997 201.019 432.136 200.742C432.412 200.328 432.55 200.051 432.688 199.637C432.826 199.222 432.965 198.946 433.103 198.532C433.379 197.841 433.517 197.012 433.655 196.321C433.655 196.045 433.655 195.768 433.655 195.492C433.932 194.11 433.793 193.281 433.655 192.452ZM382.396 217.737L228.755 307.268L169.896 341.534L141.986 325.23L101.78 301.88L170.863 261.674L249.618 215.802L332.932 167.306L372.448 190.242L401.048 206.822L382.396 217.737Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.931 194.939C433.931 195.216 433.931 195.492 433.931 195.768C433.793 196.597 433.655 197.288 433.378 197.979C433.24 198.393 433.102 198.67 432.964 199.084C432.826 199.499 432.549 199.775 432.411 200.19C432.273 200.466 431.997 200.742 431.859 200.88C431.72 201.157 431.444 201.295 431.306 201.571C430.753 202.124 430.062 202.677 429.372 203.091L416.384 210.69L338.32 256.147L281.672 289.169H281.534L262.743 300.084L224.886 322.052L181.363 347.337C180.811 347.613 180.258 347.889 179.705 348.166C178.6 348.718 177.495 349.271 176.389 349.685C175.837 349.962 175.284 350.1 174.731 350.238C174.455 350.376 174.179 350.376 173.902 350.514C173.35 350.653 172.797 350.791 172.106 350.929C171.692 351.067 171.415 351.067 171.001 351.067C170.586 351.067 170.31 351.205 169.895 351.205C169.066 351.343 168.376 351.343 167.547 351.343C166.165 351.343 164.783 351.205 163.263 351.067C161.744 350.929 160.5 350.514 159.118 350.1C158.98 350.1 158.842 349.962 158.704 349.962C158.151 349.824 157.599 349.547 157.184 349.409C156.631 349.133 156.079 348.995 155.526 348.718C154.974 348.442 154.421 348.166 154.006 347.889C153.73 347.751 153.454 347.613 153.177 347.475L121.675 329.099L87.9629 309.479L170.586 261.397L249.341 215.526L332.655 167.03L364.157 148.93L418.456 180.57L429.648 187.064C429.924 187.202 430.201 187.34 430.477 187.616C430.753 187.755 430.891 188.031 431.168 188.169C431.306 188.307 431.444 188.445 431.582 188.584C431.72 188.86 431.997 188.998 432.135 189.274C432.273 189.413 432.411 189.689 432.549 189.827C432.688 189.965 432.826 190.242 432.826 190.518C433.102 190.932 433.24 191.485 433.378 192.038C433.378 192.176 433.378 192.314 433.517 192.452C433.793 193.281 433.931 194.11 433.931 194.939Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.565 338.494C238.979 338.494 239.394 338.356 239.67 338.218L283.469 312.934C284.85 312.105 285.679 310.723 285.679 309.203V308.374C285.679 307.131 284.712 306.163 283.469 306.163C283.054 306.163 282.64 306.302 282.363 306.44L238.565 331.724C237.183 332.553 236.354 333.935 236.354 335.455V336.284C236.216 337.527 237.321 338.494 238.565 338.494Z",
    fill: "#097A57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.31 249.1C395.245 250.205 395.245 249.376 395.659 249.1L414.035 237.217C415.555 236.25 416.522 234.592 416.66 232.796V231.829C416.66 230.309 415.417 229.204 414.035 229.204C413.621 229.204 413.068 229.342 412.653 229.618L393.31 240.81C391.79 241.777 390.823 243.435 390.685 245.231V246.198C390.685 247.442 391.652 247.994 393.31 249.1Z",
    fill: "#097A57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.86 273.417C353.794 274.522 353.794 273.693 354.209 273.417L372.585 261.535C374.105 260.567 375.072 258.909 375.21 257.113V256.146C375.21 254.626 373.967 253.521 372.585 253.521C372.17 253.521 371.618 253.659 371.203 253.935L351.86 265.127C350.34 266.094 349.373 267.752 349.235 269.548V270.515C349.373 271.897 350.34 272.45 351.86 273.417Z",
    fill: "#097A57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.885 294.142C103.99 293.451 105.234 293.037 106.615 292.898C107.997 292.76 109.379 293.037 110.484 293.589L127.755 303.675C128.998 304.366 129.413 305.333 128.998 306.301C128.722 306.853 128.169 307.544 127.34 307.959L119.603 312.656C117.392 314.038 114.076 314.314 112.004 313.209L94.7329 303.123C92.7986 302.017 92.9368 300.083 95.1474 298.701L102.885 294.142Z",
    fill: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2858 301.189L103.023 296.491C104.128 295.8 105.372 295.386 106.754 295.248C108.135 295.109 109.517 295.386 110.622 295.938L127.893 306.025C128.308 306.301 128.584 306.577 128.86 306.854C128.998 306.715 128.998 306.577 129.137 306.439C129.551 305.472 129.137 304.367 127.893 303.814L110.622 293.728C109.655 293.175 108.273 292.899 106.754 293.037C105.372 293.175 104.128 293.59 103.023 294.28L95.2858 298.978C93.4896 300.083 93.0752 301.465 93.9041 302.57C94.1805 302.018 94.595 301.603 95.2858 301.189Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.709 194.662L366.229 197.149L367.611 182.089L366.091 180.984L334.727 163.022L364.709 194.662Z",
    fill: "#666360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.676 181.813L367.611 182.089L360.288 157.219L311.377 128.481L365.676 181.813Z",
    fill: "#666360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.688 175.595L364.709 194.662L365.676 181.813L333.069 161.917L331.688 175.595Z",
    fill: "#BBB8B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.24 169.792L333.069 161.917L365.676 181.813L365.261 188.859L332.24 169.792Z",
    fill: "#9C9A99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.37 192.452V193.281C307.37 195.63 308.614 197.84 310.686 198.946L328.786 209.17C333.898 212.072 340.254 212.072 345.366 209.17L351.169 205.854L366.367 197.011L364.847 194.524L363.604 194.386L307.37 192.452Z",
    fill: "#8D8A88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.03 203.505V205.854L366.229 197.011L364.709 194.524L363.465 194.386C358.768 197.978 351.03 203.505 351.03 203.505Z",
    fill: "#666360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.028 195.491L329.891 207.512C334.312 209.999 339.701 209.999 344.122 207.512L364.847 194.662L331.825 175.595L309.166 189.55C306.817 190.932 306.817 194.11 309.028 195.491Z",
    fill: "#E7E5E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.871 184.438L351.03 203.505L364.709 194.662L331.687 175.595L317.871 184.438Z",
    fill: "#CECCCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.069 161.917L365.676 181.813L359.044 159.845L310.133 131.244L333.069 161.917Z",
    fill: "#7C776A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.112 2.05902L411.685 69.2078C416.935 72.2475 420.528 81.0901 419.975 89.2419L412.79 186.096C412.238 195.077 410.58 195.63 405.882 197.979C401.461 200.189 403.671 199.499 403.671 199.499L293.277 130.83C288.026 127.79 284.434 118.948 284.987 110.796L288.303 1.50635C288.303 1.50635 292.724 0.53919 294.244 0.815523C295.073 0.815523 296.316 1.09186 298.112 2.05902Z",
    fill: "url(#paint0_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.948 197.979C408.646 195.768 410.304 195.077 410.856 186.096L418.594 89.2417C419.284 81.2281 415.554 72.2473 410.304 69.2076L296.04 2.05881C294.52 1.22981 293.415 0.95348 292.586 0.815313C293.277 0.815313 293.829 0.677147 294.106 0.815313C294.935 0.95348 296.04 1.09165 297.836 2.05881L411.409 69.2076C416.659 72.2473 420.252 81.0899 419.699 89.2417L412.514 186.096C411.962 195.077 410.304 195.63 405.606 197.979C401.185 200.189 403.395 199.498 403.395 199.498L402.566 198.946C404.224 198.117 400.908 199.36 403.948 197.979Z",
    fill: "url(#paint1_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.053 131.935L398.145 198.808C403.395 201.847 408.093 197.702 408.646 189.689L409.336 181.122L416.383 89.1037C417.074 81.0901 413.343 72.1093 408.093 69.0696L393.171 60.5033L305.435 9.38184L293 2.19719C292.033 1.64453 291.066 1.3682 290.099 1.23003C286.092 0.815532 282.914 4.82236 282.362 11.3162L281.947 17.3955L276.973 82.0573L274.763 111.763C274.21 120.053 277.802 128.896 283.053 131.935Z",
    fill: "#6A6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.77 100.157L405.33 173.661L405.468 172.28L411.824 87.9984C412.376 80.952 408.784 74.32 402.705 70.7276L291.343 6.06586C289.685 5.09869 287.75 5.51319 286.645 6.75669C286.092 7.30935 285.678 8.13835 285.54 9.10551L278.77 100.157Z",
    fill: "#249572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.224 80.5372L397.73 76.5304L298.251 19.0532L292.033 101.677L397.869 162.746L404.224 80.5372Z",
    fill: "#EBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.77 100.157L405.33 173.661L405.468 172.279L279.737 99.1895L286.783 6.61816C286.23 7.17083 285.816 7.99983 285.678 8.96699L278.77 100.157Z",
    fill: "#484949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.053 131.935L283.882 132.349L306.126 145.199L318.838 152.522L357.8 175.457L368.025 181.26L390.822 194.386L398.283 198.669C403.533 201.709 408.231 197.564 408.922 189.55L409.613 181.675L386.953 168.549L363.051 154.732L354.07 149.482L314.002 125.856L302.396 119.224L279.046 105.683L275.73 103.749L275.039 111.624C274.21 120.053 277.802 128.895 283.053 131.935Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.288 154.871L364.709 177.944L384.467 189.412L381.013 166.891L360.288 154.871Z",
    fill: "#E6E1E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.987 111.072L289.408 134.146L308.751 145.199L305.297 122.816L284.987 111.072Z",
    fill: "#E6E1E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.137 121.296L356.697 124.06L358.217 124.889L365.401 129.034L369.822 131.521L373.967 133.869L374.796 134.422L386.126 140.916L386.955 141.469L387.231 137.185L388.751 113.283L383.363 110.105L381.152 108.861L371.204 103.196L367.474 100.986L362.638 98.2225L355.039 93.8012L353.933 93.1104L353.381 102.506L352.137 121.296Z",
    fill: "#097A57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.262 122.263L366.368 107.203L377.006 120.605L365.262 122.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.891 69.4843L309.029 66.5828L347.992 88.5512L347.854 92.1435L308.891 69.4843Z",
    fill: "#BCE7F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.338 77.6359L308.476 74.7344L347.439 96.7028L347.301 100.295L308.338 77.6359Z",
    fill: "#A2D7E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.786 85.9256L308.062 82.886L347.025 104.854L346.749 108.447L307.786 85.9256Z",
    fill: "#A2D7E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.095 94.7684L307.371 91.7288L346.334 113.697L346.196 117.29L307.095 94.7684Z",
    fill: "#A2D7E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.159 198.254C284.159 198.254 284.159 201.018 281.948 202.261C279.738 203.505 275.869 206.544 275.869 206.544C275.869 206.544 274.626 208.755 274.902 210.275C275.178 211.657 277.251 212.624 277.251 212.624C277.251 212.624 280.981 212.624 282.916 210.828C284.85 209.031 286.646 207.788 286.646 207.788C286.646 207.788 291.067 206.406 291.344 205.577C291.62 204.748 291.62 201.294 291.62 201.294L287.475 198.531L284.159 198.254Z",
    fill: "#00010F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.568 204.886C301.568 204.886 302.397 206.959 301.43 209.722C300.463 212.624 299.634 215.111 297.423 217.736C295.35 220.361 294.383 221.605 290.929 221.466C287.475 221.328 286.231 219.947 286.37 217.874C286.508 215.802 289.824 212.9 290.376 211.657C290.929 210.413 293.002 206.406 293.002 206.406L295.765 204.748L301.568 204.886Z",
    fill: "#00010F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.481 154.18C270.481 154.18 270.342 151.278 270.342 150.311C270.342 149.344 270.619 147.824 270.204 146.58C269.79 145.337 269.099 144.508 269.375 142.85C269.513 142.297 270.066 140.777 270.757 138.981C269.237 138.152 267.717 137.185 266.336 136.08C265.783 139.81 265.368 143.126 265.23 143.955C264.816 145.475 263.71 149.896 263.71 150.173C263.71 150.449 264.954 154.732 265.368 155.285C265.783 155.699 267.855 156.943 267.855 156.943H269.513L269.652 156.528L270.342 156.667L270.619 155.976L270.481 155.285V154.18Z",
    fill: "#F9C8A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.441 149.896C267.441 149.896 267.165 150.863 267.026 151.692C266.888 152.521 266.888 153.074 266.888 153.074L267.579 154.594C267.579 154.594 268.408 155.285 268.684 155.423C268.961 155.561 269.79 156.114 269.79 156.114C269.79 156.114 268.823 155.008 268.823 154.318C268.823 153.627 268.823 153.074 268.823 153.074C268.823 153.074 268.823 151.278 268.684 151.002C268.546 150.725 268.546 150.449 268.546 150.449L267.441 149.896Z",
    fill: "#DEA583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.685 144.508C268.546 144.093 268.546 143.541 268.546 143.126C268.546 142.712 268.408 142.159 268.132 141.883L267.994 141.745H267.856C267.579 141.883 267.441 142.159 267.303 142.435C267.165 143.126 267.303 143.817 267.441 144.508C267.579 145.199 267.579 145.89 267.165 146.442C266.888 146.857 266.612 146.995 266.198 147.271C266.059 147.409 265.921 147.548 265.783 147.686C265.645 147.824 265.645 148.1 265.507 148.238C265.369 148.653 265.23 149.067 265.23 149.482C265.23 149.758 265.092 149.896 265.092 150.173C265.092 150.449 265.092 150.725 265.23 150.864C265.507 152.107 265.783 153.212 266.198 154.456C266.198 154.594 266.336 154.732 266.336 154.732C266.474 154.87 266.612 154.87 266.612 154.87C266.888 154.732 266.75 154.456 266.75 154.18C266.474 153.351 266.336 152.383 266.336 151.554C266.336 150.449 266.612 149.344 267.441 148.653C267.717 148.515 267.994 148.377 268.132 148.515C268.27 148.653 268.408 148.929 268.408 149.206C268.408 149.482 268.685 149.758 268.823 149.896C268.961 150.173 268.961 150.449 269.099 150.725C269.237 151.416 269.375 152.107 269.514 152.798C269.514 152.936 269.514 153.074 269.652 153.212C269.79 153.351 269.928 153.351 270.066 153.351C270.204 153.351 270.343 153.074 270.343 152.936C270.619 151.831 270.343 150.725 270.343 149.482C270.343 148.929 270.481 148.377 270.343 147.962C270.204 147.548 270.343 146.995 270.204 146.58C269.514 146.028 268.823 145.475 268.685 144.508Z",
    fill: "#FAD0B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.159 196.873C284.159 196.873 284.159 199.636 281.948 200.88C279.738 202.123 275.869 205.163 275.869 205.163C275.869 205.163 274.626 207.373 274.902 208.893C275.178 210.275 277.251 211.242 277.251 211.242C277.251 211.242 280.981 211.242 282.916 209.446C284.85 207.65 286.646 206.406 286.646 206.406C286.646 206.406 291.067 205.025 291.344 204.196C291.62 203.367 291.62 199.912 291.62 199.912L287.475 197.149L284.159 196.873Z",
    fill: "#313D3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.568 203.505C301.568 203.505 302.397 205.577 301.43 208.34C300.463 211.242 299.634 213.729 297.423 216.354C295.35 218.979 294.383 220.223 290.929 220.085C287.475 219.946 286.231 218.565 286.37 216.492C286.508 214.42 289.824 211.518 290.376 210.275C290.929 209.031 293.002 205.024 293.002 205.024L295.765 203.366L301.568 203.505Z",
    fill: "#313D3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.659 185.267C294.107 189.965 291.758 200.051 291.758 200.051C291.758 200.051 290.376 200.604 288.58 200.88C287.613 201.018 286.646 201.018 285.679 200.88C282.915 200.327 281.257 199.222 281.257 199.222C281.257 199.222 281.257 199.222 280.981 198.393C280.705 197.564 279.876 187.754 279.461 184.162C279.047 180.57 278.494 178.221 277.941 176.287C277.389 174.352 274.902 161.503 274.487 156.667C274.073 151.831 274.625 137.462 274.625 137.462C274.625 137.462 282.501 137.047 286.922 138.015C290.1 138.705 292.587 161.088 293.83 174.076C294.245 178.083 294.521 181.122 294.659 182.504C294.659 182.78 294.659 183.057 294.798 183.195C294.798 183.471 294.798 184.162 294.659 185.267Z",
    fill: "#0D1629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.66 182.366C294.66 183.333 294.66 184.3 294.66 185.267C294.107 189.965 291.758 200.051 291.758 200.051C291.758 200.051 290.376 200.604 288.58 200.88C288.58 200.189 288.58 199.36 288.442 198.807C288.304 197.978 286.922 195.215 287.06 193.833C287.199 192.452 285.955 185.543 285.955 184.991C285.955 184.438 285.955 179.188 285.541 178.497C285.126 177.806 285.955 176.01 285.955 175.457C285.955 174.905 285.126 166.062 284.297 163.851C283.468 161.641 284.021 153.351 284.021 153.351C290.791 152.107 291.482 159.43 293.969 174.076C294.383 176.977 294.521 179.74 294.66 182.366Z",
    fill: "#000918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.891 155.837C309.029 160.811 306.68 169.93 305.575 178.497C304.469 186.925 303.226 202.676 303.226 202.676C303.226 202.676 303.502 205.715 298.114 206.406C296.041 206.683 294.66 206.544 293.692 206.268C292.034 205.854 291.62 205.163 291.62 205.163C291.62 205.163 291.62 201.709 291.344 197.011C291.206 192.313 290.515 185.681 290.653 181.675C290.791 177.806 289.686 166.476 288.995 162.608C288.58 160.121 287.751 159.568 286.784 158.739C286.231 158.324 285.679 157.91 284.988 156.943C283.192 154.456 282.916 145.337 282.916 145.337L307.785 140.501C307.924 140.501 308.753 150.863 308.891 155.837Z",
    fill: "#121D36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.14 199.498C293.278 201.571 293.554 204.472 293.831 206.268C292.173 205.854 291.758 205.163 291.758 205.163C291.758 205.163 291.758 201.709 291.482 197.011C291.344 192.313 290.653 185.681 290.791 181.675C290.929 177.806 289.824 166.476 289.133 162.608C288.719 160.121 287.89 159.568 286.922 158.739C286.922 158.739 290.791 160.121 291.896 166.753C293.002 173.385 292.587 182.089 292.864 183.471C293.278 184.714 293.002 196.182 293.14 199.498Z",
    fill: "#030F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.935 146.166L283.468 151.831H283.606L289.686 155.423L291.62 156.529C291.482 153.489 291.205 150.587 290.791 147.824C290.515 145.89 290.376 144.094 290.1 142.574C289.409 138.843 288.58 136.218 287.613 135.942C284.297 135.113 279.047 134.836 276.56 134.698C275.593 134.698 275.04 134.698 275.04 134.698C275.04 134.698 274.902 135.804 274.764 137.462C274.487 139.672 274.211 142.988 273.935 146.166Z",
    fill: "#0D1629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.468 151.831L289.685 155.423C288.58 152.384 286.784 151.14 283.606 151.417C283.606 151.555 283.468 151.555 283.468 151.831Z",
    fill: "#74747F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.191 145.061C283.191 146.719 283.191 149.206 283.606 151.417C283.606 151.555 283.606 151.693 283.606 151.831L289.685 155.423L291.62 156.529L307.232 165.648C308.199 161.641 308.89 158.049 309.028 155.562C309.167 153.075 309.167 149.344 309.028 146.166C309.028 142.712 309.028 139.949 309.028 139.949L290.238 142.574L283.33 143.541C283.191 143.403 283.191 144.094 283.191 145.061Z",
    fill: "#121D36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.546 142.298C268.684 141.469 269.651 139.12 270.757 136.633C272.138 133.593 273.658 130.277 273.934 129.448C274.349 128.481 276.007 124.474 277.389 121.02C278.218 118.809 279.047 116.737 279.185 116.046C279.323 115.217 280.014 113.421 280.705 111.348C281.672 108.309 282.639 104.993 281.948 104.302C281.672 104.026 280.981 103.887 280.014 103.749C279.599 103.749 279.047 103.749 278.494 103.749C277.665 103.749 276.836 103.749 276.007 103.887C273.658 104.026 271.586 104.302 271.586 104.302C271.586 104.302 271.447 106.098 271.033 108.171C270.757 109.829 270.48 111.625 270.066 112.592C269.651 113.559 268.96 115.355 268.27 117.29C267.579 119.362 266.888 121.711 266.75 124.06C266.473 127.652 265.368 135.942 264.677 140.363L266.473 141.469L267.579 142.159L268.546 142.712C268.408 142.712 268.408 142.574 268.546 142.298Z",
    fill: "#F9C8A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.185 116.046C278.77 118.119 274.487 127.929 273.934 129.448C273.658 130.277 272.138 133.593 270.757 136.633C271.033 134.837 271.171 133.041 271.447 131.106C271.586 130.001 271.724 128.896 271.586 127.929C271.447 126.547 270.895 125.027 270.757 123.645C270.618 122.402 270.757 121.02 270.204 119.777C269.789 118.81 269.099 118.119 268.27 117.428C268.96 115.355 269.651 113.697 270.066 112.73C270.895 110.658 271.586 104.44 271.586 104.44C271.586 104.44 280.843 103.197 281.948 104.44C283.053 105.546 279.461 114.112 279.185 116.046Z",
    fill: "#DCAC8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.704 107.342C280.704 107.342 276.559 124.75 275.869 126.961C273.934 132.626 272.553 135.804 269.928 143.817L268.684 142.988L264.401 140.501C264.401 131.659 268.546 114.664 268.546 114.664C268.546 114.664 270.48 108.999 270.48 97.9462C270.48 92.2814 274.625 88.8272 274.625 88.8272C275.316 88.5509 276.698 92.5577 278.079 96.8409C279.461 101.815 280.704 107.342 280.704 107.342Z",
    fill: "#14234D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.822 118.809C268.408 120.329 267.855 121.711 267.717 123.369C267.579 125.165 267.303 126.823 266.888 128.481C266.197 131.797 265.368 135.251 265.506 138.705C265.506 138.982 265.506 139.258 265.645 139.396C265.783 139.673 265.921 139.811 266.059 140.087C266.474 140.64 266.888 141.192 267.441 141.745C268.408 137.876 269.513 134.146 270.48 130.277C270.757 129.034 271.171 127.79 271.448 126.685C272.277 123.507 273.106 120.329 273.658 117.013C274.211 113.835 274.073 110.52 274.625 107.342C275.178 104.164 275.869 100.848 274.902 97.5319C274.487 96.0121 273.796 94.4922 272.967 93.1106C272.829 92.9724 272.691 92.8342 272.553 92.8342C272.415 92.8342 272.415 92.9724 272.415 92.9724C271.309 95.3212 271.586 98.3609 271.309 100.848C271.033 103.611 271.033 106.375 270.757 109.138C270.342 112.592 269.513 115.632 268.822 118.809Z",
    fill: "#192B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.704 107.342C280.704 107.342 276.559 124.751 275.868 126.961C273.934 132.626 272.552 135.804 269.927 143.818L268.684 142.989C268.96 142.16 269.236 141.469 269.374 140.64C269.927 138.015 270.618 135.251 271.447 132.626C271.861 131.244 272.276 130.001 272.69 128.619C273.105 127.376 273.796 126.132 273.934 124.889C274.487 120.606 275.177 116.599 275.454 112.177C275.592 109.69 276.145 106.651 275.592 104.164C275.316 102.782 275.039 101.539 274.763 100.157C274.625 99.4661 274.072 96.7028 274.625 96.1502C275.454 95.5975 276.559 95.7357 277.526 96.2883C277.803 96.4265 277.941 96.5647 278.217 96.841C279.461 101.815 280.704 107.342 280.704 107.342Z",
    fill: "#132236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.935 135.389C273.935 135.389 274.073 138.429 277.112 141.607C278.08 142.574 279.185 143.541 280.705 144.646C281.534 145.199 285.679 148.377 286.37 147.824C286.922 147.271 287.613 146.857 288.442 146.442C288.58 146.857 288.58 147.133 288.718 147.548C288.857 147.824 288.857 148.239 288.995 148.515C289.962 150.035 293.554 150.173 295.212 150.449C297.423 150.726 299.633 150.726 301.982 150.726C304.193 150.726 306.265 149.62 308.2 148.515C308.891 148.1 309.443 147.824 310.134 147.41C310.41 147.271 310.549 147.133 310.825 146.995C311.239 146.581 311.239 145.752 311.239 145.199C311.239 138.981 311.516 132.626 311.93 126.408C312.207 121.987 312.483 117.566 314.003 113.421C314.141 113.006 314.279 112.592 314.417 112.039C315.937 107.203 317.042 101.4 317.042 101.4L318.424 90.2088C318.424 90.2088 316.352 88.2745 313.174 87.4455C309.858 86.4783 304.746 83.8532 302.949 83.3005C301.982 83.0242 298.528 82.886 295.489 82.886C292.725 82.886 290.238 82.886 290.238 82.886C290.238 82.886 284.712 84.8203 281.534 85.9256C280.705 86.202 279.738 86.6165 278.909 87.031C276.836 87.9981 275.178 88.9653 275.178 88.9653C275.178 88.9653 274.073 91.7286 274.625 96.2881C274.764 97.9461 275.04 99.7423 275.731 101.677C278.08 109.138 279.047 110.796 279.047 114.112C279.047 117.428 276.145 130.692 275.454 133.04C274.211 135.113 273.935 135.389 273.935 135.389Z",
    fill: "#20305B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.804 150.588C296.732 150.588 294.659 150.312 292.725 149.759C291.344 149.344 290.1 148.654 289.409 147.41C288.857 146.167 289.271 144.232 289.409 142.851C289.686 139.12 290.1 135.39 290.653 131.797C290.791 130.968 290.929 130.139 291.205 129.31C292.034 126.961 293.83 124.613 295.212 122.54C296.732 120.329 298.39 118.257 299.91 116.046C302.12 112.869 304.607 109.829 306.542 106.513C307.233 105.269 307.923 104.026 308.062 102.644C308.2 101.263 307.647 99.7427 306.404 98.9137C308.2 98.3611 309.996 97.3939 311.516 96.2886C312.345 97.8084 311.93 99.6046 311.654 101.263C310.272 107.342 309.443 113.559 309.029 119.777C308.891 122.678 309.029 125.442 308.752 128.205C308.476 131.106 308.062 134.146 308.2 137.186C308.2 139.811 308.2 142.436 307.923 145.061C307.923 145.752 308.062 147.134 307.647 147.825C306.818 149.483 303.64 150.312 301.844 150.45C301.015 150.45 299.91 150.588 298.804 150.588Z",
    fill: "#283D73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.167 135.804C309.167 138.014 309.029 140.225 308.891 142.436C308.752 144.646 309.029 146.719 308.2 148.93C309.029 148.377 309.858 147.962 310.825 147.548C310.963 147.41 311.239 147.41 311.378 147.133C311.516 146.995 311.516 146.719 311.516 146.581C311.654 141.745 310.963 136.909 311.239 132.073C311.792 123.507 311.792 118.395 313.588 113.421C313.726 113.006 313.865 112.592 314.003 112.039C313.726 110.934 313.45 109.967 313.174 108.861C312.759 107.065 313.312 105.269 313.726 103.611C313.588 104.302 312.207 105.545 311.792 106.374C310.272 110.519 310.549 115.908 310.134 120.329C309.72 125.441 309.305 130.692 309.167 135.804Z",
    fill: "#132236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.54 91.8669C285.955 94.4921 289.271 104.716 291.205 110.381C292.034 112.73 292.587 114.388 292.587 114.388C292.587 114.388 292.587 114.388 295.212 111.901C295.627 111.21 296.041 110.519 296.317 109.69C299.081 103.473 302.259 92.2814 302.259 92.2814L300.462 93.5249L293.278 95.1829L287.06 92.1433C286.922 91.8669 284.988 88.1364 285.54 91.8669Z",
    fill: "#D4DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.205 110.381C292.034 112.73 292.587 114.388 292.587 114.388C292.587 114.388 292.587 114.388 295.212 111.901C295.626 111.21 296.041 110.519 296.317 109.69C295.765 105.683 294.659 98.9133 294.659 98.9133H292.449L291.205 110.381Z",
    fill: "#B31100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.087 82.748C303.087 82.748 309.167 86.893 309.305 87.0312C309.581 87.1694 310.41 92.0052 310.41 92.0052L308.752 97.1173L304.331 97.9463L307.647 101.953L291.205 126.823L292.587 114.388C292.587 114.388 294.383 112.592 296.317 107.894C297.699 104.44 302.258 92.1434 302.258 92.1434L303.087 82.748Z",
    fill: "#405787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.109 113.283C336.938 113.145 337.905 113.007 339.149 112.592C342.741 111.487 346.886 108.862 346.886 108.862C346.886 108.862 348.959 106.927 349.511 106.236C350.064 105.546 352.136 103.888 354.071 102.92C354.209 102.92 354.209 102.782 354.347 102.782C356.143 101.815 356.696 101.401 358.077 100.71C359.459 100.157 360.703 98.9136 360.979 98.7754C361.255 98.7754 362.084 98.9136 362.084 99.8807C362.084 100.848 361.532 101.401 361.532 101.401C361.532 101.401 363.19 101.815 363.328 102.091C363.466 102.23 363.604 103.197 363.328 103.611C363.051 104.026 361.67 104.578 361.67 104.578C361.67 104.578 361.808 105.684 361.67 106.098C361.532 106.513 360.703 106.513 360.703 106.513C360.703 106.513 360.979 107.342 360.841 107.756C360.703 108.309 360.15 109.276 360.15 109.276C360.15 109.276 360.288 109.138 360.012 110.243C359.874 110.658 359.874 110.934 359.874 111.21C359.874 111.349 359.874 111.349 359.735 111.487C359.597 111.625 359.459 111.763 359.045 112.039C357.939 112.592 355.176 113.697 353.932 113.836C352.689 113.974 352.274 113.283 350.616 114.388C348.958 115.494 340.807 121.849 337.767 122.816C335.833 123.369 334.589 123.783 333.346 123.922C335.004 120.606 335.971 117.013 336.109 113.283Z",
    fill: "#F9C8A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.313 121.849C334.866 121.711 335.418 121.711 335.971 121.573C338.043 121.435 340.53 121.435 343.017 119.362C345.642 117.29 347.715 114.388 347.853 113.974C347.991 113.559 348.82 111.901 348.82 111.763C348.82 111.625 349.235 110.796 349.235 110.796C349.235 110.796 349.787 113.145 350.478 113.145C351.169 113.145 353.656 113.421 354.347 113.283C355.038 113.145 359.321 112.039 359.321 111.625C359.321 111.487 359.597 111.349 359.874 111.072C359.874 111.21 359.874 111.21 359.735 111.349C359.597 111.487 359.459 111.625 359.045 111.901C357.939 112.454 355.176 113.559 353.932 113.697C352.689 113.836 352.274 113.145 350.616 114.25C348.958 115.355 340.807 121.711 337.767 122.678C335.833 123.231 334.589 123.645 333.346 123.784C333.76 123.231 334.037 122.54 334.313 121.849Z",
    fill: "#DCAC8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.93 106.789C311.93 110.105 313.45 111.072 313.45 111.072C313.45 111.072 313.588 111.349 314.141 111.487C314.279 111.487 314.555 111.487 314.832 111.487C315.384 111.487 315.937 111.21 316.904 110.934C318.009 110.52 319.529 109.829 321.878 108.723C326.023 106.789 326.576 105.822 326.714 105.684C326.714 105.684 323.536 98.361 321.878 95.1831C320.22 92.0053 317.595 89.6565 317.595 89.6565C315.661 91.8672 314.555 96.1503 312.621 102.644C312.207 104.44 311.93 105.684 311.93 106.789Z",
    fill: "#283D73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.769 101.677C358.769 101.677 357.663 101.815 357.525 102.506C357.387 103.058 357.663 103.749 357.663 103.749C357.663 103.749 356.558 104.302 356.282 104.578C356.005 104.855 355.591 105.131 355.591 105.684C355.453 106.236 355.591 106.513 355.591 106.513C355.591 106.513 354.624 107.48 354.347 107.756C354.209 108.032 354.347 108.309 354.347 108.447C354.347 108.585 353.656 109.414 354.071 109.967C354.485 110.381 355.591 110.658 355.591 110.658C355.591 110.658 356.834 110.934 356.972 111.072C357.111 111.21 358.216 111.763 358.216 111.763C358.216 111.763 358.354 110.519 357.94 110.243C357.525 110.105 356.696 109.69 356.42 109.829C356.143 109.967 355.591 110.243 355.591 110.243C355.591 110.243 355.314 109.414 355.314 109.138C355.314 108.861 355.591 108.585 355.591 108.585C355.591 108.585 355.314 107.618 355.314 107.48C355.314 107.342 356.005 106.513 356.005 106.513C356.005 106.513 355.867 105.684 356.282 105.269C356.696 104.855 357.387 104.302 358.354 103.887C359.321 103.473 360.288 103.473 360.288 103.473C360.288 103.473 359.045 103.473 358.907 103.197C358.63 102.92 358.354 102.091 358.769 101.677Z",
    fill: "#DCAC8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.085 104.44C362.085 104.44 362.223 103.611 361.808 103.335C361.394 103.059 361.117 103.059 360.288 103.059C359.459 103.197 359.459 103.197 359.459 103.197L360.288 103.335C360.288 103.335 361.256 103.335 361.394 103.473C361.532 103.749 361.67 104.578 361.67 104.578L362.085 104.44Z",
    fill: "#DCAC8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.841 106.513C360.841 106.513 360.564 105.822 360.288 105.684C360.012 105.684 357.663 105.822 357.248 105.822C356.696 105.822 356.143 106.098 356.143 106.098V106.374C356.143 106.374 357.387 105.822 358.768 105.96C360.15 105.96 360.841 106.513 360.841 106.513Z",
    fill: "#DCAC8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.15 109.276C360.15 109.276 359.874 108.309 359.598 108.17C359.321 108.032 356.696 107.756 356.42 107.756C356.143 107.756 355.038 108.723 355.038 108.723L356.282 108.032L359.321 108.17L360.15 109.276Z",
    fill: "#DCAC8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.711 75.0107L383.362 76.3924L360.012 101.4L361.67 101.539L369.269 92.9724L385.711 75.0107Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.109 113.283C336.938 113.144 337.906 113.006 339.149 112.592C342.741 111.486 346.886 108.861 346.886 108.861C346.886 108.861 348.959 106.927 349.512 106.236C350.064 105.545 352.137 103.887 354.071 102.92C354.209 102.92 354.209 102.782 354.347 102.782C354.071 102.92 350.893 105.131 350.34 105.96C349.788 106.789 348.13 108.861 347.854 109.276C347.577 109.69 346.61 113.421 346.334 113.283C346.196 113.144 345.09 110.934 344.538 111.072C343.985 111.348 341.498 112.454 339.84 113.283C338.596 113.835 337.353 114.112 336.248 114.112C336.109 113.835 336.109 113.559 336.109 113.283Z",
    fill: "#DCAC8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.763 132.764C275.454 130.415 278.355 117.151 278.355 113.835C278.355 110.519 277.388 109 275.039 101.4C274.349 99.4661 274.072 97.67 273.934 96.012C275.73 99.1898 277.803 102.506 278.494 104.026C279.875 107.065 281.533 113.974 280.704 117.428C280.013 120.882 276.559 132.073 276.559 132.626C276.145 135.389 276.421 138.291 276.559 141.054C276.559 140.501 274.901 139.12 274.625 138.567C274.072 137.462 273.658 136.218 273.934 135.113C274.072 134.422 274.625 133.593 274.763 132.764Z",
    fill: "#132236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.935 82.7482C294.659 84.8207 292.587 87.4458 287.613 90.6237C287.613 90.6237 282.639 89.242 281.119 87.7222C280.428 87.0313 279.323 86.8932 278.217 86.8932C279.046 86.4787 279.875 86.2023 280.842 85.7878C284.158 84.6825 289.547 82.7482 289.547 82.7482C289.547 82.7482 292.172 82.61 294.935 82.7482Z",
    fill: "#132236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.706 90.2089C301.292 91.3142 295.627 94.9066 291.758 93.9394C291.758 93.9394 291.758 93.9394 291.62 93.9394C287.89 92.9722 287.199 90.6234 286.784 89.2418C286.37 87.7219 287.613 86.2021 288.166 83.8533C288.719 81.5044 288.442 76.116 288.442 76.116C288.442 76.116 297.699 81.2281 300.739 83.4388C301.154 83.7151 301.292 83.8533 301.568 84.1296C303.226 85.5113 302.121 89.1036 301.706 90.2089Z",
    fill: "#F8C098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.91 86.8927C299.219 87.7217 298.39 88.4125 297.561 88.827C297.147 89.1033 296.732 89.2415 296.18 89.3797C295.489 89.5178 294.936 89.3797 294.245 89.1033C292.725 88.6888 291.206 88.2743 290.377 87.169C291.067 88.9652 291.482 90.7613 291.62 92.5575C291.62 92.972 291.758 93.3865 291.62 93.801C287.89 92.8338 287.199 90.485 286.784 89.1033C286.37 87.5835 287.613 86.0637 288.166 83.7149C288.719 81.366 288.442 75.9775 288.442 75.9775C288.442 75.9775 297.699 81.0897 300.739 83.3004C300.877 83.7149 301.015 84.1294 301.154 84.682C301.568 85.2347 300.325 86.6163 299.91 86.8927Z",
    fill: "#DEA583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.37 71.1417C307.232 72.7997 307.094 73.905 306.956 77.3591C306.818 80.6751 304.469 84.5438 303.64 86.2018C302.811 87.8598 302.396 88.1361 299.08 87.5834C298.528 87.4453 297.975 87.3071 297.561 87.169C295.074 86.34 293.416 84.4056 291.343 82.195C288.994 79.4316 287.06 73.3523 286.369 67.5493C285.678 61.7464 290.652 58.5685 290.652 58.5685C293.277 57.8777 297.422 58.0159 300.877 58.8449C303.916 59.6739 306.541 61.1937 307.094 63.2662C307.785 65.0624 307.647 69.4837 307.37 71.1417Z",
    fill: "#FAD0B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.074 62.9901C294.798 63.5427 294.936 64.3717 294.798 64.9244C294.66 66.7206 294.798 68.5167 294.245 70.1747C293.969 71.0037 293.554 71.6945 293.416 72.5235C293.002 74.3197 293.831 75.9777 294.107 77.7739C294.245 79.1555 294.107 80.5372 294.521 81.7807C294.798 82.7478 295.35 83.715 295.903 84.544C296.456 85.373 296.87 86.202 297.423 86.8928C294.936 86.0638 293.278 84.1295 291.205 81.9188C288.857 79.1555 286.922 73.0762 286.231 67.2732C285.541 61.4702 290.515 58.2924 290.515 58.2924C293.14 57.6016 297.285 57.7398 300.739 58.5688C300.186 59.9504 299.081 60.5031 297.285 61.4702C296.732 61.8847 295.488 62.4374 295.074 62.9901Z",
    fill: "#EBB798"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.285 64.9244C297.285 64.9244 293.001 65.3389 293.001 65.4771C293.001 65.6153 293.831 68.3786 293.554 68.9313C293.416 69.3458 291.62 71.5564 291.62 72.6618C291.62 73.7671 290.238 74.0434 290.238 74.0434C290.238 74.0434 289.685 71.9709 288.304 71.8328C286.922 71.6946 286.093 74.8724 286.093 74.8724C286.093 74.8724 285.264 73.6289 284.988 71.4183C284.712 69.2076 283.883 66.3061 284.712 63.9573C285.402 61.6085 288.442 56.7726 293.692 55.391C298.943 54.1475 303.917 56.22 305.851 58.707C307.785 61.194 308.614 63.8191 308.338 66.0298C308.062 68.3786 307.785 68.9313 307.785 68.9313C307.785 68.9313 307.233 64.9244 306.818 64.0954C306.404 63.2664 306.265 63.5428 305.298 63.9573C304.193 64.3718 300.324 64.9244 297.285 64.9244Z",
    fill: "#9A5132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.718 72.5235C288.718 72.5235 288.303 71.0036 286.507 71.5563C284.711 72.109 286.507 76.1158 287.198 77.3593C287.889 78.4646 288.994 78.6028 289.271 78.3264C289.547 78.1883 289.685 76.1158 289.685 75.7013C289.685 75.2868 289.409 73.6288 288.718 72.5235Z",
    fill: "#F9C8A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.141 111.486C314.141 111.486 319.944 117.427 323.95 121.434C327.957 125.441 329.892 125.579 333.484 125.303C337.214 125.027 348.82 116.598 348.82 116.598C348.82 116.598 348.544 116.322 347.991 115.908C347.853 115.769 347.715 115.631 347.577 115.493C346.748 114.664 346.472 114.388 345.366 112.039C344.261 109.828 345.919 108.17 346.057 108.032L333.069 112.592L326.714 105.545L316.628 110.243L314.141 111.486Z",
    fill: "#283D73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.93 106.789C311.93 110.105 313.45 111.072 313.45 111.072C313.45 111.072 313.588 111.348 314.141 111.487C314.141 111.487 319.944 117.428 323.951 121.435C327.957 125.441 329.892 125.58 333.484 125.303C337.215 125.027 348.821 116.599 348.821 116.599C348.821 116.599 348.544 116.322 347.992 115.908C344.814 117.98 342.05 120.744 338.596 122.264C336.386 123.231 334.728 124.198 332.379 124.612C331.964 124.751 331.412 124.751 330.859 124.751C330.03 124.612 329.477 124.198 328.786 123.645C326.714 122.125 324.78 120.329 322.845 118.533C320.635 116.322 318.424 113.974 317.042 111.348C317.042 111.21 316.904 111.072 316.904 110.934C316.766 110.658 316.766 110.519 316.628 110.243C314.97 106.651 314.555 102.506 314.832 98.4989C314.832 98.2226 314.832 97.8081 314.555 97.8081C313.864 100.848 312.897 103.887 311.93 106.789Z",
    fill: "#132236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.659 93.9392C294.659 93.9392 297.008 96.4262 296.732 97.3933C296.456 98.4987 293.83 100.986 293.14 100.571C292.449 100.295 290.238 97.946 290.514 97.2552C290.791 96.5643 292.034 93.2484 292.587 93.3865C293.14 93.3865 294.659 93.9392 294.659 93.9392Z",
    fill: "#C61100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.198 86.4783C287.198 86.4783 287.613 90.6233 289.547 91.8668C291.62 93.2484 293.001 93.3866 293.001 93.3866L291.067 96.7026C291.067 96.7026 288.166 95.4591 286.508 93.2484C284.85 90.8996 284.435 88.8271 284.435 88.8271L287.889 84.6821L287.198 86.4783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.489 96.8406C295.489 96.8406 298.805 96.1497 301.153 94.0772C303.502 92.0048 302.535 87.0308 302.535 87.0308C302.535 87.0308 300.601 91.1758 297.976 92.4192C295.627 93.5246 293.692 93.6627 293.692 93.6627L295.489 96.8406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.587 114.388C292.587 114.388 288.028 100.71 287.475 99.1899C286.922 97.67 285.402 91.0381 285.402 91.0381L285.817 87.1694L287.751 84.8206L288.304 83.1626L282.777 85.7878L279.461 89.3801L278.909 96.5647L283.054 98.7754L279.876 100.71L290.929 126.823L291.205 123.507L292.587 114.388Z",
    fill: "#284276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.422 132.349L307.508 131.244L307.923 134.007L297.699 135.251L297.422 132.349Z",
    fill: "#405787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.77 126.132L287.199 131.382L286.37 134.008L277.803 128.619L278.77 126.132Z",
    fill: "#284276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.675 99.8804C324.504 101.953 325.056 104.164 326.162 105.96C327.129 107.618 329.063 108.723 330.307 110.381C330.721 110.934 330.997 111.348 331.412 111.763C331.826 112.177 332.241 112.315 332.517 112.868C332.794 113.835 331.965 115.079 331.826 116.046C331.412 117.704 331.136 119.362 330.721 121.02C330.721 120.882 330.721 120.882 330.721 120.744C330.859 121.296 329.339 121.158 329.063 121.02C328.51 120.744 327.958 119.776 327.543 119.362C326.576 118.395 325.471 117.566 324.642 116.322C323.675 115.079 323.122 113.559 322.431 112.177C322.017 111.348 321.464 110.657 321.049 109.967C319.391 107.341 318.01 104.44 316.904 101.538C316.49 100.295 316.352 98.7751 315.385 97.8079C314.694 96.9789 313.45 96.5644 312.759 95.7354C312.483 95.1828 312.345 94.6301 312.207 94.0774C311.792 91.8668 310.963 89.6561 310.272 87.5836C311.378 87.3073 312.483 87.7218 313.45 88.1363C314.694 88.6889 315.937 89.3798 317.043 90.0706C318.148 90.7614 318.701 91.7286 319.53 92.6958C320.082 93.3866 320.635 94.2156 321.188 95.0446C322.293 96.4263 322.984 98.0842 323.675 99.8804Z",
    fill: "#2D4480"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.967 96.4261C272.276 95.5971 271.862 94.3536 272.138 93.2483C272.276 92.0048 273.52 91.1758 274.487 90.3468C274.763 90.0705 275.731 88.9651 276.283 88.9651C276.698 88.6888 279.047 87.7216 279.461 88.5506V88.6888C279.323 89.2415 279.323 89.7941 279.185 90.2086C278.632 92.143 277.665 95.5971 278.77 97.3933C278.908 97.6696 280.014 98.3604 280.014 98.7749C280.014 99.0513 279.599 99.0513 279.461 99.1894C279.047 99.6039 279.047 100.157 279.185 100.709C279.323 101.538 279.599 102.367 279.737 103.196C279.047 102.367 278.632 101.4 278.079 100.571C277.112 99.1894 275.869 98.0841 275.178 96.5643C275.04 96.1498 275.04 95.3208 274.487 95.0445C273.934 94.9063 272.829 96.1498 272.967 96.4261Z",
    fill: "#283D73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.817 62.852C286.093 62.1611 286.508 61.4703 286.922 60.7795C286.922 61.4703 286.922 62.2993 287.613 62.5756C288.027 61.7466 288.58 60.9176 289.133 60.2268C289.271 60.7795 289.409 61.194 289.547 61.7466C289.685 62.023 289.824 62.4375 290.1 62.1611C290.238 62.023 290.376 61.7466 290.514 61.8848C290.653 62.1611 290.791 62.5756 291.067 62.852C291.205 62.9901 291.205 63.1283 291.482 63.2665C291.758 63.2665 291.896 63.1283 292.034 62.9901C292.172 62.852 292.311 62.5756 292.449 62.4375C292.725 62.852 292.725 63.2665 292.725 63.681C293.001 63.4046 293.278 62.9901 293.692 62.852C294.107 62.7138 294.521 62.852 294.798 63.1283V63.2665C294.798 63.2665 294.798 63.4046 294.659 63.4046C293.83 64.2336 292.725 64.9245 292.034 65.8916C291.896 66.168 291.205 67.5496 291.482 67.6878C291.205 67.5496 291.343 67.1351 291.343 66.8588C291.343 66.5824 291.205 66.1679 290.929 66.1679C290.791 66.1679 290.653 66.3061 290.376 66.3061C289.962 66.3061 289.685 65.339 289.271 65.4771C289.133 65.4771 289.133 65.6153 288.995 65.6153C288.718 66.0298 288.304 66.7206 287.751 66.5825C287.06 66.4443 287.198 65.2008 286.508 65.0626C285.955 65.2008 285.679 65.8916 285.679 66.4443C285.679 66.997 285.679 67.5496 285.402 68.1023C285.54 67.8259 284.988 66.4443 284.988 66.1679C284.988 65.4771 284.988 64.6481 285.264 63.9573C285.54 63.8191 285.679 63.2665 285.817 62.852Z",
    fill: "#B36949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.393 361.291C139.084 361.291 139.913 362.258 140.051 363.225C140.189 364.331 139.775 365.16 139.084 365.021C138.393 365.021 137.564 364.054 137.426 363.087C137.15 362.12 137.564 361.291 138.393 361.291Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.419 358.528C134.11 358.528 134.939 359.495 135.077 360.462C135.216 361.567 134.801 362.396 134.11 362.258C133.419 362.258 132.59 361.291 132.452 360.324C132.314 359.219 132.729 358.39 133.419 358.528Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.584 355.626C129.275 355.626 130.104 356.594 130.242 357.561C130.38 358.666 129.966 359.495 129.275 359.357C128.584 359.357 127.755 358.39 127.617 357.423C127.479 356.455 127.893 355.626 128.584 355.626Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.748 352.725C124.438 352.725 125.267 353.692 125.406 354.659C125.544 355.764 125.129 356.593 124.438 356.455C123.748 356.455 122.919 355.488 122.78 354.521C122.642 353.554 123.057 352.725 123.748 352.725Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.912 349.962C119.602 349.962 120.431 350.929 120.57 351.896C120.708 353.001 120.293 353.83 119.602 353.692C118.912 353.692 118.083 352.725 117.944 351.758C117.806 350.652 118.221 349.962 118.912 349.962Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.076 347.06C114.767 347.06 115.596 348.027 115.734 348.994C115.872 350.1 115.458 350.929 114.767 350.791C114.076 350.791 113.247 349.823 113.109 348.856C112.832 347.889 113.247 347.06 114.076 347.06Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.102 344.297C109.793 344.297 110.622 345.264 110.76 346.231C110.898 347.336 110.484 348.165 109.793 348.027C109.102 348.027 108.273 347.06 108.135 346.093C107.997 344.988 108.411 344.159 109.102 344.297Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.571 358.39C142.262 358.39 143.091 359.357 143.229 360.324C143.368 361.429 142.953 362.258 142.262 362.12C141.571 362.12 140.742 361.153 140.604 360.186C140.328 359.08 140.742 358.251 141.571 358.39Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.598 355.488C137.288 355.488 138.117 356.455 138.256 357.422C138.394 358.528 137.979 359.357 137.288 359.219C136.598 359.219 135.769 358.251 135.63 357.284C135.492 356.317 135.907 355.488 136.598 355.488Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.761 352.586C132.452 352.586 133.281 353.553 133.419 354.521C133.557 355.626 133.143 356.455 132.452 356.317C131.761 356.317 130.932 355.35 130.794 354.382C130.656 353.415 131.07 352.586 131.761 352.586Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.926 349.823C127.617 349.823 128.446 350.79 128.584 351.757C128.722 352.863 128.307 353.692 127.617 353.553C126.926 353.553 126.097 352.586 125.959 351.619C125.82 350.514 126.235 349.685 126.926 349.823Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.09 346.922C122.78 346.922 123.609 347.889 123.748 348.856C123.886 349.961 123.471 350.79 122.78 350.652C122.09 350.652 121.261 349.685 121.122 348.718C120.846 347.751 121.261 346.922 122.09 346.922Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.116 344.158C117.807 344.158 118.636 345.126 118.774 346.093C118.912 347.198 118.498 348.027 117.807 347.889C117.116 347.889 116.287 346.922 116.149 345.955C116.011 344.849 116.425 344.02 117.116 344.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.28 341.257C112.971 341.257 113.8 342.224 113.938 343.191C114.076 344.296 113.662 345.125 112.971 344.987C112.28 344.987 111.451 344.02 111.313 343.053C111.175 342.086 111.589 341.257 112.28 341.257Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1401 321.638C70.8309 321.638 71.6599 322.605 71.7981 323.572C71.9363 324.677 71.5218 325.506 70.8309 325.368C70.1401 325.368 69.3111 324.401 69.173 323.434C69.0348 322.328 69.4493 321.499 70.1401 321.638Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3039 318.736C65.9947 318.736 66.8237 319.703 66.9619 320.67C67.1 321.776 66.6855 322.605 65.9947 322.467C65.3039 322.467 64.4749 321.499 64.3367 320.532C64.0604 319.565 64.4749 318.736 65.3039 318.736Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3296 315.834C61.0204 315.834 61.8494 316.802 61.9876 317.769C62.1257 318.874 61.7112 319.703 61.0204 319.565C60.3296 319.565 59.5006 318.598 59.3624 317.631C59.2242 316.663 59.6387 315.834 60.3296 315.834Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4936 313.071C56.1845 313.071 57.0135 314.038 57.1516 315.006C57.2898 316.111 56.8753 316.94 56.1845 316.802C55.4936 316.802 54.6646 315.835 54.5265 314.867C54.3883 313.762 54.8028 313.071 55.4936 313.071Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6582 310.17C51.349 310.17 52.178 311.137 52.3162 312.104C52.4543 313.209 52.0399 314.038 51.349 313.9C50.6582 313.9 49.8292 312.933 49.691 311.966C49.5529 310.999 49.9674 310.17 50.6582 310.17Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8221 307.406C46.5129 307.406 47.3419 308.374 47.4801 309.341C47.6182 310.446 47.2037 311.275 46.5129 311.137C45.8221 311.137 44.9931 310.17 44.8549 309.203C44.5786 308.097 45.1312 307.268 45.8221 307.406Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9865 304.505C41.6773 304.505 42.5063 305.472 42.6445 306.439C42.7827 307.545 42.3682 308.374 41.6773 308.235C40.9865 308.235 40.1575 307.268 40.0193 306.301C39.743 305.334 40.1575 304.505 40.9865 304.505Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3171 318.598C74.0079 318.598 74.8369 319.565 74.9751 320.532C75.1132 321.637 74.6987 322.466 74.0079 322.328C73.3171 322.328 72.4881 321.361 72.3499 320.394C72.0736 319.427 72.4881 318.598 73.3171 318.598Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3432 315.697C69.0341 315.697 69.8631 316.664 70.0012 317.631C70.1394 318.736 69.7249 319.565 69.0341 319.427C68.3432 319.427 67.5142 318.46 67.3761 317.493C67.2379 316.526 67.6524 315.697 68.3432 315.697Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5073 312.933C64.1981 312.933 65.0271 313.9 65.1653 314.867C65.3035 315.972 64.889 316.801 64.1981 316.663C63.5073 316.663 62.6783 315.696 62.5401 314.729C62.402 313.624 62.8165 312.795 63.5073 312.933Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6714 310.031C59.3622 310.031 60.1912 310.998 60.3294 311.966C60.4675 313.071 60.053 313.9 59.3622 313.762C58.6714 313.762 57.8424 312.795 57.7042 311.827C57.566 310.86 57.9805 310.031 58.6714 310.031Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8357 307.268C54.5266 307.268 55.3556 308.235 55.4937 309.203C55.6319 310.308 55.2174 311.137 54.5266 310.999C53.8357 310.999 53.0067 310.032 52.8686 309.064C52.5922 307.959 53.1449 307.13 53.8357 307.268Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9997 304.367C49.6905 304.367 50.5195 305.334 50.6577 306.301C50.7958 307.406 50.3813 308.235 49.6905 308.097C48.9997 308.097 48.1707 307.13 48.0325 306.163C47.7562 305.196 48.1707 304.367 48.9997 304.367Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0259 301.465C44.7167 301.465 45.5457 302.432 45.6839 303.399C45.822 304.505 45.4075 305.334 44.7167 305.196C44.0259 305.196 43.1969 304.228 43.0587 303.261C42.9205 302.294 43.335 301.465 44.0259 301.465Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.295 320.394L151.105 326.197L151.381 322.328L153.592 322.19L153.316 327.44L153.039 328.269L151.658 328.407L142.677 328.546L142.953 327.302L149.585 327.164L139.637 321.361L141.295 320.394Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0152 287.925L67.929 281.983L66.5474 282.674L76.7717 288.615L78.0152 287.925Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6074 285.852L71.5213 279.911L70.1396 280.74L80.364 286.543L81.6074 285.852Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1997 283.78L74.9754 277.839L73.7319 278.668L83.8181 284.471L85.1997 283.78Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.618 213.73V270.378L273.105 268.996L276.559 213.039C274.487 213.454 272.552 213.592 270.618 213.73Z",
    fill: "#A87647"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.506 214.006L267.855 268.858L270.48 270.516V213.868C268.96 213.868 267.164 214.006 265.506 214.006Z",
    fill: "#4D2216"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.55 241.778C232.07 243.85 232.484 246.751 230.826 249.791C230.412 250.482 229.997 251.173 229.445 252.002L268.822 229.204V219.809L230.55 241.778Z",
    fill: "#C19C68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.887 187.34V244.402L147.374 243.021L150.828 187.063C148.756 187.34 146.822 187.34 144.887 187.34Z",
    fill: "#A87647"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.616 244.541L146.821 197.15V206.545L227.372 253.107C227.51 250.206 227.925 247.304 228.616 244.541Z",
    fill: "#813D06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.775 187.202L142.262 242.744L144.887 244.402V187.34C143.091 187.34 141.433 187.34 139.775 187.202Z",
    fill: "#4D2216"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.135 234.178V293.728L232.622 292.346L236.491 230.862L230.135 234.178Z",
    fill: "#A87647"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.135 234.178L224.747 230.862L227.51 292.07L230.135 293.728V234.178Z",
    fill: "#4D2216"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.925 238.599L135.354 185.129V191.07L227.925 244.54V238.599Z",
    fill: "#C06F17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.908 209.17L227.925 238.6L224.333 236.527L191.864 217.737L176.251 208.756L155.94 197.012L135.354 185.129L186.337 155.7L192.554 159.292L213.003 171.036L228.616 180.017L248.926 191.761L278.908 209.17Z",
    fill: "#F8D298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.265 163.161L164.783 173.662L178.738 182.366L198.219 171.865L184.265 163.161Z",
    fill: "#EB4E4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.738 183.195V182.366L164.783 173.662L164.645 174.491L178.738 183.195Z",
    fill: "#9F0B08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.08 181.675L177.633 181.951L197.114 171.451L196.7 171.174L177.08 181.675Z",
    fill: "#C32A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.08 181.675V181.399L196.7 170.898V171.175L177.08 181.675Z",
    fill: "#8D0B0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.838 168.411L166.303 173.385L179.153 181.399L196.7 172.003L196.838 168.411Z",
    fill: "#67D6EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.989 160.397L166.441 169.793L179.291 177.806L196.838 168.411L183.989 160.397Z",
    fill: "#90EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.153 181.399L179.291 177.806L166.441 169.793L166.303 173.385L179.153 181.399Z",
    fill: "#D8E2ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.291 179.188L179.429 175.596L166.441 169.516L166.303 171.174L179.291 179.188Z",
    fill: "#B3BBC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.429 182.089C179.291 182.504 179.015 182.78 178.738 183.057L198.22 172.556C198.22 172.556 198.358 172.418 198.358 172.28C198.496 172.003 198.634 171.727 198.772 171.451C199.187 170.483 199.187 169.378 198.911 168.549C198.634 167.582 198.358 167.029 198.22 166.891L178.738 177.392C178.738 177.392 179.153 178.083 179.429 179.05C179.705 180.017 179.844 181.122 179.429 182.089Z",
    fill: "#760806"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.876 177.53C178.876 177.53 179.29 178.221 179.567 179.188L199.048 168.688C198.772 167.72 198.496 167.168 198.357 167.03L178.876 177.53Z",
    fill: "#8D0B0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.738 183.195L198.22 172.694C198.22 172.694 198.358 172.556 198.358 172.418C198.496 172.142 198.634 171.865 198.772 171.589L179.291 182.09C179.291 182.504 179.015 182.781 178.738 183.195Z",
    fill: "#640806"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.922 168.826L184.403 158.325L186.338 159.568V159.707C186.338 159.983 186.338 160.397 186.476 160.674C186.752 161.641 187.305 162.332 187.996 162.884C188.963 163.713 190.068 164.266 191.173 164.542C191.45 164.681 191.726 164.681 191.864 164.681C192.693 164.819 193.384 164.957 194.075 164.819C194.351 164.819 194.628 164.819 195.042 164.681L196.424 165.51L196.838 165.786V165.924L197.391 166.2L197.529 166.062L198.634 166.753L179.153 177.254L177.495 176.287L176.942 176.01L164.922 168.826Z",
    fill: "#EB4E4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.337 159.568L194.904 164.957C194.627 164.957 194.351 165.095 193.937 165.095C193.246 165.095 192.555 165.095 191.726 164.957C191.45 164.957 191.311 164.819 191.035 164.819C189.93 164.542 188.824 163.99 187.857 163.161C187.166 162.608 186.614 161.779 186.337 160.95C186.199 160.674 186.199 160.259 186.199 159.983C186.337 159.707 186.337 159.707 186.337 159.568Z",
    fill: "#EB4E4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.877 178.359V177.53L164.922 168.826L164.784 169.655L178.877 178.359Z",
    fill: "#9F0B08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.877 177.53L178.739 177.392L178.324 177.53C178.324 177.53 179.706 180.155 178.601 182.366L178.739 183.195C181.364 181.122 178.877 177.53 178.877 177.53Z",
    fill: "#9F0B08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.356 176.701L177.771 177.116L197.252 166.615L196.838 166.339L177.356 176.701Z",
    fill: "#C32A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.356 176.701L177.218 176.425L196.838 166.062V166.339L177.356 176.701Z",
    fill: "#8D0B0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.265 157.496L164.783 167.859L178.738 176.701L198.219 166.201L184.265 157.496Z",
    fill: "#B0D879"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.738 177.392V176.701L164.783 167.859L164.645 168.688L178.738 177.392Z",
    fill: "#648C29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.08 175.872L177.633 176.148L197.114 165.648L196.7 165.371L177.08 175.872Z",
    fill: "#8DB051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.08 175.872V175.596L196.7 165.234V165.372L177.08 175.872Z",
    fill: "#5A7A26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.837 162.608L166.303 167.582L179.152 175.734L196.699 166.2L196.837 162.608Z",
    fill: "#D8939D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.988 154.594L166.441 163.99L179.29 172.003L196.837 162.608L183.988 154.594Z",
    fill: "#ECBFC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.152 175.734L179.29 172.003L166.441 163.99L166.303 167.582L179.152 175.734Z",
    fill: "#D8E2ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.29 173.523L179.429 169.793L166.441 163.713L166.303 165.51L179.29 173.523Z",
    fill: "#B3BBC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.429 176.425C179.291 176.839 179.015 177.116 178.738 177.392L198.22 166.891C198.22 166.891 198.358 166.753 198.358 166.615C198.496 166.339 198.634 166.062 198.772 165.786C199.187 164.819 199.187 163.714 198.911 162.885C198.634 161.917 198.358 161.365 198.22 161.227L178.738 171.727C178.738 171.727 179.153 172.418 179.429 173.385C179.705 174.352 179.844 175.458 179.429 176.425Z",
    fill: "#47631D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.876 171.865C178.876 171.865 179.29 172.556 179.567 173.523L199.048 163.023C198.772 162.056 198.496 161.503 198.357 161.365L178.876 171.865Z",
    fill: "#5A7A26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.738 177.392L198.22 166.891C198.22 166.891 198.358 166.753 198.358 166.615C198.496 166.339 198.634 166.062 198.772 165.786L179.291 176.287C179.291 176.701 179.015 177.116 178.738 177.392Z",
    fill: "#3A5119"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.922 163.161L184.403 152.66L186.338 153.904V154.042C186.338 154.318 186.338 154.733 186.476 155.009C186.752 155.976 187.305 156.667 187.996 157.22C188.963 158.049 190.068 158.601 191.173 158.878C191.45 159.016 191.726 159.016 191.864 159.016C192.693 159.154 193.384 159.292 194.075 159.154C194.351 159.154 194.628 159.154 195.042 159.016L196.424 159.845L196.838 160.121V160.259L197.391 160.536L197.529 160.397L198.634 161.088L179.153 171.589L177.495 170.622L176.942 170.345L164.922 163.161Z",
    fill: "#B0D879"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.337 153.904L194.904 159.292C194.627 159.292 194.351 159.43 193.937 159.43C193.246 159.43 192.555 159.43 191.726 159.292C191.45 159.292 191.311 159.154 191.035 159.154C189.93 158.878 188.824 158.325 187.857 157.496C187.166 156.943 186.614 156.114 186.337 155.285C186.199 155.009 186.199 154.594 186.199 154.318C186.337 153.904 186.337 153.904 186.337 153.904Z",
    fill: "#B0D879"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.877 172.556V171.866L164.922 163.161L164.784 163.852L178.877 172.556Z",
    fill: "#648C29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.877 171.865L178.739 171.727L178.324 171.865C178.324 171.865 179.706 174.49 178.601 176.701L178.739 177.53C181.364 175.458 178.877 171.865 178.877 171.865Z",
    fill: "#648C29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.356 171.036L177.771 171.313L197.252 160.812L196.838 160.536L177.356 171.036Z",
    fill: "#8DB051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.356 171.036L177.218 170.76L196.838 160.259V160.536L177.356 171.036Z",
    fill: "#5A7A26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.265 151.417L164.783 161.917L178.738 170.622L198.219 160.121L184.265 151.417Z",
    fill: "#79B9D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.738 171.313V170.622L164.783 161.917L164.645 162.608L178.738 171.313Z",
    fill: "#296D8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.08 169.793L177.633 170.069L197.114 159.707L196.7 159.292L177.08 169.793Z",
    fill: "#5197B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.08 169.793V169.517L196.7 159.154V159.292L177.08 169.793Z",
    fill: "#26627A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.838 156.529L166.303 161.641L179.153 169.655L196.7 160.121L196.838 156.529Z",
    fill: "#D8C393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.989 148.515L166.441 157.91L179.291 165.924L196.838 156.529L183.989 148.515Z",
    fill: "#ECDFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.153 169.655L179.291 165.924L166.441 157.91L166.303 161.641L179.153 169.655Z",
    fill: "#D8E2ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.291 167.444L179.429 163.713L166.441 157.772L166.303 159.43L179.291 167.444Z",
    fill: "#B3BBC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.429 170.346C179.291 170.76 179.015 171.037 178.738 171.313L198.22 160.812C198.22 160.812 198.358 160.674 198.358 160.536C198.496 160.26 198.634 159.983 198.772 159.707C199.187 158.74 199.187 157.634 198.911 156.805C198.634 155.838 198.358 155.286 198.22 155.147L178.738 165.648C178.738 165.648 179.153 166.339 179.429 167.306C179.705 168.273 179.844 169.379 179.429 170.346Z",
    fill: "#1D4E63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.876 165.786C178.876 165.786 179.29 166.477 179.567 167.444L199.048 156.943C198.772 155.976 198.496 155.424 198.357 155.285L178.876 165.786Z",
    fill: "#26627A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.738 171.312L198.219 160.812C198.219 160.812 198.357 160.674 198.357 160.536C198.496 160.259 198.634 159.983 198.772 159.707L179.29 170.207C179.29 170.76 179.014 171.036 178.738 171.312Z",
    fill: "#193F51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.922 157.082L184.403 146.581L186.338 147.825V147.963C186.338 148.239 186.338 148.654 186.476 148.93C186.752 149.897 187.305 150.588 187.996 151.141C188.963 151.97 190.068 152.522 191.173 152.799C191.45 152.937 191.726 152.937 191.864 152.937C192.693 153.075 193.384 153.213 194.075 153.075C194.351 153.075 194.628 153.075 195.042 152.937L196.424 153.766L196.838 154.042V154.18L197.391 154.457L197.529 154.318L198.634 155.009L179.153 165.51L177.495 164.543L176.942 164.266L164.922 157.082Z",
    fill: "#79B9D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.337 147.824L194.904 153.213C194.627 153.213 194.351 153.351 193.937 153.351C193.246 153.351 192.555 153.351 191.726 153.213C191.45 153.213 191.311 153.075 191.035 153.075C189.93 152.798 188.824 152.246 187.857 151.417C187.166 150.864 186.614 150.035 186.337 149.206C186.199 148.93 186.199 148.515 186.199 148.239C186.337 147.963 186.337 147.824 186.337 147.824Z",
    fill: "#79B9D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.877 166.477V165.787L164.922 157.082L164.784 157.773L178.877 166.477Z",
    fill: "#296D8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.877 165.786L178.739 165.648L178.324 165.786C178.324 165.786 179.706 168.411 178.601 170.622L178.739 171.451C181.364 169.378 178.877 165.786 178.877 165.786Z",
    fill: "#296D8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.356 164.957L177.771 165.234L197.252 154.733L196.838 154.457L177.356 164.957Z",
    fill: "#5197B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.356 164.957L177.218 164.681L196.838 154.318V154.457L177.356 164.957Z",
    fill: "#26627A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.908 209.17V215.25L227.925 244.541V238.6L278.908 209.17Z",
    fill: "#E6B381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.472 202.815L237.044 206.96C236.215 206.407 235.248 205.854 234.281 205.302C232.899 204.473 233.452 202.124 232.623 201.709L211.069 185.129L218.115 181.951L211.621 178.221L201.121 184.3H200.706L200.844 184.438L170.033 202.262C169.342 202.676 169.342 203.644 170.033 204.058L207.2 225.474C209.687 226.994 211.621 226.165 214.108 224.645L232.07 214.282L239.531 218.704C239.531 218.704 233.037 218.842 231.932 219.394C230.826 220.085 231.241 223.263 235.662 224.507C240.222 225.612 242.709 224.783 242.709 224.783L245.748 222.158L252.795 221.467L262.466 206.131L245.472 202.815Z",
    fill: "#C2AC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.738 183.195L160.5 182.089L150.137 176.563L162.71 169.378L178.738 183.195Z",
    fill: "#C2AC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.59 211.243L232.346 211.519L201.121 151.002H201.397C201.95 149.344 203.055 148.101 204.575 148.654L241.051 169.793C242.294 170.208 243.123 171.451 243.123 172.833L235.938 209.585C235.386 211.105 234.833 211.519 233.59 211.243Z",
    fill: "#131414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.018 170.898L234.557 173.938L202.088 150.449L204.299 148.653C204.437 148.653 204.575 148.653 204.713 148.791L241.189 169.931C241.465 170.069 241.742 170.622 242.018 170.898Z",
    fill: "#D0E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.32 182.09L243.262 172.556C243.262 172.694 243.262 172.694 243.262 172.832L236.077 209.585C236.077 209.723 235.662 209.861 235.662 209.999L234.419 209.723L237.32 182.09Z",
    fill: "#131414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.171 202.262L206.647 223.401C208.443 224.507 210.654 224.092 212.588 223.125L233.866 211.796C234.695 211.381 234.971 210.69 234.971 209.723V209.447L169.895 199.084L169.48 199.361C169.342 199.499 169.204 199.637 169.066 199.775C168.928 200.051 168.928 200.466 168.928 200.604C168.928 201.157 168.928 201.433 170.171 202.262Z",
    fill: "#27292A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.971 210.552C234.971 210.966 234.695 211.381 234.418 211.657L212.588 223.263C212.312 223.401 211.897 223.54 211.621 223.678L210.516 207.512H221.983L234.971 209.585V210.552Z",
    fill: "#191A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.452 208.618L194.489 188.584C193.66 188.031 193.107 187.064 193.383 185.958L200.844 150.726C200.844 149.068 202.502 148.101 204.022 148.515L241.189 169.793C242.156 170.069 242.847 171.589 242.847 172.556L235.662 208.756C234.833 209.861 235.11 209.032 233.452 208.618Z",
    fill: "#5B6662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.524 168.411L241.188 170.346C242.156 170.622 242.846 171.589 242.846 172.695L235.662 208.894C234.971 209.999 235.247 209.17 233.451 208.756L202.502 192.867L235.524 168.411Z",
    fill: "#5B6662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.383 186.097L193.936 184.853L235.8 208.618L235.662 208.894C234.971 210 235.386 209.861 233.728 209.447L194.627 188.722C193.66 188.031 193.245 187.064 193.383 186.097Z",
    fill: "#404747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.765 184.024L200.568 187.34L235.386 207.374C235.524 207.236 235.524 207.236 235.662 207.098L242.294 172.28C242.294 171.727 241.879 171.175 241.327 171.036L239.392 170.346L216.595 156.529L203.193 149.068C202.916 148.93 202.778 148.93 202.502 149.068C202.226 149.068 201.673 149.344 201.397 150.311V150.45L194.765 184.024Z",
    fill: "#4B4E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.628 196.044L235.386 207.374C235.524 207.236 235.524 207.236 235.662 207.098L242.294 172.28C242.294 171.727 241.741 170.76 241.189 170.622L216.595 156.667L215.628 196.044Z",
    fill: "#69717A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.317 181.537L201.535 151.002L241.603 174.214L235.8 205.44L195.317 181.537Z",
    fill: "#097A57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.066 200.604C169.066 200.88 169.342 201.295 169.619 201.433L191.034 213.73L207.614 223.263C208.581 223.678 210.101 223.678 211.759 222.849L235.109 209.447L232.346 207.789L203.746 191.347L193.659 185.406L175.836 195.768L170.171 199.222L169.757 199.499C169.619 199.637 169.48 199.775 169.342 199.913C169.066 199.913 168.928 200.328 169.066 200.604Z",
    fill: "#848D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.632 195.63L192.692 186.926L195.179 188.307L179.981 197.15L177.632 195.63Z",
    fill: "#5E6A70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.534 197.426L193.936 189.827L227.925 209.447L214.661 217.184L180.534 197.426Z",
    fill: "#566063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.569 161.918C221.983 161.918 222.26 161.503 222.26 160.951C222.26 160.398 221.845 159.983 221.431 159.983C221.016 159.983 220.74 160.398 220.74 160.951C220.74 161.503 221.154 161.918 221.569 161.918Z",
    fill: "#3E3F4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.431 161.641C221.292 161.503 221.154 161.365 221.154 161.089C221.154 160.674 221.292 160.398 221.569 160.398H221.707C221.845 160.536 221.983 160.674 221.983 160.951C221.983 161.089 221.983 161.227 221.845 161.365C221.707 161.503 221.707 161.641 221.431 161.641Z",
    fill: "#8357D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.569 161.365C221.431 161.365 221.292 161.089 221.292 160.95C221.292 160.674 221.431 160.536 221.569 160.536C221.569 160.536 221.569 160.536 221.707 160.536C221.845 160.536 221.983 160.812 221.983 160.95C221.983 161.089 221.983 161.227 221.845 161.227C221.707 161.365 221.707 161.365 221.569 161.365Z",
    fill: "#A78FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.903 214.973C195.317 214.973 195.593 214.835 195.87 214.697L200.567 211.795C200.982 211.519 201.12 211.243 201.12 210.828C201.12 210.414 200.844 209.999 200.567 209.861L191.725 204.749C191.448 204.611 191.034 204.473 190.758 204.473C190.343 204.473 190.067 204.611 189.79 204.749L185.093 207.65C184.678 207.927 184.54 208.203 184.54 208.618C184.54 209.032 184.816 209.447 185.093 209.585L193.935 214.697C194.212 214.973 194.488 214.973 194.903 214.973Z",
    fill: "#27292A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.231 209.585L194.074 214.697C194.626 214.973 195.317 214.973 195.732 214.697L197.113 213.868L200.291 211.934C200.982 211.519 200.982 210.69 200.291 210.276L191.448 205.164C190.896 204.887 190.205 204.887 189.791 205.164L186.06 207.512L185.231 208.065C184.54 208.341 184.54 209.17 185.231 209.585Z",
    fill: "#6C7578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.231 209.585L194.073 214.697C194.626 214.973 195.317 214.973 195.731 214.697L197.113 213.868L185.922 207.512L185.093 208.065C184.54 208.341 184.54 209.17 185.231 209.585Z",
    fill: "#566063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.784 207.65L185.093 208.065C185.093 208.065 185.093 208.065 185.231 208.065L186.06 207.512L197.251 213.868L196.975 214.006L185.784 207.65Z",
    fill: "#1B1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.075 217.46L230.135 208.756L232.622 210.137L217.424 218.842L215.075 217.46Z",
    fill: "#5E6A70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.173 210.414L188.962 211.795L188.686 211.657L190.896 210.276L191.173 210.414Z",
    fill: "#1B1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.798 192.314L192.692 191.623C192.554 191.485 192.554 191.347 192.692 191.347L192.969 191.209C193.107 191.071 193.521 191.071 193.66 191.209L194.765 191.9C194.903 192.038 194.903 192.176 194.765 192.176L194.489 192.314C194.35 192.452 193.936 192.452 193.798 192.314Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.667 194.525L196.562 193.834C196.423 193.696 196.423 193.558 196.562 193.558L196.838 193.42C196.976 193.281 197.391 193.281 197.529 193.42L198.634 194.11C198.772 194.249 198.772 194.387 198.634 194.387L198.358 194.525C198.22 194.663 197.805 194.663 197.667 194.525Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.602 195.63L198.496 194.939C198.358 194.801 198.358 194.663 198.496 194.663L198.773 194.525C198.911 194.386 199.325 194.386 199.463 194.525L200.569 195.215C200.707 195.354 200.707 195.492 200.569 195.492L200.292 195.63C200.154 195.768 199.74 195.768 199.602 195.63Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.397 196.735L200.292 196.044C200.153 195.906 200.153 195.768 200.292 195.768L200.568 195.63C200.706 195.492 201.121 195.492 201.259 195.63L202.364 196.321C202.502 196.459 202.502 196.597 202.364 196.597L202.088 196.735C201.95 196.873 201.673 196.873 201.397 196.735Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.266 198.946L204.161 198.255C204.023 198.117 204.023 197.979 204.161 197.979L204.437 197.841C204.575 197.703 204.99 197.703 205.128 197.841L206.233 198.532C206.371 198.67 206.371 198.808 206.233 198.808L205.957 198.946C205.819 199.084 205.404 199.084 205.266 198.946Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.201 200.052L206.095 199.361C205.957 199.223 205.957 199.085 206.095 199.085L206.372 198.946C206.51 198.808 206.924 198.808 207.063 198.946L208.168 199.637C208.306 199.775 208.306 199.914 208.168 199.914L207.891 200.052C207.753 200.19 207.339 200.19 207.201 200.052Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.134 201.295L208.029 200.604C207.891 200.466 207.891 200.328 208.029 200.328L208.305 200.19C208.443 200.051 208.858 200.051 208.996 200.19L210.101 200.88C210.24 201.019 210.24 201.157 210.101 201.157L209.825 201.295C209.549 201.295 209.272 201.295 209.134 201.295Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.865 203.506L211.76 202.815C211.622 202.677 211.622 202.538 211.76 202.538L212.036 202.4C212.174 202.262 212.589 202.262 212.727 202.4L213.832 203.091C213.971 203.229 213.971 203.367 213.832 203.367L213.556 203.506C213.418 203.506 213.003 203.506 212.865 203.506Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.8 204.611L213.694 203.92C213.556 203.782 213.556 203.643 213.694 203.643L213.971 203.505C214.109 203.367 214.523 203.367 214.662 203.505L215.767 204.196C215.905 204.334 215.905 204.472 215.767 204.472L215.491 204.611C215.352 204.611 214.938 204.611 214.8 204.611Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.733 205.716L215.628 205.025C215.49 204.887 215.49 204.749 215.628 204.749L215.904 204.611C216.043 204.473 216.457 204.473 216.595 204.611L217.701 205.302C217.839 205.44 217.839 205.578 217.701 205.578L217.424 205.716C217.286 205.716 216.872 205.716 216.733 205.716Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.53 206.821L217.424 206.131C217.286 205.992 217.286 205.854 217.424 205.854L217.701 205.716C217.839 205.578 218.253 205.578 218.392 205.716L219.497 206.407C219.635 206.545 219.635 206.683 219.497 206.683L219.221 206.821C219.082 206.821 218.806 206.821 218.53 206.821Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.587 193.558L190.482 192.867C190.344 192.729 190.344 192.59 190.482 192.59L191.587 192.038C191.726 191.9 192.14 191.9 192.278 192.038L193.384 192.729C193.522 192.867 193.522 193.005 193.384 193.005L192.278 193.558C192.14 193.696 191.726 193.696 191.587 193.558Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.522 194.663L192.417 193.972C192.278 193.834 192.278 193.696 192.417 193.696L193.522 193.143C193.66 193.005 194.075 193.005 194.213 193.143L195.318 193.834C195.456 193.972 195.456 194.11 195.318 194.11L194.213 194.663C194.075 194.801 193.66 194.801 193.522 194.663Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.457 195.768L194.351 195.077C194.213 194.939 194.213 194.801 194.351 194.801L195.457 194.248C195.595 194.11 196.009 194.11 196.147 194.248L197.253 194.939C197.391 195.077 197.391 195.216 197.253 195.216L196.147 195.768C196.009 195.906 195.595 195.906 195.457 195.768Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.39 196.873L196.285 196.183C196.147 196.044 196.147 195.906 196.285 195.906L197.39 195.354C197.528 195.215 197.943 195.215 198.081 195.354L199.186 196.044C199.324 196.183 199.324 196.321 199.186 196.321L198.081 196.873C197.805 197.012 197.528 197.012 197.39 196.873Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.187 197.979L198.082 197.288C197.943 197.15 197.943 197.012 198.082 197.012L199.187 196.459C199.325 196.321 199.74 196.321 199.878 196.459L200.983 197.15C201.121 197.288 201.121 197.426 200.983 197.426L199.878 197.979C199.74 198.117 199.325 198.117 199.187 197.979Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.121 199.084L200.016 198.394C199.878 198.255 199.878 198.117 200.016 198.117L201.121 197.565C201.259 197.426 201.674 197.426 201.812 197.565L202.917 198.255C203.055 198.394 203.055 198.532 202.917 198.532L201.812 199.084C201.674 199.223 201.259 199.223 201.121 199.084Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.056 200.189L201.95 199.499C201.812 199.36 201.812 199.222 201.95 199.222L203.056 198.67C203.194 198.531 203.608 198.531 203.746 198.67L204.852 199.36C204.99 199.499 204.99 199.637 204.852 199.637L203.746 200.189C203.608 200.328 203.194 200.328 203.056 200.189Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.989 201.295L203.884 200.604C203.746 200.466 203.746 200.328 203.884 200.328L204.989 199.775C205.127 199.637 205.542 199.637 205.68 199.775L206.785 200.466C206.924 200.604 206.924 200.742 206.785 200.742L205.68 201.295C205.542 201.433 205.127 201.433 204.989 201.295Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.786 202.539L205.681 201.848C205.543 201.71 205.543 201.571 205.681 201.571L206.786 201.019C206.924 200.88 207.339 200.88 207.477 201.019L208.582 201.709C208.72 201.848 208.72 201.986 208.582 201.986L207.477 202.539C207.339 202.539 207.062 202.539 206.786 202.539Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.72 203.643L207.615 202.953C207.477 202.814 207.477 202.676 207.615 202.676L208.72 202.124C208.858 201.985 209.273 201.985 209.411 202.124L210.516 202.814C210.655 202.953 210.655 203.091 210.516 203.091L209.411 203.643C209.273 203.643 208.858 203.643 208.72 203.643Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.655 204.749L209.549 204.058C209.411 203.92 209.411 203.782 209.549 203.782L210.655 203.229C210.793 203.091 211.207 203.091 211.346 203.229L212.451 203.92C212.589 204.058 212.589 204.196 212.451 204.196L211.346 204.749C211.207 204.749 210.793 204.749 210.655 204.749Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.588 205.854L211.483 205.164C211.345 205.025 211.345 204.887 211.483 204.887L212.588 204.335C212.727 204.196 213.141 204.196 213.279 204.335L214.384 205.025C214.523 205.164 214.523 205.302 214.384 205.302L213.279 205.854C213.141 205.854 212.727 205.854 212.588 205.854Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.01 208.065L218.116 207.512C218.254 207.374 218.254 207.236 218.116 207.236L215.076 205.44C214.938 205.44 214.8 205.302 214.662 205.302C214.523 205.302 214.385 205.302 214.247 205.302L213.142 205.854C213.004 205.992 213.004 206.13 213.142 206.13L214.247 206.821L216.181 207.927C216.458 208.065 216.872 208.065 217.01 208.065Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.74 208.065L219.635 207.374C219.497 207.236 219.497 207.098 219.635 207.098L219.911 206.96C220.049 206.821 220.464 206.821 220.602 206.96L221.707 207.65C221.846 207.789 221.846 207.927 221.707 207.927L221.431 208.065C221.293 208.203 220.878 208.203 220.74 208.065Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.675 209.17L221.569 208.479C221.431 208.341 221.431 208.203 221.569 208.203L221.846 208.065C221.984 207.927 222.398 207.927 222.537 208.065L223.642 208.756C223.78 208.894 223.78 209.032 223.642 209.032L223.366 209.17C223.227 209.308 222.813 209.308 222.675 209.17Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.609 210.276L223.504 209.585C223.366 209.447 223.366 209.308 223.504 209.308L223.78 209.17C223.919 209.032 224.333 209.032 224.471 209.17L225.577 209.861C225.715 209.999 225.715 210.137 225.577 210.137L225.3 210.276C225.162 210.414 224.748 210.414 224.609 210.276Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.53 209.308L217.424 208.618C217.286 208.48 217.286 208.341 217.424 208.341L218.53 207.789C218.668 207.651 219.082 207.651 219.221 207.789L220.326 208.48C220.464 208.618 220.464 208.756 220.326 208.756L219.221 209.308C219.082 209.447 218.668 209.447 218.53 209.308Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.464 210.414L219.359 209.723C219.221 209.585 219.221 209.447 219.359 209.447L220.464 208.894C220.602 208.756 221.017 208.756 221.155 208.894L222.26 209.585C222.399 209.723 222.399 209.861 222.26 209.861L221.155 210.414C221.017 210.552 220.602 210.552 220.464 210.414Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.399 211.519L221.294 210.828C221.155 210.69 221.155 210.552 221.294 210.552L222.399 209.999C222.537 209.861 222.952 209.861 223.09 209.999L224.195 210.69C224.333 210.828 224.333 210.967 224.195 210.967L223.09 211.519C222.952 211.657 222.537 211.657 222.399 211.519Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.733 210.414L215.628 209.723C215.49 209.585 215.49 209.447 215.628 209.447L216.733 208.894C216.872 208.756 217.286 208.756 217.424 208.894L218.53 209.585C218.668 209.723 218.668 209.861 218.53 209.861L217.424 210.414C217.286 210.414 216.872 210.414 216.733 210.414Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.53 211.519L217.424 210.828C217.286 210.69 217.286 210.552 217.424 210.552L218.53 209.999C218.668 209.861 219.082 209.861 219.221 209.999L220.326 210.69C220.464 210.828 220.464 210.967 220.326 210.967L219.221 211.519C219.082 211.519 218.806 211.519 218.53 211.519Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.464 212.624L219.359 211.933C219.221 211.795 219.221 211.657 219.359 211.657L220.464 211.104C220.602 210.966 221.017 210.966 221.155 211.104L222.26 211.795C222.399 211.933 222.399 212.072 222.26 212.072L221.155 212.624C221.017 212.624 220.602 212.624 220.464 212.624Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.416 195.768L193.521 195.215C193.66 195.077 193.66 194.939 193.521 194.939L192.416 194.248L190.482 193.143C190.344 193.005 189.929 193.005 189.791 193.143L188.686 193.696C188.547 193.834 188.547 193.972 188.686 193.972L191.725 195.768C191.863 195.768 192.002 195.906 192.14 195.906C192.14 195.768 192.278 195.768 192.416 195.768Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.522 196.873L192.417 196.183C192.278 196.044 192.278 195.906 192.417 195.906L193.522 195.354C193.66 195.215 194.075 195.215 194.213 195.354L195.318 196.044C195.456 196.183 195.456 196.321 195.318 196.321L194.213 196.873C194.075 197.012 193.66 196.873 193.522 196.873Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.457 197.979L194.351 197.288C194.213 197.15 194.213 197.012 194.351 197.012L195.457 196.459C195.595 196.321 196.009 196.321 196.147 196.459L197.253 197.15C197.391 197.288 197.391 197.426 197.253 197.426L196.147 197.979C196.009 198.117 195.595 198.117 195.457 197.979Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.39 199.084L196.285 198.394C196.147 198.255 196.147 198.117 196.285 198.117L197.39 197.565C197.528 197.426 197.943 197.426 198.081 197.565L199.186 198.255C199.324 198.394 199.324 198.532 199.186 198.532L198.081 199.084C197.943 199.223 197.528 199.223 197.39 199.084Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.325 200.189L198.219 199.499C198.081 199.36 198.081 199.222 198.219 199.222L199.325 198.67C199.463 198.531 199.877 198.531 200.016 198.67L201.121 199.36C201.259 199.499 201.259 199.637 201.121 199.637L200.016 200.189C199.877 200.328 199.463 200.328 199.325 200.189Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.121 201.295L200.016 200.604C199.878 200.466 199.878 200.328 200.016 200.328L201.121 199.775C201.259 199.637 201.674 199.637 201.812 199.775L202.917 200.466C203.055 200.604 203.055 200.742 202.917 200.742L201.812 201.295C201.674 201.433 201.397 201.433 201.121 201.295Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.056 202.4L201.95 201.709C201.812 201.571 201.812 201.433 201.95 201.433L203.056 200.88C203.194 200.742 203.608 200.742 203.746 200.88L204.852 201.571C204.99 201.709 204.99 201.847 204.852 201.847L203.746 202.4C203.608 202.538 203.194 202.538 203.056 202.4Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.989 203.506L203.884 202.815C203.746 202.677 203.746 202.539 203.884 202.539L204.989 201.986C205.127 201.848 205.542 201.848 205.68 201.986L206.785 202.677C206.924 202.815 206.924 202.953 206.785 202.953L205.68 203.506C205.542 203.644 205.127 203.644 204.989 203.506Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.924 204.611L205.818 203.92C205.68 203.782 205.68 203.644 205.818 203.644L206.924 203.091C207.062 202.953 207.476 202.953 207.615 203.091L208.72 203.782C208.858 203.92 208.858 204.058 208.72 204.058L207.615 204.611C207.476 204.749 207.062 204.749 206.924 204.611Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.858 205.716L207.753 205.025C207.615 204.887 207.615 204.749 207.753 204.749L208.858 204.196C208.997 204.058 209.411 204.058 209.549 204.196L210.655 204.887C210.793 205.025 210.793 205.163 210.655 205.163L209.549 205.716C209.411 205.854 208.997 205.854 208.858 205.716Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.655 206.821L209.549 206.13C209.411 205.992 209.411 205.854 209.549 205.854L210.655 205.301C210.793 205.163 211.207 205.163 211.346 205.301L212.451 205.992C212.589 206.13 212.589 206.269 212.451 206.269L211.346 206.821C211.207 206.959 210.793 206.959 210.655 206.821Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.588 207.927L211.483 207.236C211.345 207.098 211.345 206.96 211.483 206.96L212.588 206.407C212.727 206.269 213.141 206.269 213.279 206.407L214.384 207.098C214.523 207.236 214.523 207.374 214.384 207.374L213.279 207.927C213.141 208.065 212.727 208.065 212.588 207.927Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.483 196.735L191.588 196.183C191.726 196.045 191.726 195.906 191.588 195.906L190.483 195.216L188.548 194.11C188.41 193.972 187.996 193.972 187.857 194.11L186.752 194.663C186.614 194.801 186.614 194.939 186.752 194.939L189.792 196.735C189.93 196.735 190.068 196.874 190.206 196.874C190.344 196.874 190.483 196.874 190.483 196.735Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.726 197.841L190.62 197.15C190.482 197.012 190.482 196.874 190.62 196.874L191.726 196.321C191.864 196.183 192.278 196.183 192.416 196.321L193.522 197.012C193.66 197.15 193.66 197.288 193.522 197.288L192.416 197.841C192.278 197.979 191.864 197.979 191.726 197.841Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.66 198.946L192.555 198.255C192.417 198.117 192.417 197.979 192.555 197.979L193.66 197.426C193.798 197.288 194.213 197.288 194.351 197.426L195.456 198.117C195.594 198.255 195.594 198.393 195.456 198.393L194.351 198.946C194.213 199.084 193.798 199.084 193.66 198.946Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.457 200.051L194.351 199.361C194.213 199.222 194.213 199.084 194.351 199.084L195.457 198.532C195.595 198.393 196.009 198.393 196.147 198.532L197.253 199.222C197.391 199.361 197.391 199.499 197.253 199.499L196.147 200.051C196.009 200.19 195.733 200.19 195.457 200.051Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.39 201.157L196.285 200.466C196.147 200.328 196.147 200.19 196.285 200.19L197.39 199.637C197.528 199.499 197.943 199.499 198.081 199.637L199.186 200.328C199.324 200.466 199.324 200.604 199.186 200.604L198.081 201.157C197.943 201.295 197.528 201.295 197.39 201.157Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.325 202.262L198.219 201.571C198.081 201.433 198.081 201.295 198.219 201.295L199.325 200.742C199.463 200.604 199.877 200.604 200.016 200.742L201.121 201.433C201.259 201.571 201.259 201.709 201.121 201.709L200.016 202.262C199.877 202.4 199.463 202.4 199.325 202.262Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.259 203.367L200.154 202.677C200.016 202.538 200.016 202.4 200.154 202.4L201.259 201.848C201.397 201.709 201.812 201.709 201.95 201.848L203.055 202.538C203.194 202.677 203.194 202.815 203.055 202.815L201.95 203.367C201.812 203.506 201.397 203.506 201.259 203.367Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.193 204.611L202.088 203.92C201.95 203.782 201.95 203.644 202.088 203.644L203.193 203.091C203.331 202.953 203.746 202.953 203.884 203.091L204.989 203.782C205.128 203.92 205.128 204.058 204.989 204.058L203.884 204.611C203.746 204.611 203.331 204.611 203.193 204.611Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.989 205.716L203.884 205.025C203.746 204.887 203.746 204.749 203.884 204.749L204.989 204.196C205.127 204.058 205.542 204.058 205.68 204.196L206.785 204.887C206.924 205.025 206.924 205.163 206.785 205.163L205.68 205.716C205.542 205.716 205.127 205.716 204.989 205.716Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.924 206.821L205.818 206.13C205.68 205.992 205.68 205.854 205.818 205.854L206.924 205.301C207.062 205.163 207.476 205.163 207.615 205.301L208.72 205.992C208.858 206.13 208.858 206.269 208.72 206.269L207.615 206.821C207.476 206.821 207.062 206.821 206.924 206.821Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.858 207.927L207.753 207.236C207.615 207.098 207.615 206.96 207.753 206.96L208.858 206.407C208.997 206.269 209.411 206.269 209.549 206.407L210.655 207.098C210.793 207.236 210.793 207.374 210.655 207.374L209.549 207.927C209.411 207.927 208.997 207.927 208.858 207.927Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.28 210.137L214.385 209.585L216.181 208.479C216.32 208.341 216.32 208.203 216.181 208.203L215.076 207.512C214.938 207.374 214.523 207.374 214.385 207.512L212.865 208.341L211.346 207.374C211.207 207.236 210.793 207.236 210.655 207.374L209.549 207.927C209.411 208.065 209.411 208.203 209.549 208.203L212.589 209.999C212.727 209.999 212.865 210.137 213.004 210.137C213.142 210.137 213.28 210.137 213.28 210.137Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.344 198.946C190.344 198.946 190.482 198.946 190.344 198.946C190.482 198.946 190.62 198.946 190.62 198.946L191.726 198.393C191.864 198.393 191.864 198.255 191.864 198.255C191.864 198.255 191.864 198.117 191.726 198.117L190.62 197.426L188.686 196.321L186.752 195.215C186.614 195.077 186.199 195.077 186.061 195.215L184.956 195.768C184.818 195.906 184.818 196.044 184.956 196.044L189.93 198.946C189.93 198.946 190.068 198.946 190.344 198.946C190.206 198.946 190.206 198.946 190.344 198.946Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.726 200.051L190.62 199.361C190.482 199.222 190.482 199.084 190.62 199.084L191.726 198.532C191.864 198.393 192.278 198.393 192.416 198.532L193.522 199.222C193.66 199.361 193.66 199.499 193.522 199.499L192.416 200.051C192.278 200.19 191.864 200.19 191.726 200.051Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.66 201.157L192.555 200.466C192.417 200.328 192.417 200.19 192.555 200.19L193.66 199.637C193.798 199.499 194.213 199.499 194.351 199.637L195.456 200.328C195.594 200.466 195.594 200.604 195.456 200.604L194.351 201.157C194.213 201.295 193.798 201.295 193.66 201.157Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.594 202.262L194.489 201.571C194.351 201.433 194.351 201.295 194.489 201.295L195.594 200.742C195.732 200.604 196.147 200.604 196.285 200.742L197.39 201.433C197.529 201.571 197.529 201.709 197.39 201.709L196.285 202.262C196.147 202.4 195.732 202.4 195.594 202.262Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.529 203.367L196.423 202.677C196.285 202.538 196.285 202.4 196.423 202.4L197.529 201.848C197.667 201.709 198.081 201.709 198.22 201.848L199.325 202.538C199.463 202.677 199.463 202.815 199.325 202.815L198.22 203.367C198.081 203.506 197.667 203.506 197.529 203.367Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.325 204.473L198.219 203.782C198.081 203.644 198.081 203.505 198.219 203.505L199.325 202.953C199.463 202.815 199.877 202.815 200.016 202.953L201.121 203.644C201.259 203.782 201.259 203.92 201.121 203.92L200.016 204.473C199.877 204.611 199.463 204.611 199.325 204.473Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.259 205.578L200.154 204.887C200.016 204.749 200.016 204.611 200.154 204.611L201.259 204.058C201.397 203.92 201.812 203.92 201.95 204.058L203.055 204.749C203.194 204.887 203.194 205.025 203.055 205.025L201.95 205.578C201.812 205.716 201.397 205.716 201.259 205.578Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.193 206.684L202.088 205.993C201.95 205.855 201.95 205.716 202.088 205.716L203.193 205.164C203.331 205.026 203.746 205.026 203.884 205.164L204.989 205.855C205.128 205.993 205.128 206.131 204.989 206.131L203.884 206.684C203.746 206.822 203.331 206.822 203.193 206.684Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.128 207.789L204.023 207.098C203.884 206.96 203.884 206.821 204.023 206.821L205.128 206.269C205.266 206.13 205.681 206.13 205.819 206.269L206.924 206.959C207.062 207.098 207.062 207.236 206.924 207.236L205.819 207.789C205.681 207.927 205.266 207.927 205.128 207.789Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.752 198.808L187.857 198.255C187.995 198.117 187.995 197.979 187.857 197.979L184.817 196.183C184.679 196.045 184.265 196.045 184.126 196.183L183.021 196.736C182.883 196.874 182.883 197.012 183.021 197.012L184.955 198.117L186.061 198.808C186.199 198.808 186.337 198.946 186.475 198.946C186.613 198.946 186.752 198.946 186.752 198.808Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.995 199.913L186.89 199.222C186.752 199.084 186.752 198.946 186.89 198.946L187.995 198.393C188.133 198.255 188.548 198.255 188.686 198.393L189.791 199.084C189.929 199.222 189.929 199.36 189.791 199.36L188.686 199.913C188.548 200.051 188.133 200.051 187.995 199.913Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.93 201.019L188.824 200.328C188.686 200.19 188.686 200.052 188.824 200.052L189.93 199.499C190.068 199.361 190.482 199.361 190.62 199.499L191.726 200.19C191.864 200.328 191.864 200.466 191.726 200.466L190.62 201.019C190.482 201.157 190.068 201.157 189.93 201.019Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.259 207.789L200.154 207.098C200.016 206.96 200.016 206.821 200.154 206.821L201.259 206.269C201.397 206.13 201.812 206.13 201.95 206.269L203.055 206.959C203.194 207.098 203.194 207.236 203.055 207.236L201.95 207.789C201.812 207.789 201.536 207.789 201.259 207.789Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.193 208.894L202.088 208.203C201.95 208.065 201.95 207.927 202.088 207.927L203.193 207.374C203.331 207.236 203.746 207.236 203.884 207.374L204.989 208.065C205.128 208.203 205.128 208.341 204.989 208.341L203.884 208.894C203.746 208.894 203.331 208.894 203.193 208.894Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.128 209.999L204.023 209.309C203.884 209.17 203.884 209.032 204.023 209.032L205.128 208.48C205.266 208.341 205.681 208.341 205.819 208.48L206.924 209.17C207.062 209.309 207.062 209.447 206.924 209.447L205.819 209.999C205.681 209.999 205.266 209.999 205.128 209.999Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.687 212.21L210.792 211.658C210.931 211.519 210.931 211.381 210.792 211.381L207.753 209.585C207.615 209.447 207.2 209.447 207.062 209.585L205.957 210.138C205.818 210.276 205.818 210.414 205.957 210.414L208.996 212.21C209.134 212.21 209.549 212.21 209.687 212.21Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.937 213.454L213.832 212.763C213.694 212.625 213.694 212.486 213.832 212.486L214.937 211.934C215.076 211.796 215.49 211.796 215.628 211.934L216.734 212.625C216.872 212.763 216.872 212.901 216.734 212.901L215.628 213.454C215.49 213.592 215.076 213.592 214.937 213.454Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.069 213.454L209.963 212.763C209.825 212.625 209.825 212.486 209.963 212.486L211.069 211.934C211.207 211.796 211.621 211.796 211.76 211.934L212.865 212.625C213.003 212.763 213.003 212.901 212.865 212.901L211.76 213.454C211.621 213.592 211.345 213.592 211.069 213.454Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.003 214.559L211.898 213.868C211.76 213.73 211.76 213.592 211.898 213.592L213.003 213.039C213.142 212.901 213.556 212.901 213.694 213.039L214.8 213.73C214.938 213.868 214.938 214.006 214.8 214.006L213.694 214.559C213.556 214.697 213.142 214.697 213.003 214.559Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.937 215.664L213.832 214.974C213.694 214.835 213.694 214.697 213.832 214.697L214.937 214.145C215.076 214.006 215.49 214.006 215.628 214.145L216.734 214.835C216.872 214.974 216.872 215.112 216.734 215.112L215.628 215.664C215.49 215.803 215.076 215.803 214.937 215.664Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.154 206.683L201.259 206.131C201.397 205.992 201.397 205.854 201.259 205.854L192.555 200.742C192.416 200.604 192.002 200.604 191.864 200.742L190.758 201.295C190.62 201.433 190.62 201.571 190.758 201.571L198.358 205.992L199.463 206.683C199.601 206.683 200.016 206.683 200.154 206.683Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.792 211.105L205.818 208.203C205.68 208.065 205.68 207.927 205.818 207.927L206.924 207.374C207.062 207.236 207.476 207.236 207.615 207.374L212.589 210.276C212.727 210.414 212.727 210.552 212.589 210.552L211.483 211.105C211.345 211.243 210.931 211.243 210.792 211.105Z",
    fill: "#354747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.936 192.452L192.831 191.762C192.693 191.623 192.693 191.485 192.831 191.485L193.107 191.347C193.246 191.209 193.66 191.209 193.798 191.347L194.904 192.038C195.042 192.176 195.042 192.314 194.904 192.314L194.627 192.452C194.351 192.591 194.075 192.591 193.936 192.452Z",
    fill: "url(#paint2_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.667 194.663L196.562 193.972C196.423 193.834 196.423 193.696 196.562 193.696L196.838 193.558C196.976 193.42 197.391 193.42 197.529 193.558L198.634 194.249C198.772 194.387 198.772 194.525 198.634 194.525L198.358 194.663C198.22 194.801 197.805 194.801 197.667 194.663Z",
    fill: "url(#paint3_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.602 195.768L198.496 195.077C198.358 194.939 198.358 194.801 198.496 194.801L198.773 194.663C198.911 194.525 199.325 194.525 199.463 194.663L200.569 195.354C200.707 195.492 200.707 195.63 200.569 195.63L200.292 195.768C200.154 195.906 199.74 195.906 199.602 195.768Z",
    fill: "url(#paint4_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.536 196.874L200.43 196.183C200.292 196.045 200.292 195.906 200.43 195.906L200.707 195.768C200.845 195.63 201.259 195.63 201.397 195.768L202.503 196.459C202.641 196.597 202.641 196.735 202.503 196.735L202.226 196.874C202.088 197.012 201.674 197.012 201.536 196.874Z",
    fill: "url(#paint5_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.266 199.084L204.161 198.394C204.023 198.255 204.023 198.117 204.161 198.117L204.437 197.979C204.575 197.841 204.99 197.841 205.128 197.979L206.233 198.67C206.371 198.808 206.371 198.946 206.233 198.946L205.957 199.084C205.819 199.223 205.404 199.223 205.266 199.084Z",
    fill: "url(#paint6_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.201 200.19L206.095 199.499C205.957 199.361 205.957 199.223 206.095 199.223L206.372 199.085C206.51 198.946 206.924 198.946 207.063 199.085L208.168 199.775C208.306 199.914 208.306 200.052 208.168 200.052L207.891 200.19C207.753 200.328 207.339 200.328 207.201 200.19Z",
    fill: "url(#paint7_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.135 201.295L208.029 200.604C207.891 200.466 207.891 200.328 208.029 200.328L208.306 200.19C208.444 200.051 208.858 200.051 208.997 200.19L210.102 200.88C210.24 201.019 210.24 201.157 210.102 201.157L209.826 201.295C209.687 201.433 209.273 201.433 209.135 201.295Z",
    fill: "url(#paint8_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.865 203.506L211.76 202.815C211.622 202.677 211.622 202.539 211.76 202.539L212.036 202.4C212.174 202.262 212.589 202.262 212.727 202.4L213.832 203.091C213.971 203.229 213.971 203.368 213.832 203.368L213.556 203.506C213.418 203.644 213.003 203.644 212.865 203.506Z",
    fill: "url(#paint9_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.8 204.611L213.694 203.92C213.556 203.782 213.556 203.644 213.694 203.644L213.971 203.506C214.109 203.368 214.523 203.368 214.662 203.506L215.767 204.197C215.905 204.335 215.905 204.473 215.767 204.473L215.491 204.611C215.352 204.749 214.938 204.749 214.8 204.611Z",
    fill: "url(#paint10_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.734 205.854L215.629 205.164C215.491 205.025 215.491 204.887 215.629 204.887L215.905 204.749C216.044 204.611 216.458 204.611 216.596 204.749L217.702 205.44C217.84 205.578 217.84 205.716 217.702 205.716L217.425 205.854C217.287 205.854 216.873 205.854 216.734 205.854Z",
    fill: "url(#paint11_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.668 206.96L217.563 206.269C217.425 206.131 217.425 205.993 217.563 205.993L217.839 205.854C217.978 205.716 218.392 205.716 218.53 205.854L219.636 206.545C219.774 206.683 219.774 206.822 219.636 206.822L219.359 206.96C219.221 206.96 218.807 206.96 218.668 206.96Z",
    fill: "url(#paint12_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.588 193.696L190.483 193.005C190.345 192.867 190.345 192.729 190.483 192.729L191.588 192.176C191.726 192.038 192.141 192.038 192.279 192.176L193.384 192.867C193.523 193.005 193.523 193.143 193.384 193.143L192.279 193.696C192.141 193.834 191.865 193.834 191.588 193.696Z",
    fill: "url(#paint13_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.522 194.801L192.417 194.11C192.278 193.972 192.278 193.834 192.417 193.834L193.522 193.281C193.66 193.143 194.075 193.143 194.213 193.281L195.318 193.972C195.456 194.11 195.456 194.249 195.318 194.249L194.213 194.801C194.075 194.939 193.66 194.939 193.522 194.801Z",
    fill: "url(#paint14_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.457 195.906L194.351 195.216C194.213 195.077 194.213 194.939 194.351 194.939L195.457 194.387C195.595 194.248 196.009 194.248 196.147 194.387L197.253 195.077C197.391 195.216 197.391 195.354 197.253 195.354L196.147 195.906C196.009 196.045 195.595 196.045 195.457 195.906Z",
    fill: "url(#paint15_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.391 197.012L196.286 196.321C196.148 196.183 196.148 196.044 196.286 196.044L197.391 195.492C197.529 195.354 197.944 195.354 198.082 195.492L199.187 196.183C199.325 196.321 199.325 196.459 199.187 196.459L198.082 197.012C197.944 197.15 197.529 197.15 197.391 197.012Z",
    fill: "url(#paint16_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.325 198.117L198.22 197.427C198.082 197.288 198.082 197.15 198.22 197.15L199.325 196.598C199.463 196.459 199.878 196.459 200.016 196.598L201.121 197.288C201.26 197.427 201.26 197.565 201.121 197.565L200.016 198.117C199.878 198.256 199.463 198.256 199.325 198.117Z",
    fill: "url(#paint17_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.121 199.223L200.016 198.532C199.878 198.394 199.878 198.255 200.016 198.255L201.121 197.703C201.259 197.565 201.674 197.565 201.812 197.703L202.917 198.394C203.055 198.532 203.055 198.67 202.917 198.67L201.812 199.223C201.674 199.361 201.397 199.361 201.121 199.223Z",
    fill: "url(#paint18_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.056 200.328L201.95 199.637C201.812 199.499 201.812 199.36 201.95 199.36L203.056 198.808C203.194 198.67 203.608 198.67 203.746 198.808L204.852 199.499C204.99 199.637 204.99 199.775 204.852 199.775L203.746 200.328C203.608 200.466 203.194 200.466 203.056 200.328Z",
    fill: "url(#paint19_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.99 201.433L203.885 200.742C203.747 200.604 203.747 200.466 203.885 200.466L204.99 199.913C205.128 199.775 205.543 199.775 205.681 199.913L206.786 200.604C206.925 200.742 206.925 200.881 206.786 200.881L205.681 201.433C205.543 201.571 205.128 201.571 204.99 201.433Z",
    fill: "url(#paint20_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.924 202.539L205.819 201.848C205.681 201.71 205.681 201.571 205.819 201.571L206.924 201.019C207.062 200.88 207.477 200.88 207.615 201.019L208.72 201.709C208.859 201.848 208.859 201.986 208.72 201.986L207.615 202.539C207.477 202.677 207.062 202.677 206.924 202.539Z",
    fill: "url(#paint21_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.72 203.644L207.615 202.953C207.477 202.815 207.477 202.677 207.615 202.677L208.72 202.124C208.858 201.986 209.273 201.986 209.411 202.124L210.516 202.815C210.655 202.953 210.655 203.091 210.516 203.091L209.411 203.644C209.273 203.782 208.997 203.782 208.72 203.644Z",
    fill: "url(#paint22_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.655 204.749L209.549 204.058C209.411 203.92 209.411 203.782 209.549 203.782L210.655 203.229C210.793 203.091 211.207 203.091 211.346 203.229L212.451 203.92C212.589 204.058 212.589 204.197 212.451 204.197L211.346 204.749C211.207 204.887 210.793 204.887 210.655 204.749Z",
    fill: "url(#paint23_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.589 205.854L211.484 205.164C211.346 205.025 211.346 204.887 211.484 204.887L212.589 204.335C212.727 204.196 213.142 204.196 213.28 204.335L214.385 205.025C214.524 205.164 214.524 205.302 214.385 205.302L213.28 205.854C213.142 205.993 212.727 205.993 212.589 205.854Z",
    fill: "url(#paint24_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.149 208.203L218.254 207.65C218.393 207.512 218.393 207.374 218.254 207.374L215.215 205.578C215.077 205.578 214.938 205.44 214.8 205.44C214.662 205.44 214.524 205.44 214.386 205.44L213.28 205.992C213.142 206.131 213.142 206.269 213.28 206.269L214.386 206.96L216.32 208.065C216.596 208.203 217.011 208.203 217.149 208.203Z",
    fill: "url(#paint25_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.741 208.203L219.636 207.512C219.498 207.374 219.498 207.236 219.636 207.236L219.912 207.098C220.05 206.96 220.465 206.96 220.603 207.098L221.708 207.789C221.847 207.927 221.847 208.065 221.708 208.065L221.432 208.203C221.294 208.341 221.018 208.341 220.741 208.203Z",
    fill: "url(#paint26_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.675 209.309L221.57 208.618C221.432 208.48 221.432 208.342 221.57 208.342L221.846 208.203C221.984 208.065 222.399 208.065 222.537 208.203L223.642 208.894C223.781 209.032 223.781 209.171 223.642 209.171L223.366 209.309C223.228 209.447 222.813 209.447 222.675 209.309Z",
    fill: "url(#paint27_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.61 210.414L223.505 209.723C223.366 209.585 223.366 209.447 223.505 209.447L223.781 209.309C223.919 209.171 224.333 209.171 224.472 209.309L225.577 210C225.715 210.138 225.715 210.276 225.577 210.276L225.301 210.414C225.163 210.552 224.748 210.552 224.61 210.414Z",
    fill: "url(#paint28_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.53 209.447L217.425 208.756C217.287 208.618 217.287 208.48 217.425 208.48L218.53 207.927C218.668 207.789 219.083 207.789 219.221 207.927L220.326 208.618C220.465 208.756 220.465 208.894 220.326 208.894L219.221 209.447C219.083 209.585 218.807 209.585 218.53 209.447Z",
    fill: "url(#paint29_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.464 210.552L219.359 209.861C219.221 209.723 219.221 209.585 219.359 209.585L220.464 209.032C220.602 208.894 221.017 208.894 221.155 209.032L222.26 209.723C222.399 209.861 222.399 209.999 222.26 209.999L221.155 210.552C221.017 210.69 220.602 210.69 220.464 210.552Z",
    fill: "url(#paint30_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.399 211.658L221.294 210.967C221.155 210.829 221.155 210.69 221.294 210.69L222.399 210.138C222.537 210 222.952 210 223.09 210.138L224.195 210.829C224.333 210.967 224.333 211.105 224.195 211.105L223.09 211.658C222.952 211.796 222.537 211.796 222.399 211.658Z",
    fill: "url(#paint31_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.734 210.414L215.629 209.723C215.49 209.585 215.49 209.447 215.629 209.447L216.734 208.894C216.872 208.756 217.287 208.756 217.425 208.894L218.53 209.585C218.668 209.723 218.668 209.861 218.53 209.861L217.425 210.414C217.287 210.552 216.872 210.552 216.734 210.414Z",
    fill: "url(#paint32_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.668 211.519L217.563 210.829C217.425 210.69 217.425 210.552 217.563 210.552L218.668 210C218.807 209.861 219.221 209.861 219.359 210L220.465 210.69C220.603 210.829 220.603 210.967 220.465 210.967L219.359 211.519C219.221 211.658 218.807 211.658 218.668 211.519Z",
    fill: "url(#paint33_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.464 212.625L219.359 211.934C219.221 211.796 219.221 211.658 219.359 211.658L220.464 211.105C220.602 210.967 221.017 210.967 221.155 211.105L222.26 211.796C222.399 211.934 222.399 212.072 222.26 212.072L221.155 212.625C221.017 212.763 220.741 212.763 220.464 212.625Z",
    fill: "url(#paint34_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.417 195.907L193.522 195.354C193.661 195.216 193.661 195.078 193.522 195.078L192.417 194.387L190.483 193.281C190.345 193.143 189.93 193.143 189.792 193.281L188.687 193.834C188.548 193.972 188.548 194.11 188.687 194.11L191.726 195.907C191.864 195.907 192.003 196.045 192.141 196.045C192.141 195.907 192.279 195.907 192.417 195.907Z",
    fill: "url(#paint35_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.661 197.012L192.555 196.321C192.417 196.183 192.417 196.044 192.555 196.044L193.661 195.492C193.799 195.354 194.213 195.354 194.351 195.492L195.457 196.183C195.595 196.321 195.595 196.459 195.457 196.459L194.351 197.012C194.213 197.012 193.799 197.012 193.661 197.012Z",
    fill: "url(#paint36_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.457 198.117L194.351 197.427C194.213 197.288 194.213 197.15 194.351 197.15L195.457 196.598C195.595 196.459 196.009 196.459 196.147 196.598L197.253 197.288C197.391 197.427 197.391 197.565 197.253 197.565L196.147 198.117C196.009 198.117 195.595 198.117 195.457 198.117Z",
    fill: "url(#paint37_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.391 199.223L196.286 198.532C196.148 198.394 196.148 198.255 196.286 198.255L197.391 197.703C197.529 197.565 197.944 197.565 198.082 197.703L199.187 198.394C199.325 198.532 199.325 198.67 199.187 198.67L198.082 199.223C197.944 199.223 197.529 199.223 197.391 199.223Z",
    fill: "url(#paint38_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.325 200.328L198.22 199.637C198.082 199.499 198.082 199.36 198.22 199.36L199.325 198.808C199.463 198.67 199.878 198.67 200.016 198.808L201.121 199.499C201.26 199.637 201.26 199.775 201.121 199.775L200.016 200.328C199.878 200.466 199.463 200.328 199.325 200.328Z",
    fill: "url(#paint39_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.26 201.433L200.154 200.742C200.016 200.604 200.016 200.466 200.154 200.466L201.26 199.913C201.398 199.775 201.812 199.775 201.951 199.913L203.056 200.604C203.194 200.742 203.194 200.881 203.056 200.881L201.951 201.433C201.812 201.571 201.398 201.433 201.26 201.433Z",
    fill: "url(#paint40_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.056 202.539L201.95 201.848C201.812 201.71 201.812 201.571 201.95 201.571L203.056 201.019C203.194 200.88 203.608 200.88 203.746 201.019L204.852 201.709C204.99 201.848 204.99 201.986 204.852 201.986L203.746 202.539C203.608 202.677 203.332 202.677 203.056 202.539Z",
    fill: "url(#paint41_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.99 203.644L203.885 202.953C203.747 202.815 203.747 202.677 203.885 202.677L204.99 202.124C205.128 201.986 205.543 201.986 205.681 202.124L206.786 202.815C206.925 202.953 206.925 203.091 206.786 203.091L205.681 203.644C205.543 203.782 205.128 203.782 204.99 203.644Z",
    fill: "url(#paint42_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.924 204.749L205.819 204.058C205.681 203.92 205.681 203.782 205.819 203.782L206.924 203.229C207.062 203.091 207.477 203.091 207.615 203.229L208.72 203.92C208.859 204.058 208.859 204.197 208.72 204.197L207.615 204.749C207.477 204.887 207.062 204.887 206.924 204.749Z",
    fill: "url(#paint43_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.859 205.854L207.754 205.164C207.615 205.025 207.615 204.887 207.754 204.887L208.859 204.335C208.997 204.196 209.412 204.196 209.55 204.335L210.655 205.025C210.793 205.164 210.793 205.302 210.655 205.302L209.55 205.854C209.412 205.993 208.997 205.993 208.859 205.854Z",
    fill: "url(#paint44_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.793 206.96L209.688 206.269C209.549 206.131 209.549 205.993 209.688 205.993L210.793 205.44C210.931 205.302 211.346 205.302 211.484 205.44L212.589 206.131C212.727 206.269 212.727 206.407 212.589 206.407L211.484 206.96C211.346 207.098 210.931 207.098 210.793 206.96Z",
    fill: "url(#paint45_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.589 208.065L211.484 207.374C211.346 207.236 211.346 207.098 211.484 207.098L212.589 206.545C212.727 206.407 213.142 206.407 213.28 206.545L214.385 207.236C214.524 207.374 214.524 207.512 214.385 207.512L213.28 208.065C213.142 208.203 212.866 208.203 212.589 208.065Z",
    fill: "url(#paint46_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.483 196.874L191.588 196.321C191.726 196.183 191.726 196.045 191.588 196.045L190.483 195.354L188.548 194.248C188.41 194.11 187.996 194.11 187.857 194.248L186.752 194.801C186.614 194.939 186.614 195.077 186.752 195.077L189.792 196.874C189.93 196.874 190.068 197.012 190.206 197.012C190.344 197.012 190.483 197.012 190.483 196.874Z",
    fill: "url(#paint47_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.726 197.979L190.621 197.288C190.483 197.15 190.483 197.012 190.621 197.012L191.726 196.459C191.864 196.321 192.279 196.321 192.417 196.459L193.522 197.15C193.66 197.288 193.66 197.426 193.522 197.426L192.417 197.979C192.279 198.117 191.864 198.117 191.726 197.979Z",
    fill: "url(#paint48_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.661 199.084L192.555 198.394C192.417 198.255 192.417 198.117 192.555 198.117L193.661 197.565C193.799 197.426 194.213 197.426 194.351 197.565L195.457 198.255C195.595 198.394 195.595 198.532 195.457 198.532L194.351 199.084C194.213 199.223 193.799 199.223 193.661 199.084Z",
    fill: "url(#paint49_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.595 200.19L194.489 199.499C194.351 199.361 194.351 199.223 194.489 199.223L195.595 198.67C195.733 198.532 196.147 198.532 196.286 198.67L197.391 199.361C197.529 199.499 197.529 199.637 197.391 199.637L196.286 200.19C196.147 200.328 195.733 200.328 195.595 200.19Z",
    fill: "url(#paint50_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.391 201.295L196.286 200.604C196.148 200.466 196.148 200.328 196.286 200.328L197.391 199.775C197.529 199.637 197.944 199.637 198.082 199.775L199.187 200.466C199.325 200.604 199.325 200.742 199.187 200.742L198.082 201.295C197.944 201.433 197.667 201.433 197.391 201.295Z",
    fill: "url(#paint51_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.325 202.4L198.22 201.709C198.082 201.571 198.082 201.433 198.22 201.433L199.325 200.88C199.463 200.742 199.878 200.742 200.016 200.88L201.121 201.571C201.26 201.709 201.26 201.848 201.121 201.848L200.016 202.4C199.878 202.538 199.463 202.538 199.325 202.4Z",
    fill: "url(#paint52_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.26 203.506L200.154 202.815C200.016 202.677 200.016 202.538 200.154 202.538L201.26 201.986C201.398 201.848 201.812 201.848 201.951 201.986L203.056 202.677C203.194 202.815 203.194 202.953 203.056 202.953L201.951 203.506C201.812 203.644 201.398 203.644 201.26 203.506Z",
    fill: "url(#paint53_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.194 204.611L202.088 203.92C201.95 203.782 201.95 203.644 202.088 203.644L203.194 203.091C203.332 202.953 203.746 202.953 203.885 203.091L204.99 203.782C205.128 203.92 205.128 204.058 204.99 204.058L203.885 204.611C203.746 204.749 203.332 204.749 203.194 204.611Z",
    fill: "url(#paint54_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.128 205.716L204.023 205.026C203.884 204.887 203.884 204.749 204.023 204.749L205.128 204.197C205.266 204.058 205.681 204.058 205.819 204.197L206.924 204.887C207.062 205.026 207.062 205.164 206.924 205.164L205.819 205.716C205.681 205.855 205.266 205.855 205.128 205.716Z",
    fill: "url(#paint55_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.924 206.822L205.819 206.131C205.681 205.993 205.681 205.855 205.819 205.855L206.924 205.302C207.062 205.164 207.477 205.164 207.615 205.302L208.72 205.993C208.859 206.131 208.859 206.269 208.72 206.269L207.615 206.96C207.477 206.96 207.201 206.96 206.924 206.822Z",
    fill: "url(#paint56_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.859 207.927L207.754 207.236C207.615 207.098 207.615 206.96 207.754 206.96L208.859 206.407C208.997 206.269 209.412 206.269 209.55 206.407L210.655 207.098C210.793 207.236 210.793 207.374 210.655 207.374L209.55 207.927C209.412 208.065 208.997 208.065 208.859 207.927Z",
    fill: "url(#paint57_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.418 210.276L214.523 209.723L216.32 208.618C216.458 208.48 216.458 208.342 216.32 208.342L215.214 207.651C215.076 207.513 214.662 207.513 214.523 207.651L213.004 208.48L211.484 207.513C211.346 207.374 210.931 207.374 210.793 207.513L209.688 208.065C209.549 208.203 209.549 208.342 209.688 208.342L212.727 210.138C212.865 210.138 213.004 210.276 213.142 210.276C213.142 210.276 213.28 210.276 213.418 210.276Z",
    fill: "url(#paint58_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.345 199.084C190.483 199.084 190.483 199.084 190.345 199.084C190.483 199.084 190.621 199.084 190.621 199.084L191.726 198.532C191.864 198.532 191.864 198.394 191.864 198.394C191.864 198.394 191.864 198.255 191.726 198.255L190.621 197.565L188.687 196.459L186.752 195.354C186.614 195.216 186.2 195.216 186.061 195.354L184.956 195.907C184.818 196.045 184.818 196.183 184.956 196.183L189.93 199.084C189.93 199.084 190.068 199.084 190.345 199.084C190.206 199.084 190.345 199.084 190.345 199.084Z",
    fill: "url(#paint59_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.726 200.19L190.621 199.499C190.483 199.361 190.483 199.223 190.621 199.223L191.726 198.67C191.864 198.532 192.279 198.532 192.417 198.67L193.522 199.361C193.66 199.499 193.66 199.637 193.522 199.637L192.417 200.19C192.279 200.19 192.002 200.19 191.726 200.19Z",
    fill: "url(#paint60_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.661 201.295L192.555 200.604C192.417 200.466 192.417 200.328 192.555 200.328L193.661 199.775C193.799 199.637 194.213 199.637 194.351 199.775L195.457 200.466C195.595 200.604 195.595 200.742 195.457 200.742L194.351 201.295C194.213 201.295 193.799 201.295 193.661 201.295Z",
    fill: "url(#paint61_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.595 202.4L194.489 201.709C194.351 201.571 194.351 201.433 194.489 201.433L195.595 200.88C195.733 200.742 196.147 200.742 196.286 200.88L197.391 201.571C197.529 201.709 197.529 201.848 197.391 201.848L196.286 202.4C196.147 202.538 195.733 202.4 195.595 202.4Z",
    fill: "url(#paint62_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.529 203.506L196.423 202.815C196.285 202.677 196.285 202.538 196.423 202.538L197.529 201.986C197.667 201.848 198.081 201.848 198.22 201.986L199.325 202.677C199.463 202.815 199.463 202.953 199.325 202.953L198.22 203.506C198.081 203.644 197.667 203.506 197.529 203.506Z",
    fill: "url(#paint63_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.463 204.611L198.358 203.92C198.22 203.782 198.22 203.644 198.358 203.644L199.463 203.091C199.602 202.953 200.016 202.953 200.154 203.091L201.259 203.782C201.398 203.92 201.398 204.058 201.259 204.058L200.154 204.611C200.016 204.749 199.602 204.749 199.463 204.611Z",
    fill: "url(#paint64_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.26 205.716L200.154 205.026C200.016 204.887 200.016 204.749 200.154 204.749L201.26 204.197C201.398 204.058 201.812 204.058 201.951 204.197L203.056 204.887C203.194 205.026 203.194 205.164 203.056 205.164L201.951 205.716C201.812 205.855 201.536 205.855 201.26 205.716Z",
    fill: "url(#paint65_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.194 206.822L202.088 206.131C201.95 205.993 201.95 205.855 202.088 205.855L203.194 205.302C203.332 205.164 203.746 205.164 203.885 205.302L204.99 205.993C205.128 206.131 205.128 206.269 204.99 206.269L203.885 206.822C203.746 206.96 203.332 206.96 203.194 206.822Z",
    fill: "url(#paint66_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.128 207.927L204.023 207.236C203.884 207.098 203.884 206.96 204.023 206.96L205.128 206.407C205.266 206.269 205.681 206.269 205.819 206.407L206.924 207.098C207.062 207.236 207.062 207.374 206.924 207.374L205.819 207.927C205.681 208.065 205.266 208.065 205.128 207.927Z",
    fill: "url(#paint67_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.89 198.946L187.996 198.394C188.134 198.255 188.134 198.117 187.996 198.117L184.956 196.321C184.818 196.183 184.403 196.183 184.265 196.321L183.16 196.874C183.022 197.012 183.022 197.15 183.16 197.15L185.094 198.255L186.199 198.946C186.338 198.946 186.476 199.084 186.614 199.084C186.614 199.084 186.752 199.084 186.89 198.946Z",
    fill: "url(#paint68_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.996 200.051L186.89 199.361C186.752 199.222 186.752 199.084 186.89 199.084L187.996 198.532C188.134 198.393 188.548 198.393 188.686 198.532L189.792 199.222C189.93 199.361 189.93 199.499 189.792 199.499L188.686 200.051C188.548 200.19 188.134 200.19 187.996 200.051Z",
    fill: "url(#paint69_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.93 201.157L188.824 200.466C188.686 200.328 188.686 200.19 188.824 200.19L189.93 199.637C190.068 199.499 190.482 199.499 190.62 199.637L191.726 200.328C191.864 200.466 191.864 200.604 191.726 200.604L190.62 201.157C190.482 201.295 190.068 201.295 189.93 201.157Z",
    fill: "url(#paint70_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.398 207.789L200.293 207.098C200.154 206.96 200.154 206.822 200.293 206.822L201.398 206.269C201.536 206.131 201.951 206.131 202.089 206.269L203.194 206.96C203.332 207.098 203.332 207.236 203.194 207.236L202.089 207.789C201.951 207.927 201.536 207.927 201.398 207.789Z",
    fill: "url(#paint71_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.194 208.894L202.088 208.342C201.95 208.203 201.95 208.065 202.088 208.065L203.194 207.513C203.332 207.374 203.746 207.374 203.885 207.513L204.99 208.203C205.128 208.342 205.128 208.48 204.99 208.48L203.885 209.032C203.746 209.032 203.47 209.032 203.194 208.894Z",
    fill: "url(#paint72_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.128 209.999L204.023 209.309C203.884 209.17 203.884 209.032 204.023 209.032L205.128 208.48C205.266 208.341 205.681 208.341 205.819 208.48L206.924 209.17C207.062 209.309 207.062 209.447 206.924 209.447L205.819 209.999C205.681 210.138 205.266 210.138 205.128 209.999Z",
    fill: "url(#paint73_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.688 212.348L210.793 211.796C210.931 211.658 210.931 211.519 210.793 211.519L207.753 209.723C207.615 209.585 207.201 209.585 207.062 209.723L205.957 210.276C205.819 210.414 205.819 210.552 205.957 210.552L208.997 212.348C209.135 212.348 209.549 212.348 209.688 212.348Z",
    fill: "url(#paint74_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.937 213.592L213.832 212.901C213.694 212.763 213.694 212.625 213.832 212.625L214.937 212.072C215.076 211.934 215.49 211.934 215.628 212.072L216.734 212.763C216.872 212.901 216.872 213.039 216.734 213.039L215.628 213.592C215.49 213.73 215.076 213.73 214.937 213.592Z",
    fill: "url(#paint75_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.207 213.592L210.102 212.901C209.964 212.763 209.964 212.625 210.102 212.625L211.207 212.072C211.346 211.934 211.76 211.934 211.898 212.072L213.004 212.763C213.142 212.901 213.142 213.039 213.004 213.039L211.898 213.592C211.76 213.73 211.346 213.592 211.207 213.592Z",
    fill: "url(#paint76_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.004 214.697L211.899 214.006C211.76 213.868 211.76 213.73 211.899 213.73L213.004 213.177C213.142 213.039 213.557 213.039 213.695 213.177L214.8 213.868C214.938 214.006 214.938 214.145 214.8 214.145L213.695 214.697C213.557 214.835 213.28 214.697 213.004 214.697Z",
    fill: "url(#paint77_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.938 215.803L213.833 215.112C213.695 214.974 213.695 214.835 213.833 214.835L214.938 214.283C215.077 214.145 215.491 214.145 215.629 214.283L216.735 214.974C216.873 215.112 216.873 215.25 216.735 215.25L215.629 215.803C215.491 215.941 215.077 215.941 214.938 215.803Z",
    fill: "url(#paint78_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.154 206.822L201.26 206.269C201.398 206.131 201.398 205.993 201.26 205.993L192.555 200.88C192.417 200.742 192.002 200.742 191.864 200.88L190.759 201.433C190.621 201.571 190.621 201.709 190.759 201.709L198.358 206.131L199.463 206.822C199.602 206.822 200.016 206.822 200.154 206.822Z",
    fill: "url(#paint79_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.793 211.243L205.819 208.342C205.681 208.203 205.681 208.065 205.819 208.065L206.924 207.513C207.062 207.374 207.477 207.374 207.615 207.513L212.589 210.414C212.727 210.552 212.727 210.69 212.589 210.69L211.484 211.243C211.346 211.381 210.931 211.381 210.793 211.243Z",
    fill: "url(#paint80_linear_293_11642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.326 208.341L219.221 207.65C219.082 207.512 218.668 207.512 218.53 207.65L217.424 208.203C217.286 208.341 217.286 208.48 217.424 208.48L218.53 209.17C218.668 209.309 219.082 209.309 219.221 209.17L220.326 208.618C220.464 208.618 220.464 208.479 220.326 208.341Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.713 199.222L203.608 198.532C203.47 198.393 203.055 198.393 202.917 198.532L201.812 199.084C201.673 199.222 201.673 199.361 201.812 199.361L202.917 200.051C203.055 200.19 203.47 200.19 203.608 200.051L204.713 199.499C204.989 199.499 204.989 199.361 204.713 199.222Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.648 200.742C206.786 200.604 206.786 200.466 206.648 200.466L205.542 199.775C205.404 199.637 204.99 199.637 204.852 199.775L203.746 200.328C203.608 200.466 203.608 200.604 203.746 200.604L204.852 201.295C204.99 201.433 205.404 201.433 205.542 201.295L206.648 200.742Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.253 197.012L196.147 196.321C196.009 196.183 195.595 196.183 195.457 196.321L194.351 196.874C194.213 197.012 194.213 197.15 194.351 197.15L195.457 197.841C195.595 197.979 196.009 197.979 196.147 197.841L197.253 197.288C197.391 197.15 197.391 197.012 197.253 197.012Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.049 198.117L197.943 197.426C197.805 197.288 197.391 197.288 197.252 197.426L196.147 197.979C196.009 198.117 196.009 198.255 196.147 198.255L197.252 198.946C197.391 199.084 197.805 199.084 197.943 198.946L199.049 198.393C199.325 198.255 199.325 198.255 199.049 198.117Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.116 207.098L215.076 205.302C214.938 205.302 214.8 205.164 214.662 205.164C214.523 205.164 214.385 205.164 214.247 205.164L213.142 205.716C213.004 205.854 213.004 205.993 213.142 205.993L214.247 206.683L216.181 207.789C216.32 207.927 216.734 207.927 216.872 207.789L217.978 207.236C218.254 207.236 218.254 207.098 218.116 207.098Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.312 203.644L211.207 202.953C211.069 202.815 210.654 202.815 210.516 202.953L209.411 203.505C209.273 203.644 209.273 203.782 209.411 203.782L210.516 204.473C210.654 204.611 211.069 204.611 211.207 204.473L212.312 203.92C212.589 203.92 212.589 203.782 212.312 203.644Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.852 201.433L203.746 200.742C203.608 200.604 203.194 200.604 203.056 200.742L201.95 201.295C201.812 201.433 201.812 201.571 201.95 201.571L203.056 202.262C203.194 202.4 203.608 202.4 203.746 202.262L204.852 201.709C204.99 201.709 204.99 201.571 204.852 201.433Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.049 196.321C199.187 196.183 199.187 196.044 199.049 196.044L197.943 195.354C197.805 195.215 197.391 195.215 197.252 195.354L196.147 195.906C196.009 196.044 196.009 196.183 196.147 196.183L197.252 196.873C197.391 197.012 197.805 197.012 197.943 196.873L199.049 196.321Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.247 204.749L213.141 204.196C213.003 204.058 212.589 204.058 212.451 204.196L211.345 204.749C211.207 204.887 211.207 205.025 211.345 205.025L212.451 205.716C212.589 205.854 213.003 205.854 213.141 205.716L214.247 205.163C214.523 205.025 214.523 204.887 214.247 204.749Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.648 202.538L205.542 201.848C205.404 201.709 204.99 201.709 204.852 201.848L203.746 202.4C203.608 202.538 203.608 202.677 203.746 202.677L204.852 203.367C204.99 203.506 205.404 203.506 205.542 203.367L206.648 202.815C206.924 202.815 206.924 202.677 206.648 202.538Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.786 202.953L205.681 203.506C205.543 203.644 205.543 203.782 205.681 203.782L206.786 204.473C206.924 204.611 207.339 204.611 207.477 204.473L208.582 203.92C208.72 203.782 208.72 203.644 208.582 203.644L207.477 202.953C207.339 202.953 206.924 202.815 206.786 202.953Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.186 198.532L198.081 199.084C197.943 199.222 197.943 199.361 198.081 199.361L199.186 200.051C199.325 200.19 199.739 200.19 199.877 200.051L200.983 199.499C201.121 199.361 201.121 199.222 200.983 199.222L199.877 198.532C199.739 198.393 199.325 198.393 199.186 198.532Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.219 203.782L199.325 204.473C199.463 204.611 199.877 204.611 200.016 204.473L201.121 203.92C201.259 203.782 201.259 203.644 201.121 203.644L200.016 202.953C199.877 202.815 199.463 202.815 199.325 202.953L198.219 203.505C198.081 203.505 198.081 203.644 198.219 203.782Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.285 202.677L197.39 203.367C197.528 203.506 197.943 203.506 198.081 203.367L199.186 202.815C199.324 202.677 199.324 202.538 199.186 202.538L198.081 201.848C197.943 201.709 197.528 201.709 197.39 201.848L196.285 202.4C196.147 202.4 196.147 202.538 196.285 202.677Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.489 201.571L195.594 202.262C195.732 202.4 196.147 202.4 196.285 202.262L197.39 201.709C197.529 201.571 197.529 201.433 197.39 201.433L196.285 200.742C196.147 200.604 195.732 200.604 195.594 200.742L194.489 201.295C194.213 201.295 194.213 201.433 194.489 201.571Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.088 205.993L203.193 206.684C203.332 206.822 203.746 206.822 203.884 206.684L204.99 206.131C205.128 205.993 205.128 205.855 204.99 205.855L203.884 205.164C203.746 205.026 203.332 205.026 203.193 205.164L202.088 205.578C201.812 205.716 201.812 205.855 202.088 205.993Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.154 204.887L201.259 205.578C201.397 205.716 201.812 205.716 201.95 205.578L203.055 205.025C203.194 204.887 203.194 204.749 203.055 204.749L201.95 204.058C201.812 203.92 201.397 203.92 201.259 204.058L200.154 204.611C200.016 204.611 200.016 204.749 200.154 204.887Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.417 195.768C192.278 195.906 192.278 196.044 192.417 196.044L193.522 196.735C193.66 196.873 194.075 196.873 194.213 196.735L195.318 196.183C195.456 196.044 195.456 195.906 195.318 195.906L194.213 195.215C194.075 195.077 193.66 195.077 193.522 195.215L192.417 195.768Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.62 196.874C190.482 197.012 190.482 197.15 190.62 197.15L191.726 197.841C191.864 197.979 192.278 197.979 192.416 197.841L193.522 197.288C193.66 197.15 193.66 197.012 193.522 197.012L192.416 196.321C192.278 196.183 191.864 196.183 191.726 196.321L190.62 196.874Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.114 194.801L196.009 194.11C195.871 193.972 195.456 193.972 195.318 194.11L194.213 194.663C194.074 194.801 194.074 194.939 194.213 194.939L195.318 195.63C195.456 195.768 195.871 195.768 196.009 195.63L197.114 195.077C197.39 195.077 197.39 194.939 197.114 194.801Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.62 198.946C190.482 199.084 190.482 199.222 190.62 199.222L191.726 199.913C191.864 200.051 192.278 200.051 192.416 199.913L193.522 199.36C193.66 199.222 193.66 199.084 193.522 199.084L192.416 198.393C192.278 198.255 191.864 198.255 191.726 198.393L190.62 198.946Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.555 198.255L193.66 198.946C193.798 199.084 194.213 199.084 194.351 198.946L195.456 198.393C195.595 198.255 195.595 198.117 195.456 198.117L194.351 197.426C194.213 197.288 193.798 197.288 193.66 197.426L192.555 197.979C192.279 197.979 192.279 198.117 192.555 198.255Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.555 200.466L193.66 201.157C193.798 201.295 194.213 201.295 194.351 201.157L195.456 200.604C195.594 200.466 195.594 200.328 195.456 200.328L194.351 199.637C194.213 199.499 193.798 199.499 193.66 199.637L192.555 200.19C192.417 200.19 192.417 200.328 192.555 200.466Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.285 200.466L197.39 201.157C197.528 201.295 197.943 201.295 198.081 201.157L199.186 200.604C199.324 200.466 199.324 200.328 199.186 200.328L198.081 199.637C197.943 199.499 197.528 199.499 197.39 199.637L196.285 200.19C196.147 200.19 196.147 200.328 196.285 200.466Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.022 207.098L205.128 207.789C205.266 207.927 205.68 207.927 205.818 207.789L206.924 207.236C207.062 207.098 207.062 206.959 206.924 206.959L205.818 206.269C205.68 206.13 205.266 206.13 205.128 206.269L204.022 206.821C203.746 206.821 203.746 206.96 204.022 207.098Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.056 210.552L222.951 209.861C222.813 209.723 222.398 209.723 222.26 209.861L221.155 210.414C221.017 210.552 221.017 210.69 221.155 210.69L222.26 211.381C222.398 211.519 222.813 211.519 222.951 211.381L224.056 210.828C224.333 210.828 224.195 210.69 224.056 210.552Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.122 209.447L221.017 208.756C220.879 208.618 220.464 208.618 220.326 208.756L219.221 209.308C219.083 209.447 219.083 209.585 219.221 209.585L220.326 210.276C220.464 210.414 220.879 210.414 221.017 210.276L222.122 209.723C222.399 209.723 222.399 209.585 222.122 209.447Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.516 204.749L209.411 204.058C209.273 203.92 208.858 203.92 208.72 204.058L207.615 204.611C207.477 204.749 207.477 204.887 207.615 204.887L208.72 205.578C208.858 205.716 209.273 205.716 209.411 205.578L210.516 205.025C210.655 205.025 210.655 204.887 210.516 204.749Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.424 210.276L218.53 209.723C218.668 209.585 218.668 209.447 218.53 209.447L217.424 208.756C217.286 208.618 216.872 208.618 216.733 208.756L215.628 209.308C215.49 209.447 215.49 209.585 215.628 209.585L216.733 210.276C216.872 210.414 217.286 210.414 217.424 210.276Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.818 205.993L206.924 206.684C207.062 206.822 207.476 206.822 207.615 206.684L208.72 206.131C208.858 205.993 208.858 205.855 208.72 205.855L207.615 205.164C207.476 205.026 207.062 205.026 206.924 205.164L205.818 205.716C205.68 205.855 205.68 205.855 205.818 205.993Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.483 207.236L212.588 207.927C212.727 208.065 213.141 208.065 213.279 207.927L214.384 207.374C214.523 207.236 214.523 207.098 214.384 207.098L213.279 206.407C213.141 206.269 212.727 206.269 212.588 206.407L211.483 206.96C211.345 206.96 211.345 207.098 211.483 207.236Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.753 207.098L208.858 207.789C208.997 207.927 209.411 207.927 209.549 207.789L210.655 207.236C210.793 207.098 210.793 206.959 210.655 206.959L209.549 206.269C209.411 206.13 208.997 206.13 208.858 206.269L207.753 206.821C207.477 206.959 207.477 207.098 207.753 207.098Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.451 205.855L211.346 205.164C211.207 205.026 210.793 205.026 210.655 205.164L209.549 205.716C209.411 205.855 209.411 205.993 209.549 205.993L210.655 206.684C210.793 206.822 211.207 206.822 211.346 206.684L212.451 206.131C212.589 206.131 212.589 205.993 212.451 205.855Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.687 208.203L212.727 209.999C212.865 209.999 213.003 210.137 213.141 210.137C213.28 210.137 213.418 210.137 213.556 210.137L214.661 209.585L216.457 208.479C216.596 208.341 216.596 208.203 216.457 208.203L215.352 207.512C215.214 207.374 214.799 207.374 214.661 207.512L213.141 208.341L211.622 207.374C211.483 207.236 211.069 207.236 210.931 207.374L209.825 207.927C209.411 208.065 209.411 208.203 209.687 208.203Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.016 200.604L201.121 201.295C201.259 201.433 201.674 201.433 201.812 201.295L202.917 200.742C203.055 200.604 203.055 200.466 202.917 200.466L201.812 199.775C201.674 199.637 201.259 199.637 201.121 199.775L200.016 200.328C199.878 200.328 199.878 200.466 200.016 200.604Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.253 199.084L196.147 198.393C196.009 198.255 195.595 198.255 195.457 198.393L194.351 198.946C194.213 199.084 194.213 199.222 194.351 199.222L195.457 199.913C195.595 200.051 196.009 200.051 196.147 199.913L197.253 199.36C197.391 199.36 197.391 199.222 197.253 199.084Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.884 204.887L204.989 205.578C205.127 205.716 205.542 205.716 205.68 205.578L206.785 205.025C206.924 204.887 206.924 204.749 206.785 204.749L205.68 204.058C205.542 203.92 205.127 203.92 204.989 204.058L203.884 204.611C203.746 204.749 203.746 204.749 203.884 204.887Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.219 201.571L199.325 202.262C199.463 202.4 199.877 202.4 200.016 202.262L201.121 201.709C201.259 201.571 201.259 201.433 201.121 201.433L200.016 200.742C199.877 200.604 199.463 200.604 199.325 200.742L198.219 201.295C198.081 201.295 198.081 201.433 198.219 201.571Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.95 203.782L203.056 204.473C203.194 204.611 203.608 204.611 203.746 204.473L204.852 203.92C204.99 203.782 204.99 203.644 204.852 203.644L203.746 202.953C203.608 202.815 203.194 202.815 203.056 202.953L201.95 203.505C201.812 203.644 201.812 203.644 201.95 203.782Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.154 202.677L201.259 203.367C201.398 203.506 201.812 203.506 201.95 203.367L203.056 202.815C203.194 202.677 203.194 202.538 203.056 202.538L201.95 201.848C201.812 201.709 201.398 201.709 201.259 201.848L200.154 202.4C199.878 202.4 199.878 202.538 200.154 202.677Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.206 196.735C190.344 196.735 190.482 196.735 190.62 196.735L191.726 196.183C191.864 196.045 191.864 195.906 191.726 195.906L190.62 195.216L188.686 194.11C188.548 193.972 188.133 193.972 187.995 194.11L186.89 194.663C186.752 194.801 186.752 194.939 186.89 194.939L189.929 196.735C189.929 196.735 190.068 196.735 190.206 196.735Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.206 198.946C190.344 198.946 190.344 198.946 190.344 198.946H190.482L191.588 198.393C191.726 198.393 191.726 198.255 191.726 198.255C191.726 198.255 191.726 198.117 191.588 198.117L190.482 197.426L188.548 196.321L186.614 195.215C186.475 195.077 186.061 195.077 185.923 195.215L184.817 195.768C184.679 195.906 184.679 196.044 184.817 196.044L189.791 198.946C189.93 198.808 190.068 198.946 190.206 198.946Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.818 208.203L210.792 211.105C210.931 211.243 211.345 211.243 211.483 211.105L212.589 210.552C212.727 210.414 212.727 210.276 212.589 210.276L207.615 207.374C207.476 207.236 207.062 207.236 206.924 207.374L205.818 207.927C205.68 207.927 205.68 208.065 205.818 208.203Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.791 199.36C189.929 199.222 189.929 199.084 189.791 199.084L188.686 198.393C188.548 198.255 188.133 198.255 187.995 198.393L186.89 198.946C186.752 199.084 186.752 199.222 186.89 199.222L187.995 199.913C188.133 200.051 188.548 200.051 188.686 199.913L189.791 199.36Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.278 193.558L193.384 193.005C193.522 192.867 193.522 192.729 193.384 192.729L192.278 192.038C192.14 191.9 191.726 191.9 191.587 192.038L190.482 192.59C190.344 192.729 190.344 192.867 190.482 192.867L191.587 193.558C191.726 193.558 192.14 193.558 192.278 193.558Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.857 198.255C187.995 198.117 187.995 197.979 187.857 197.979L184.817 196.183C184.679 196.045 184.265 196.045 184.126 196.183L183.021 196.736C182.883 196.874 182.883 197.012 183.021 197.012L184.955 198.117L186.061 198.808C186.199 198.808 186.337 198.946 186.475 198.946C186.613 198.946 186.752 198.946 186.89 198.946L187.857 198.255Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.292 195.768C200.153 195.906 200.153 196.044 200.292 196.044L201.397 196.735C201.535 196.873 201.95 196.873 202.088 196.735L202.364 196.597C202.502 196.459 202.502 196.321 202.364 196.321L201.259 195.63C201.121 195.492 200.706 195.492 200.568 195.63L200.292 195.768Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.587 200.466C191.725 200.328 191.725 200.19 191.587 200.19L190.482 199.499C190.344 199.361 189.929 199.361 189.791 199.499L188.686 200.052C188.547 200.19 188.547 200.328 188.686 200.328L189.791 201.019C189.929 201.157 190.344 201.157 190.482 201.019L191.587 200.466Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.358 194.663C198.219 194.801 198.219 194.939 198.358 194.939L199.463 195.63C199.601 195.768 200.016 195.768 200.154 195.63L200.43 195.492C200.568 195.354 200.568 195.215 200.43 195.215L199.325 194.525C199.187 194.386 198.772 194.386 198.634 194.525L198.358 194.663Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.417 193.696C192.278 193.834 192.278 193.972 192.417 193.972L193.522 194.663C193.66 194.801 194.075 194.801 194.213 194.663L195.318 194.11C195.456 193.972 195.456 193.834 195.318 193.834L194.213 193.143C194.075 193.005 193.66 193.005 193.522 193.143L192.417 193.696Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.489 192.314L194.765 192.176C194.903 192.038 194.903 191.9 194.765 191.9L193.66 191.209C193.521 191.071 193.107 191.071 192.969 191.209L192.692 191.347C192.554 191.485 192.554 191.623 192.692 191.623L193.798 192.314C193.936 192.314 194.35 192.314 194.489 192.314Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.562 193.558C196.423 193.696 196.423 193.834 196.562 193.834L197.667 194.525C197.805 194.663 198.22 194.663 198.358 194.525L198.634 194.387C198.772 194.249 198.772 194.11 198.634 194.11L197.529 193.42C197.391 193.281 196.976 193.281 196.838 193.42L196.562 193.558Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.734 214.973C216.872 214.835 216.872 214.697 216.734 214.697L215.628 214.006C215.49 213.868 215.076 213.868 214.937 214.006L213.832 214.559C213.694 214.697 213.694 214.835 213.832 214.835L214.937 215.526C215.076 215.664 215.49 215.664 215.628 215.526L216.734 214.973Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.186 196.321L198.081 196.873C197.943 197.012 197.943 197.15 198.081 197.15L199.186 197.841C199.325 197.979 199.739 197.979 199.877 197.841L200.983 197.288C201.121 197.15 201.121 197.012 200.983 197.012L199.877 196.321C199.739 196.321 199.325 196.321 199.186 196.321Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.8 213.868C214.938 213.73 214.938 213.592 214.8 213.592L213.694 212.901C213.556 212.763 213.142 212.763 213.003 212.901L211.898 213.454C211.76 213.592 211.76 213.73 211.898 213.73L213.003 214.421C213.142 214.559 213.556 214.559 213.694 214.421L214.8 213.868Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.055 207.098C203.194 206.96 203.194 206.822 203.055 206.822L201.95 206.131C201.812 205.993 201.397 205.993 201.259 206.131L200.154 206.683C200.016 206.822 200.016 206.96 200.154 206.96L201.259 207.651C201.397 207.789 201.812 207.789 201.95 207.651L203.055 207.098Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.121 205.993C201.259 205.854 201.259 205.716 201.121 205.716L192.416 200.604C192.278 200.466 191.864 200.466 191.726 200.604L190.62 201.157C190.482 201.295 190.482 201.433 190.62 201.433L198.219 205.854L199.325 206.545C199.463 206.683 199.877 206.683 200.016 206.545L201.121 205.993Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.989 208.203C205.128 208.065 205.128 207.927 204.989 207.927L203.884 207.236C203.746 207.098 203.331 207.098 203.193 207.236L202.088 207.789C201.95 207.927 201.95 208.065 202.088 208.065L203.193 208.756C203.331 208.894 203.746 208.894 203.884 208.756L204.989 208.203Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.865 212.762C213.003 212.624 213.003 212.486 212.865 212.486L211.76 211.795C211.621 211.657 211.207 211.657 211.069 211.795L209.963 212.348C209.825 212.486 209.825 212.624 209.963 212.624L211.069 213.315C211.207 213.453 211.621 213.453 211.76 213.315L212.865 212.762Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.654 211.519C210.792 211.381 210.792 211.243 210.654 211.243L207.615 209.447C207.476 209.308 207.062 209.308 206.924 209.447L205.818 209.999C205.68 210.137 205.68 210.276 205.818 210.276L208.858 212.072C208.996 212.21 209.411 212.21 209.549 212.072L210.654 211.519Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.924 209.308C207.062 209.17 207.062 209.032 206.924 209.032L205.819 208.341C205.681 208.203 205.266 208.203 205.128 208.341L204.023 208.894C203.884 209.032 203.884 209.17 204.023 209.17L205.128 209.861C205.266 209.999 205.681 209.999 205.819 209.861L206.924 209.308Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.002 195.768C192.14 195.768 192.278 195.768 192.416 195.768L193.521 195.215C193.66 195.077 193.66 194.939 193.521 194.939L192.416 194.248L190.482 193.143C190.344 193.005 189.929 193.005 189.791 193.143L188.686 193.696C188.547 193.834 188.547 193.972 188.686 193.972L191.725 195.768C191.725 195.63 191.863 195.768 192.002 195.768Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.359 211.796L220.464 212.486C220.602 212.625 221.017 212.625 221.155 212.486L222.26 211.934C222.399 211.796 222.399 211.657 222.26 211.657L221.155 210.967C221.017 210.828 220.602 210.828 220.464 210.967L219.359 211.519C219.221 211.658 219.221 211.796 219.359 211.796Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.221 211.381L220.326 210.828C220.464 210.69 220.464 210.552 220.326 210.552L219.221 209.861C219.082 209.723 218.668 209.723 218.53 209.861L217.424 210.414C217.286 210.552 217.286 210.69 217.424 210.69L218.53 211.381C218.806 211.519 219.082 211.519 219.221 211.381Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.016 198.117C199.878 198.255 199.878 198.394 200.016 198.394L201.121 199.084C201.259 199.223 201.674 199.223 201.812 199.084L202.917 198.532C203.055 198.394 203.055 198.255 202.917 198.255L201.812 197.565C201.674 197.426 201.259 197.426 201.121 197.565L200.016 198.117Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.694 212.486C213.556 212.625 213.556 212.763 213.694 212.763L214.8 213.454C214.938 213.592 215.352 213.592 215.491 213.454L216.596 212.901C216.734 212.763 216.734 212.625 216.596 212.625L215.491 211.934C215.352 211.796 214.938 211.796 214.8 211.934L213.694 212.486Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.504 209.17C223.366 209.308 223.366 209.447 223.504 209.447L224.609 210.137C224.748 210.276 225.162 210.276 225.3 210.137L225.577 209.999C225.715 209.861 225.715 209.723 225.577 209.723L224.471 209.032C224.333 208.894 223.919 208.894 223.78 209.032L223.504 209.17Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.615 202.539C207.477 202.677 207.477 202.815 207.615 202.815L208.72 203.506C208.858 203.644 209.273 203.644 209.411 203.506L210.516 202.953C210.655 202.815 210.655 202.677 210.516 202.677L209.411 201.986C209.273 201.848 208.858 201.848 208.72 201.986L207.615 202.539Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.891 200.19C207.753 200.328 207.753 200.466 207.891 200.466L208.997 201.157C209.135 201.295 209.549 201.295 209.687 201.157L209.964 201.019C210.102 200.88 210.102 200.742 209.964 200.742L208.997 200.051C208.858 199.913 208.444 199.913 208.306 200.051L207.891 200.19Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.786 200.88L205.68 201.433C205.542 201.571 205.542 201.709 205.68 201.709L206.786 202.4C206.924 202.538 207.338 202.538 207.476 202.4L208.582 201.847C208.72 201.709 208.72 201.571 208.582 201.571L207.476 200.88C207.338 200.742 206.924 200.742 206.786 200.88Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.095 199.085C205.957 199.223 205.957 199.361 206.095 199.361L207.201 200.052C207.339 200.19 207.753 200.19 207.891 200.052L208.168 199.914C208.306 199.775 208.306 199.637 208.168 199.637L207.063 198.946C206.924 198.808 206.51 198.808 206.372 198.946L206.095 199.085Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.161 197.979C204.023 198.117 204.023 198.255 204.161 198.255L205.266 198.946C205.404 199.084 205.819 199.084 205.957 198.946L206.233 198.808C206.371 198.67 206.371 198.532 206.233 198.532L205.128 197.841C204.99 197.703 204.575 197.703 204.437 197.841L204.161 197.979Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.694 203.506C213.556 203.644 213.556 203.782 213.694 203.782L214.8 204.473C214.938 204.611 215.352 204.611 215.491 204.473L215.767 204.335C215.905 204.197 215.905 204.058 215.767 204.058L214.662 203.368C214.523 203.229 214.109 203.229 213.971 203.368L213.694 203.506Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.424 205.716C217.286 205.854 217.286 205.992 217.424 205.992L218.53 206.683C218.668 206.821 219.082 206.821 219.221 206.683L219.497 206.545C219.635 206.407 219.635 206.269 219.497 206.269L218.392 205.578C218.253 205.44 217.839 205.44 217.701 205.578L217.424 205.716Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.635 206.96C219.497 207.098 219.497 207.236 219.635 207.236L220.74 207.927C220.878 208.065 221.293 208.065 221.431 207.927L221.707 207.789C221.846 207.651 221.846 207.512 221.707 207.512L220.602 206.822C220.464 206.683 220.049 206.683 219.911 206.822L219.635 206.96Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.49 204.611C215.352 204.749 215.352 204.887 215.49 204.887L216.596 205.578C216.734 205.716 217.148 205.716 217.287 205.578L217.563 205.44C217.701 205.302 217.701 205.164 217.563 205.164L216.458 204.473C216.319 204.335 215.905 204.335 215.767 204.473L215.49 204.611Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.569 208.065C221.431 208.203 221.431 208.341 221.569 208.341L222.675 209.032C222.813 209.17 223.227 209.17 223.366 209.032L223.642 208.894C223.78 208.756 223.78 208.618 223.642 208.618L222.537 207.927C222.398 207.789 221.984 207.789 221.846 207.927L221.569 208.065Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.76 202.4C211.622 202.538 211.622 202.676 211.76 202.676L212.865 203.367C213.003 203.505 213.418 203.505 213.556 203.367L213.832 203.229C213.971 203.091 213.971 202.953 213.832 202.953L212.727 202.262C212.589 202.124 212.174 202.124 212.036 202.262L211.76 202.4Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.049 198.117L197.943 197.426C197.805 197.288 197.391 197.288 197.252 197.426L196.147 197.979C196.009 198.117 196.009 198.255 196.147 198.255L197.252 198.946C197.391 199.084 197.805 199.084 197.943 198.946L199.049 198.393C199.325 198.255 199.325 198.255 199.049 198.117Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.489 201.571L195.594 202.262C195.732 202.4 196.147 202.4 196.285 202.262L197.39 201.709C197.529 201.571 197.529 201.433 197.39 201.433L196.285 200.742C196.147 200.604 195.732 200.604 195.594 200.742L194.489 201.295C194.213 201.295 194.213 201.433 194.489 201.571Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.983 199.222L199.877 198.532C199.739 198.393 199.325 198.393 199.186 198.532L198.081 199.084C197.943 199.222 197.943 199.361 198.081 199.361L199.186 200.051C199.325 200.19 199.739 200.19 199.877 200.051L200.983 199.499C201.121 199.361 201.121 199.361 200.983 199.222Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.253 199.084L196.147 198.393C196.009 198.255 195.595 198.255 195.457 198.393L194.351 198.946C194.213 199.084 194.213 199.222 194.351 199.222L195.457 199.913C195.595 200.051 196.009 200.051 196.147 199.913L197.253 199.36C197.391 199.36 197.391 199.222 197.253 199.084Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.285 202.677L197.39 203.367C197.528 203.506 197.943 203.506 198.081 203.367L199.186 202.815C199.324 202.677 199.324 202.538 199.186 202.538L198.081 201.848C197.943 201.709 197.528 201.709 197.39 201.848L196.285 202.4C196.147 202.4 196.147 202.538 196.285 202.677Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.285 200.466L197.39 201.157C197.528 201.295 197.943 201.295 198.081 201.157L199.186 200.604C199.324 200.466 199.324 200.328 199.186 200.328L198.081 199.637C197.943 199.499 197.528 199.499 197.39 199.637L196.285 200.19C196.147 200.19 196.147 200.328 196.285 200.466Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.917 200.604C203.055 200.466 203.055 200.328 202.917 200.328L201.812 199.637C201.674 199.499 201.259 199.499 201.121 199.637L200.016 200.19C199.878 200.328 199.878 200.466 200.016 200.466L201.121 201.157C201.259 201.295 201.674 201.295 201.812 201.157L202.917 200.604Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.62 198.946C190.482 199.084 190.482 199.222 190.62 199.222L191.726 199.913C191.864 200.051 192.278 200.051 192.416 199.913L193.522 199.36C193.66 199.222 193.66 199.084 193.522 199.084L192.416 198.393C192.278 198.255 191.864 198.255 191.726 198.393L190.62 198.946Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.555 200.466L193.66 201.157C193.798 201.295 194.213 201.295 194.351 201.157L195.456 200.604C195.594 200.466 195.594 200.328 195.456 200.328L194.351 199.637C194.213 199.499 193.798 199.499 193.66 199.637L192.555 200.19C192.417 200.19 192.417 200.328 192.555 200.466Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.917 202.4L201.812 201.709C201.674 201.571 201.259 201.571 201.121 201.709L200.016 202.262C199.878 202.4 199.878 202.538 200.016 202.538L201.121 203.229C201.259 203.367 201.674 203.367 201.812 203.229L202.917 202.676C203.194 202.676 203.194 202.538 202.917 202.4Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.555 198.255L193.66 198.946C193.798 199.084 194.213 199.084 194.351 198.946L195.456 198.393C195.595 198.255 195.595 198.117 195.456 198.117L194.351 197.426C194.213 197.288 193.798 197.288 193.66 197.426L192.555 197.979C192.279 197.979 192.279 198.117 192.555 198.255Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.587 196.183L190.482 196.735C190.344 196.873 190.344 197.012 190.482 197.012L191.587 197.702C191.726 197.841 192.14 197.841 192.278 197.702L193.384 197.15C193.522 197.012 193.522 196.873 193.384 196.873L192.278 196.183C192.14 196.183 191.726 196.183 191.587 196.183Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.983 201.295L199.877 200.604C199.739 200.466 199.325 200.466 199.186 200.604L198.081 201.157C197.943 201.295 197.943 201.433 198.081 201.433L199.186 202.124C199.325 202.262 199.739 202.262 199.877 202.124L200.983 201.571C201.259 201.571 201.259 201.433 200.983 201.295Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.68 206.131C205.542 205.993 205.127 205.993 204.989 206.131L203.884 206.683C203.746 206.822 203.746 206.96 203.884 206.96L204.989 207.651C205.127 207.789 205.404 207.789 205.542 207.651L205.818 206.269L205.68 206.131Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.852 201.847L203.746 202.4C203.608 202.538 203.608 202.676 203.746 202.676L204.852 203.367C204.99 203.505 205.404 203.505 205.542 203.367L206.51 202.814L206.648 202.538L205.542 201.847C205.404 201.847 204.99 201.709 204.852 201.847Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.351 195.077L195.456 195.768C195.594 195.906 196.009 195.906 196.147 195.768L197.252 195.216C197.39 195.077 197.39 194.939 197.252 194.939L196.147 194.248C196.009 194.11 195.594 194.11 195.456 194.248L194.351 194.801C194.074 194.801 194.074 194.939 194.351 195.077Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.852 199.775L203.746 200.328C203.608 200.466 203.608 200.604 203.746 200.604L204.852 201.295C204.99 201.433 205.404 201.433 205.542 201.295L206.648 200.742C206.786 200.604 206.786 200.466 206.648 200.466L205.542 199.775C205.404 199.637 204.99 199.637 204.852 199.775Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.384 192.591L192.278 191.9C192.14 191.762 191.726 191.762 191.587 191.9L190.482 192.452C190.344 192.591 190.344 192.729 190.482 192.729L191.587 193.42C191.726 193.558 192.14 193.558 192.278 193.42L193.384 192.867C193.522 192.867 193.522 192.729 193.384 192.591Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.417 193.972L193.522 194.663C193.66 194.801 194.075 194.801 194.213 194.663L195.318 194.11C195.456 193.972 195.456 193.834 195.318 193.834L194.213 193.143C194.075 193.005 193.66 193.005 193.522 193.143L192.417 193.696C192.278 193.696 192.278 193.834 192.417 193.972Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.818 205.993L205.957 206.131L206.095 205.578L205.818 205.716C205.68 205.854 205.68 205.854 205.818 205.993Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.056 202.953L201.95 203.505C201.812 203.644 201.812 203.782 201.95 203.782L203.056 204.473C203.194 204.611 203.608 204.611 203.746 204.473L204.852 203.92C204.99 203.782 204.99 203.644 204.852 203.644L203.746 202.953C203.608 202.815 203.194 202.815 203.056 202.953Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.351 196.874C194.213 197.012 194.213 197.15 194.351 197.15L195.457 197.841C195.595 197.979 196.009 197.979 196.147 197.841L197.253 197.288C197.391 197.15 197.391 197.012 197.253 197.012L196.147 196.321C196.009 196.183 195.595 196.183 195.457 196.321L194.351 196.874Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.819 203.92L206.371 204.335L206.648 203.091L205.819 203.644C205.542 203.644 205.542 203.782 205.819 203.92Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.989 204.058L203.884 204.611C203.746 204.749 203.746 204.887 203.884 204.887L204.989 205.578C205.127 205.716 205.542 205.716 205.68 205.578L206.095 205.302L206.233 204.334L205.542 203.92C205.542 203.92 205.127 203.92 204.989 204.058Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.081 196.873L199.186 196.321C199.324 196.183 199.324 196.044 199.186 196.044L198.081 195.354C197.943 195.215 197.528 195.215 197.39 195.354L196.285 195.906C196.147 196.044 196.147 196.183 196.285 196.183L197.39 196.873C197.528 196.873 197.805 196.873 198.081 196.873Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.713 199.222L203.608 198.532C203.47 198.393 203.055 198.393 202.917 198.532L201.812 199.084C201.673 199.222 201.673 199.361 201.812 199.361L202.917 200.051C203.055 200.19 203.47 200.19 203.608 200.051L204.713 199.499C204.989 199.499 204.989 199.361 204.713 199.222Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.62 201.433L198.219 205.854L199.325 206.545C199.463 206.683 199.877 206.683 200.016 206.545L201.121 205.993C201.259 205.854 201.259 205.716 201.121 205.716L192.416 200.604C192.278 200.466 191.864 200.466 191.726 200.604L190.62 201.157C190.482 201.157 190.482 201.295 190.62 201.433Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.154 206.96L201.259 207.651C201.397 207.789 201.812 207.789 201.95 207.651L203.055 207.098C203.194 206.96 203.194 206.822 203.055 206.822L201.95 206.131C201.812 205.993 201.397 205.993 201.259 206.131L200.154 206.683C200.016 206.822 200.016 206.822 200.154 206.96Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.219 203.782L199.325 204.473C199.463 204.611 199.877 204.611 200.016 204.473L201.121 203.92C201.259 203.782 201.259 203.644 201.121 203.644L200.016 202.953C199.877 202.815 199.463 202.815 199.325 202.953L198.219 203.505C198.081 203.505 198.081 203.644 198.219 203.782Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.824 200.328L189.929 201.019C190.067 201.157 190.482 201.157 190.62 201.019L191.725 200.466C191.864 200.328 191.864 200.19 191.725 200.19L190.62 199.499C190.482 199.361 190.067 199.361 189.929 199.499L188.824 200.052C188.548 200.052 188.548 200.19 188.824 200.328Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.022 209.17L205.128 209.861C205.128 209.861 205.128 209.861 205.266 209.861L205.542 208.203C205.404 208.203 205.128 208.203 204.99 208.203L203.884 208.756C203.884 209.032 203.884 209.17 204.022 209.17Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.89 199.222L187.995 199.913C188.133 200.051 188.548 200.051 188.686 199.913L189.791 199.36C189.929 199.222 189.929 199.084 189.791 199.084L188.686 198.393C188.548 198.255 188.133 198.255 187.995 198.393L186.89 198.946C186.752 198.946 186.752 199.084 186.89 199.222Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.786 200.88L205.681 201.433C205.543 201.571 205.543 201.709 205.681 201.709L206.786 202.262L207.062 200.742C206.924 200.742 206.786 200.742 206.786 200.88Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.686 193.834L191.725 195.63C191.864 195.63 192.002 195.768 192.14 195.768C192.278 195.768 192.416 195.768 192.554 195.768L193.66 195.215C193.798 195.077 193.798 194.939 193.66 194.939L192.554 194.248L190.62 193.143C190.482 193.005 190.067 193.005 189.929 193.143L188.824 193.696C188.409 193.696 188.409 193.834 188.686 193.834Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.692 191.347C192.554 191.485 192.554 191.623 192.692 191.623L193.798 192.314C193.936 192.452 194.35 192.452 194.489 192.314L194.765 192.176C194.903 192.038 194.903 191.9 194.765 191.9L193.66 191.209C193.521 191.071 193.107 191.071 192.969 191.209L192.692 191.347Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.021 196.735C182.883 196.874 182.883 197.012 183.021 197.012L184.955 198.117L186.061 198.808C186.199 198.808 186.337 198.946 186.475 198.946C186.613 198.946 186.752 198.946 186.89 198.946L187.995 198.393C188.133 198.255 188.133 198.117 187.995 198.117L184.955 196.321C184.817 196.183 184.403 196.183 184.265 196.321L183.021 196.735Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.063 198.946C206.924 198.808 206.51 198.808 206.372 198.946L206.095 199.085C205.957 199.223 205.957 199.361 206.095 199.361L207.201 200.052C207.201 200.052 207.201 200.052 207.339 200.052L207.477 199.085L207.063 198.946Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.529 193.42C197.391 193.281 196.976 193.281 196.838 193.42L196.562 193.558C196.423 193.696 196.423 193.834 196.562 193.834L197.667 194.525C197.805 194.663 198.22 194.663 198.358 194.525L198.634 194.387C198.772 194.249 198.772 194.11 198.634 194.11L197.529 193.42Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.088 208.065L203.193 208.756C203.331 208.894 203.746 208.894 203.884 208.756L204.989 208.203C205.128 208.065 205.128 207.927 204.989 207.927L203.884 207.236C203.746 207.098 203.331 207.098 203.193 207.236L202.088 207.789C201.95 207.927 201.95 207.927 202.088 208.065Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.852 201.433L203.746 200.742C203.608 200.604 203.194 200.604 203.056 200.742L201.95 201.295C201.812 201.433 201.812 201.571 201.95 201.571L203.056 202.262C203.194 202.4 203.608 202.4 203.746 202.262L204.852 201.709C204.99 201.709 204.99 201.571 204.852 201.433Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.233 198.808C206.371 198.67 206.371 198.532 206.233 198.532L205.128 197.841C204.99 197.703 204.575 197.703 204.437 197.841L204.161 197.979C204.023 198.117 204.023 198.255 204.161 198.255L205.266 198.946C205.404 199.084 205.819 199.084 205.957 198.946L206.233 198.808Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.982 197.426L199.877 197.979C199.739 198.117 199.739 198.255 199.877 198.255L200.982 198.946C201.121 199.084 201.535 199.084 201.673 198.946L202.779 198.393C202.917 198.255 202.917 198.117 202.779 198.117L201.673 197.426C201.535 197.426 201.259 197.426 200.982 197.426Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.154 204.887L201.259 205.578C201.397 205.716 201.812 205.716 201.95 205.578L203.055 205.025C203.194 204.887 203.194 204.749 203.055 204.749L201.95 204.058C201.812 203.92 201.397 203.92 201.259 204.058L200.154 204.611C200.016 204.611 200.016 204.749 200.154 204.887Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.088 205.993L203.193 206.684C203.332 206.822 203.746 206.822 203.884 206.684L204.99 206.131C205.128 205.993 205.128 205.855 204.99 205.855L203.884 205.164C203.746 205.026 203.332 205.026 203.193 205.164L202.088 205.578C201.812 205.716 201.812 205.855 202.088 205.993Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.417 195.768C192.278 195.906 192.278 196.044 192.417 196.044L193.522 196.735C193.66 196.873 194.075 196.873 194.213 196.735L195.318 196.183C195.456 196.044 195.456 195.906 195.318 195.906L194.213 195.215C194.075 195.077 193.66 195.077 193.522 195.215L192.417 195.768Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.956 195.63C184.818 195.768 184.818 195.906 184.956 195.906L189.93 198.808C190.068 198.808 190.206 198.946 190.344 198.946C190.344 198.946 190.344 198.946 190.482 198.946C190.482 198.946 190.482 198.946 190.62 198.946H190.759L191.864 198.393C192.002 198.393 192.002 198.255 192.002 198.255C192.002 198.255 192.002 198.117 191.864 198.117L190.759 197.426L188.824 196.321L186.89 195.215C186.752 195.077 186.337 195.077 186.199 195.215L184.956 195.63Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.344 195.077L188.41 193.972C188.271 193.834 187.857 193.834 187.719 193.972L186.613 194.525C186.475 194.663 186.475 194.801 186.613 194.801L189.653 196.597C189.791 196.597 189.929 196.735 190.068 196.735C190.206 196.735 190.344 196.735 190.482 196.735L191.587 196.183C191.726 196.045 191.726 195.906 191.587 195.906L190.344 195.077C190.482 195.077 190.482 195.077 190.344 195.077Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.502 196.597C202.64 196.459 202.64 196.321 202.502 196.321L201.397 195.63C201.259 195.492 200.844 195.492 200.706 195.63L200.43 195.768C200.292 195.906 200.292 196.044 200.43 196.044L201.535 196.735C201.673 196.873 202.088 196.873 202.226 196.735L202.502 196.597Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.569 195.078L199.463 194.387C199.325 194.249 198.911 194.249 198.773 194.387L198.496 194.525C198.358 194.663 198.358 194.801 198.496 194.801L199.602 195.492C199.74 195.63 200.154 195.63 200.292 195.492L200.569 195.354C200.707 195.354 200.707 195.216 200.569 195.078Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.983 197.012L199.878 196.321C199.74 196.183 199.325 196.183 199.187 196.321L198.082 196.874C197.943 197.012 197.943 197.15 198.082 197.15L199.187 197.841C199.325 197.979 199.74 197.979 199.878 197.841L200.983 197.288C201.121 197.288 201.121 197.15 200.983 197.012Z",
    fill: "#45494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.306 211.105C229.168 211.105 229.168 211.105 229.306 211.105C229.168 211.105 229.168 211.105 229.168 211.105H229.03C228.615 210.967 228.201 210.69 228.339 210.414C228.339 210.138 228.615 210 228.892 210H229.03H229.168H229.306C229.306 210 229.444 210 229.583 210C229.721 210 229.859 210 229.997 210.138C230.55 210.276 230.826 210.552 230.826 210.829C230.826 210.967 230.688 211.105 230.412 211.243C230.273 211.243 229.997 211.381 229.721 211.381C229.444 211.105 229.306 211.105 229.306 211.105Z",
    fill: "#C4CACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.444 211.243C229.306 211.243 229.306 211.243 229.306 211.243H229.168C228.615 211.105 228.339 210.829 228.339 210.552C228.339 210.276 228.477 210.138 228.892 210H229.03C229.03 210 229.168 210 229.306 210H229.444C229.444 210 229.444 210 229.582 210C229.721 210 229.859 210 229.859 210C230.411 210.138 230.688 210.414 230.688 210.69C230.688 210.829 230.55 211.105 230.411 211.105C230.273 211.243 230.135 211.243 229.859 211.243C229.582 211.243 229.582 211.243 229.444 211.243Z",
    fill: "#373A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.936 196.459C193.798 196.459 193.798 196.459 193.66 196.459C193.522 196.459 193.522 196.321 193.522 196.183C193.245 196.044 193.245 195.906 193.522 195.768C193.66 195.63 194.074 195.63 194.351 195.768C194.627 195.906 194.627 196.044 194.351 196.183C194.213 196.321 193.936 196.321 193.66 196.183C193.66 196.321 193.66 196.321 193.798 196.321C193.66 196.321 193.798 196.321 193.936 196.459ZM193.522 196.044C193.66 196.183 194.074 196.183 194.213 196.044C194.351 195.906 194.351 195.768 194.213 195.63C194.074 195.492 193.66 195.492 193.522 195.63C193.384 195.768 193.384 196.044 193.522 196.044Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.587 196.874H191.311L192.416 196.735L192.001 197.426L192.14 197.288L191.587 196.874ZM192.278 196.735L191.587 196.874L192.001 197.15L192.278 196.735Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.35 198.117C194.212 198.117 194.212 197.979 194.074 197.979C193.936 197.84 193.798 197.84 193.798 197.979C193.521 198.117 194.212 198.255 193.936 198.393C193.798 198.393 193.66 198.393 193.521 198.393C193.383 198.393 193.383 198.255 193.383 198.117C193.383 198.255 193.383 198.255 193.521 198.255C193.66 198.393 193.798 198.393 193.936 198.255C194.212 198.117 193.521 197.978 193.798 197.84C193.936 197.84 194.074 197.84 194.212 197.84C194.35 197.978 194.35 197.979 194.35 198.117Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.147 198.946C196.423 199.084 196.423 199.222 196.147 199.36C196.009 199.498 195.594 199.498 195.318 199.36L195.042 199.222L195.732 198.808L196.147 198.946ZM195.18 199.222L195.456 199.36C195.594 199.498 196.009 199.498 196.147 199.36C196.285 199.222 196.285 199.084 196.147 198.946L195.871 198.808L195.18 199.222Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.805 200.051L197.528 200.189L197.943 200.466L197.528 200.189L197.252 200.327L197.805 200.051L198.219 200.327L197.805 200.051Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.739 201.571L199.463 201.709C199.325 201.709 199.187 201.709 199.049 201.571C198.772 201.433 198.772 201.295 199.049 201.157C199.187 201.018 199.601 201.018 199.878 201.157C200.016 201.157 200.016 201.295 200.016 201.433C200.016 201.433 200.016 201.295 199.878 201.295C199.739 201.157 199.325 201.157 199.187 201.295C199.049 201.433 199.049 201.571 199.187 201.709C199.325 201.709 199.325 201.847 199.463 201.847L199.739 201.571Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.259 202.814L201.673 202.676L201.121 202.4L200.706 202.538L201.397 202.124L200.982 202.262L201.535 202.538L201.95 202.4L201.259 202.814Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.193 203.644C203.055 203.782 202.917 203.782 202.779 203.644C202.641 203.644 202.641 203.505 202.641 203.505C202.641 203.505 202.641 203.644 202.779 203.644C202.917 203.782 202.917 203.782 203.193 203.644L203.608 203.367L203.331 203.229L203.608 203.367L203.193 203.644Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.989 204.611H204.575L204.437 204.749L205.127 204.334L204.713 204.611H205.68H204.989V205.025V204.611Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.786 205.992L206.371 205.716L207.062 205.302L206.371 205.716L206.786 205.992Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.582 206.683C208.582 206.683 208.72 206.683 208.582 206.683C208.72 206.683 208.72 206.683 208.582 206.683C208.72 206.683 208.582 206.683 208.582 206.683ZM208.443 206.821C208.305 206.959 208.305 206.959 208.443 206.821H208.305H208.443C208.305 206.821 208.305 206.821 208.443 206.821C208.305 206.821 208.305 206.821 208.443 206.821Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.622 208.203L211.483 208.341L211.76 208.479L211.483 208.341L211.345 208.479L211.622 208.617L211.345 208.479L211.622 208.203L211.898 208.341L211.622 208.203Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.174 208.756L212.036 208.894L212.174 208.756V208.618C212.036 208.618 212.036 208.618 211.898 208.618L211.76 208.756L212.036 208.618H211.898C212.036 208.618 212.036 208.618 212.174 208.618C212.174 208.618 212.174 208.756 212.174 208.756Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.312 209.032C212.174 209.032 212.174 209.032 212.312 209.032C212.036 209.032 212.036 208.894 212.312 209.032L212.45 208.755H212.589H212.45L212.589 208.894L212.45 208.755L212.312 209.032C212.174 208.894 212.174 209.032 212.312 209.032C212.174 209.032 212.174 209.032 212.312 209.032Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.727 209.17L212.451 209.032C212.313 209.032 212.313 209.17 212.451 209.17C212.451 209.17 212.589 209.17 212.727 209.17C212.589 209.17 212.451 209.17 212.451 209.17C212.313 209.17 212.313 209.032 212.451 209.032C212.589 209.032 212.727 209.032 212.727 209.032C212.865 209.032 212.865 209.17 212.727 209.17ZM212.727 209.17C212.865 209.17 212.727 209.032 212.727 209.032C212.589 209.032 212.589 209.032 212.451 209.032L212.727 209.17Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.003 209.17C213.142 209.17 213.142 209.17 213.28 209.17C213.142 209.17 213.003 209.17 213.003 209.17L212.727 209.308L213.003 209.17Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.937 205.854C214.937 205.992 214.799 205.992 214.937 205.854C214.799 205.992 214.799 205.992 214.799 206.131C214.799 206.131 214.661 206.131 214.522 206.131L214.384 205.992L214.661 205.854H214.937ZM214.661 205.854C214.799 205.992 214.937 205.992 214.937 205.992C214.937 205.992 214.937 205.992 214.937 205.854H214.661ZM214.384 205.854C214.522 205.992 214.661 205.992 214.661 205.992C214.661 205.992 214.661 205.992 214.661 205.854L214.522 205.716L214.384 205.854Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.937 206.131H214.799C214.799 206.131 214.799 206.131 214.799 205.992C214.799 205.992 214.937 205.992 214.937 206.131C215.075 205.992 215.075 205.992 215.075 205.992H214.937H215.075C215.213 205.992 215.213 206.131 214.937 206.131ZM215.075 206.131C214.937 205.992 214.937 205.992 214.937 205.992C214.937 205.992 214.937 205.992 214.937 206.131C214.937 206.131 214.937 206.131 215.075 206.131Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.489 206.269C215.351 206.13 215.213 206.13 215.213 206.269V206.407H215.351H215.213C215.075 206.407 215.075 206.269 215.213 206.269C215.213 206.13 215.351 206.13 215.489 206.269Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.489 206.407L215.766 206.269L215.489 206.407H215.766H215.627V206.545L215.489 206.407Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.042 206.545C215.904 206.545 215.904 206.545 216.042 206.545C215.904 206.545 215.904 206.407 215.904 206.545C215.904 206.545 216.042 206.683 215.904 206.683H215.766C215.766 206.683 215.766 206.683 215.766 206.545H215.904C216.042 206.545 215.766 206.407 215.904 206.407C215.766 206.407 215.904 206.407 216.042 206.545C215.904 206.545 216.042 206.545 216.042 206.545Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.181 206.822C216.042 206.822 216.042 206.822 215.904 206.822C215.904 206.822 215.904 206.822 215.904 206.683L215.766 206.822L216.042 206.683H216.181C216.319 206.683 216.319 206.822 216.181 206.822ZM216.181 206.822C216.319 206.822 216.319 206.683 216.181 206.822C216.181 206.683 216.042 206.683 215.904 206.683V206.822C216.042 206.822 216.181 206.822 216.181 206.822Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.457 206.959H216.319C216.319 206.959 216.319 206.959 216.319 206.821C216.319 206.821 216.319 206.821 216.457 206.959C216.595 206.821 216.595 206.821 216.595 206.821H216.457H216.595C216.595 206.821 216.595 206.959 216.457 206.959ZM216.457 206.959C216.319 206.821 216.319 206.821 216.319 206.821C216.319 206.821 216.319 206.821 216.319 206.959C216.319 206.959 216.319 206.959 216.457 206.959Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.871 207.098C216.733 206.96 216.595 206.96 216.595 207.098V207.236H216.733H216.595C216.457 207.236 216.457 207.098 216.595 207.098C216.595 206.96 216.733 206.96 216.871 207.098Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.148 207.374L216.872 207.236V207.374C216.872 207.374 216.872 207.374 217.148 207.374C217.01 207.374 217.01 207.374 216.872 207.374C216.734 207.374 216.734 207.236 216.872 207.236C217.01 207.236 217.01 207.236 217.148 207.236C217.148 207.236 217.148 207.236 217.148 207.374ZM217.148 207.236C217.148 207.098 217.01 207.098 216.872 207.098L217.148 207.236Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.127 207.098H204.989H205.127C204.989 207.098 204.989 207.098 205.127 207.098C205.127 206.96 205.127 206.96 205.127 207.098Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.47 206.13L204.16 205.716L203.193 205.854L203.47 205.302L202.779 205.716L203.47 205.302L203.193 205.854L204.16 205.716L203.47 206.13Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.397 205.025L201.535 204.334L200.844 204.749L201.535 204.334L201.397 205.025L202.088 204.611L201.397 205.025Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.015 203.367C200.154 203.505 200.154 203.505 200.015 203.644C199.877 203.644 199.739 203.644 199.739 203.644C199.877 203.782 199.877 203.782 199.739 203.92C199.601 204.058 199.463 203.92 199.325 203.92L199.048 203.782L199.739 203.367H200.015ZM199.325 203.367L199.601 203.505C199.739 203.643 199.877 203.643 200.015 203.505C200.154 203.505 200.154 203.367 200.015 203.367L199.739 203.229L199.325 203.367ZM199.048 203.644L199.325 203.782C199.463 203.92 199.601 203.92 199.739 203.782C199.877 203.782 199.739 203.643 199.601 203.505L199.325 203.367L199.048 203.644Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.252 202.676L197.666 202.124L197.252 202.676L198.357 202.4L197.252 202.676Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.423 201.433C196.285 201.433 196.285 201.295 196.147 201.295C196.008 201.157 195.594 201.157 195.456 201.295C195.318 201.433 195.318 201.571 195.456 201.709C195.594 201.709 195.732 201.847 195.732 201.847C195.594 201.847 195.456 201.847 195.318 201.709C195.041 201.571 195.041 201.433 195.318 201.295C195.456 201.157 195.87 201.157 196.147 201.295C196.285 201.157 196.423 201.295 196.423 201.433Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.798 200.604V200.189H193.245H193.936L194.074 199.775L193.936 200.051H194.489H193.798V200.604Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.449 199.084L192.002 199.36L191.449 199.084L192.555 198.946L192.002 198.669L192.555 199.084H191.449Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.613 195.63C186.475 195.63 186.475 195.63 186.613 195.63C186.475 195.492 186.337 195.492 186.337 195.492C186.199 195.63 186.613 195.63 186.337 195.768C186.337 195.768 186.199 195.768 186.061 195.768L185.922 195.63C185.922 195.63 185.922 195.768 186.061 195.768C186.199 195.768 186.199 195.768 186.337 195.768C186.475 195.63 186.061 195.63 186.337 195.492C186.337 195.492 186.337 195.492 186.613 195.63C186.475 195.63 186.613 195.63 186.613 195.63Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.89 196.044L186.751 196.183L186.89 196.044V195.906C186.751 195.906 186.751 195.906 186.613 195.906L186.475 196.044L186.89 195.768L186.613 195.906C186.751 195.906 186.751 195.906 186.89 195.906V196.044Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.166 196.044C187.166 195.906 187.166 195.906 187.166 196.044V196.044ZM186.751 196.182L187.028 196.044L186.751 196.182Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.304 196.183L186.89 196.321L187.304 196.183H187.166H187.304H187.442C187.442 196.045 187.442 196.045 187.304 196.183Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.304 196.459C187.166 196.459 187.166 196.459 187.304 196.459L187.442 196.183H187.58H187.442L187.58 196.321L187.442 196.183L187.304 196.459C187.166 196.459 187.166 196.459 187.304 196.459Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.548 209.032C209.548 209.032 209.41 209.032 209.548 209.032C209.41 208.894 209.272 208.894 209.272 208.894C209.134 209.032 209.548 209.032 209.272 209.17C209.272 209.17 209.134 209.17 208.996 209.17L208.857 209.032C208.857 209.032 208.857 209.17 208.996 209.17C209.134 209.17 209.134 209.17 209.272 209.17C209.41 209.032 208.996 209.032 209.272 208.894C209.272 208.894 209.41 208.894 209.548 209.032Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.825 209.446L209.686 209.585L209.825 209.446V209.308C209.686 209.308 209.686 209.308 209.548 209.308L209.41 209.446L209.825 209.17L209.548 209.308C209.686 209.308 209.686 209.308 209.825 209.308C209.825 209.308 209.825 209.308 209.825 209.446Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.239 209.446C210.101 209.446 210.101 209.446 210.239 209.446C210.101 209.446 210.101 209.308 210.239 209.446C210.101 209.308 210.101 209.308 210.239 209.446C210.239 209.308 210.239 209.446 210.239 209.446ZM209.687 209.585L209.963 209.446L209.687 209.585Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.239 209.585L209.825 209.723L210.239 209.585H210.101H210.239H210.377C210.377 209.447 210.377 209.447 210.239 209.585Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.239 209.861C210.101 209.861 210.101 209.861 210.239 209.861L210.377 209.585H210.515H210.377L210.515 209.723H210.377L210.239 209.861Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.133 194.801C188.133 194.801 188.133 194.663 188.133 194.801C187.995 194.663 187.857 194.663 187.718 194.663C187.58 194.663 187.58 194.801 187.718 194.801H187.857H187.718C187.58 194.801 187.58 194.663 187.718 194.663C187.857 194.663 187.995 194.663 188.133 194.801C188.133 194.663 188.133 194.801 188.133 194.801Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.133 195.077H187.995C187.995 195.077 187.995 195.077 187.995 194.939C187.995 194.939 188.133 194.939 188.133 195.077C188.271 194.939 188.271 194.939 188.271 194.939H188.133H188.271C188.271 194.939 188.271 194.939 188.133 195.077ZM188.133 195.077C187.995 194.939 187.995 194.939 187.995 194.939C187.995 194.939 187.995 194.939 187.995 195.077H188.133Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.547 195.215C188.409 195.215 188.409 195.215 188.271 195.215C188.271 195.215 188.271 195.215 188.271 195.077L188.133 195.215L188.409 195.077H188.547C188.685 195.077 188.685 195.215 188.547 195.215ZM188.547 195.215C188.685 195.215 188.685 195.077 188.547 195.215C188.547 195.077 188.409 195.077 188.271 195.077V195.215C188.409 195.215 188.547 195.215 188.547 195.215Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.962 195.353C188.824 195.353 188.824 195.215 188.962 195.353C188.824 195.353 188.824 195.215 188.824 195.353C188.824 195.353 188.962 195.491 188.824 195.491H188.686C188.686 195.491 188.686 195.491 188.686 195.353H188.824C188.962 195.353 188.686 195.215 188.824 195.215C188.686 195.215 188.824 195.215 188.962 195.353C188.824 195.215 188.962 195.215 188.962 195.353Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.1 195.63L188.962 195.492L189.238 195.354L188.962 195.492L189.1 195.63Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.515 195.768C189.377 195.768 189.377 195.768 189.238 195.768C189.1 195.768 189.1 195.63 189.238 195.63C189.377 195.63 189.377 195.63 189.515 195.63C189.653 195.63 189.653 195.768 189.515 195.768ZM189.238 195.63C189.238 195.63 189.238 195.768 189.238 195.63C189.238 195.768 189.377 195.768 189.515 195.768V195.63C189.377 195.63 189.377 195.63 189.238 195.63Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.929 195.906C189.929 195.906 189.791 195.906 189.929 195.906C189.791 195.768 189.653 195.768 189.653 195.906V196.044H189.791H189.653C189.515 196.044 189.515 195.906 189.653 195.906C189.653 195.768 189.791 195.768 189.929 195.906C189.929 195.768 189.929 195.906 189.929 195.906Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.929 196.044L190.206 195.906L189.929 196.044H190.206H190.067V196.182L189.929 196.044Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.817 196.597C184.679 196.459 184.541 196.459 184.402 196.459C184.264 196.459 184.264 196.597 184.402 196.597H184.541H184.402C184.264 196.597 184.264 196.459 184.402 196.459C184.541 196.459 184.679 196.459 184.817 196.597Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.817 196.873C184.679 196.873 184.679 196.873 184.817 196.873C184.679 196.873 184.679 196.873 184.817 196.873L184.955 196.735H185.093H184.955L184.817 196.873C184.679 196.873 184.679 196.873 184.817 196.873C184.679 196.873 184.817 196.873 184.817 196.873Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.093 196.874H185.231C185.093 196.874 185.093 196.874 185.093 196.874L184.955 197.012L185.093 196.874Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.955 197.012L185.369 196.874L184.955 197.012Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.72 210.552C208.72 210.552 208.582 210.414 208.72 210.552C208.582 210.414 208.444 210.414 208.306 210.414C208.168 210.414 208.168 210.552 208.306 210.552H208.444H208.306C208.168 210.552 208.168 210.414 208.306 210.414C208.306 210.414 208.582 210.414 208.72 210.552C208.72 210.414 208.72 210.552 208.72 210.552Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.582 210.828C208.582 210.69 208.582 210.69 208.582 210.828L208.72 210.69H208.858H208.72L208.582 210.828C208.582 210.69 208.582 210.69 208.582 210.828Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.858 210.69H208.997H208.858L208.72 210.828L208.858 210.69Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.858 210.966L209.272 210.828L208.858 210.966Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.791 199.913H189.653L190.205 199.775L190.067 200.051V199.913H189.791ZM190.067 199.913H189.791L189.929 200.051L190.067 199.913Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.929 200.189L190.343 200.051L189.929 200.189Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.206 200.328C190.068 200.328 190.068 200.328 190.206 200.328L190.344 200.189H190.482H190.344L190.206 200.328Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.383 191.208L193.245 191.347L193.521 191.485L193.245 191.347L193.107 191.485L193.383 191.623L193.107 191.485L193.383 191.208L193.66 191.347L193.383 191.208Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.798 191.623C193.66 191.485 193.66 191.485 193.521 191.485C193.383 191.485 193.66 191.623 193.521 191.761C193.521 191.761 193.383 191.761 193.245 191.761C193.245 191.761 193.107 191.761 193.107 191.623C193.107 191.623 193.107 191.623 193.245 191.761H193.383C193.521 191.761 193.245 191.623 193.383 191.485C193.66 191.485 193.66 191.485 193.798 191.623Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.212 191.899C194.212 191.899 194.212 191.761 194.212 191.899C194.074 191.761 193.936 191.761 193.798 191.761C193.66 191.761 193.66 191.899 193.798 191.899H193.936H193.798C193.66 191.899 193.66 191.761 193.798 191.761C193.936 191.761 194.074 191.761 194.212 191.899C194.212 191.761 194.212 191.899 194.212 191.899Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.528 193.557L197.39 193.695L197.666 193.833L197.39 193.695L197.252 193.833L197.528 193.557L197.805 193.695L197.528 193.557Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.39 194.11L197.805 193.833H197.666L197.805 193.972L197.39 194.11Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.462 194.801L199.324 194.939L199.601 195.077L199.324 194.939L199.186 195.077L199.462 194.801L199.739 194.939L199.462 194.801Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.877 195.077C199.877 195.077 199.739 195.077 199.601 195.077H199.324L199.601 195.216L199.324 195.077H199.739H199.877C199.739 194.939 199.739 194.939 199.601 194.939C199.739 194.939 199.739 194.939 199.739 194.939C200.015 195.077 200.015 195.077 199.877 195.077Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.259 195.768L201.121 195.906L201.397 196.044L201.121 195.906L200.982 196.044L201.259 195.768L201.535 195.906L201.259 195.768Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.535 196.182C201.673 196.182 201.673 196.321 201.535 196.321C201.397 196.321 201.397 196.321 201.259 196.321C201.259 196.321 201.121 196.321 201.121 196.182C201.121 196.182 201.121 196.182 201.259 196.321C201.397 196.321 201.397 196.321 201.535 196.321V196.182H201.811L201.535 196.044L201.811 196.182H201.535Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.127 198.117L204.989 198.255L205.266 198.393L204.989 198.255L204.851 198.393L205.127 198.117L205.404 198.255L205.127 198.117Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.403 198.531H205.541H205.403L205.265 198.67L205.403 198.531L205.127 198.393H205.541H205.127L205.403 198.531Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.062 199.222L206.923 199.36L207.2 199.499L206.923 199.36L206.785 199.499L207.062 199.222L207.338 199.36L207.062 199.222Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.338 199.361L207.2 199.499H207.338C207.476 199.499 207.476 199.637 207.338 199.637C207.2 199.637 207.2 199.637 207.062 199.637L206.923 199.499C206.923 199.499 206.923 199.637 207.062 199.637C207.2 199.637 207.2 199.637 207.338 199.637V199.499H207.2L207.338 199.361L207.614 199.499L207.338 199.361Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.858 200.328L208.72 200.466L208.996 200.604L208.72 200.466L208.582 200.604L208.858 200.328L209.134 200.466L208.858 200.328Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.548 200.742C209.41 200.604 209.41 200.604 209.548 200.742C209.272 200.604 209.134 200.604 208.996 200.742C209.134 200.742 209.134 200.742 209.272 200.742C209.41 200.742 209.41 200.88 209.272 200.88C209.134 200.88 209.134 200.88 208.996 200.88C208.858 200.88 208.858 200.742 208.996 200.604C209.134 200.604 209.272 200.466 209.548 200.742C209.41 200.604 209.548 200.604 209.548 200.742ZM208.996 200.742C208.996 200.742 208.858 200.88 208.996 200.88C209.134 200.88 209.134 200.88 209.272 200.88C209.41 200.88 209.272 200.742 209.272 200.742C209.134 200.604 208.996 200.604 208.996 200.742Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.727 202.538L212.588 202.676L212.865 202.814L212.588 202.676L212.45 202.814L212.727 202.538L213.003 202.676L212.727 202.538Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.726 202.953L213.279 202.815L213.002 202.677H213.141L213.417 202.815L212.726 202.953Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.661 203.505L214.522 203.643L214.799 203.781L214.522 203.643L214.384 203.781L214.661 203.505L214.937 203.643L214.661 203.505Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.075 203.92H214.937V204.058C214.799 204.058 214.799 204.058 214.661 204.058C214.523 204.058 214.523 203.92 214.661 203.92C214.661 203.92 214.799 203.92 214.937 203.92V203.781C214.937 203.781 215.075 203.781 215.213 203.781C215.213 203.92 215.213 203.92 215.075 203.92ZM214.799 203.781C214.799 203.781 214.799 203.92 214.799 203.781C214.937 203.92 214.937 203.92 215.075 203.92V203.781C214.937 203.781 214.937 203.781 214.799 203.781ZM214.661 203.92V204.058C214.799 204.058 214.799 204.058 214.937 204.058V203.92C214.799 203.92 214.661 203.92 214.661 203.92Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.457 204.749L216.319 204.887L216.595 205.025L216.319 204.887L216.181 205.025L216.457 204.749L216.733 204.887L216.457 204.749Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.457 205.163C216.733 205.301 216.872 205.301 217.01 205.163C216.872 205.163 216.872 205.163 216.733 205.163C216.595 205.163 216.595 205.025 216.733 205.025C216.872 205.025 216.872 205.025 217.01 205.025C217.148 205.025 217.148 205.163 217.01 205.301C216.733 205.301 216.595 205.301 216.457 205.163ZM217.01 205.163C217.01 205.163 217.148 205.025 217.01 205.025C216.872 205.025 216.872 205.025 216.733 205.025C216.595 205.025 216.733 205.163 216.733 205.163C216.733 205.163 216.872 205.163 217.01 205.163Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.115 205.716L217.977 205.854L218.253 205.992L217.977 205.854L217.839 205.992L218.115 205.716L218.392 205.854L218.115 205.716Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.115 206.131L218.529 205.854H218.391L218.529 205.993L218.115 206.131Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.806 206.407C218.668 206.545 218.53 206.545 218.392 206.407C218.254 206.269 218.254 206.269 218.392 206.131C218.53 205.993 218.668 205.993 218.806 206.131C218.944 206.131 218.944 206.269 218.806 206.407ZM218.53 206.131C218.392 206.269 218.392 206.269 218.53 206.269C218.668 206.269 218.806 206.269 218.944 206.269C219.083 206.131 219.083 206.131 218.944 206.131C218.806 206.131 218.668 206.131 218.53 206.131Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.326 207.098L220.187 207.236L220.464 207.374L220.187 207.236L220.049 207.374L220.326 207.098L220.602 207.236L220.326 207.098Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.325 207.513L220.74 207.236H220.602L220.74 207.375L220.325 207.513Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.464 207.651L220.878 207.374H220.74L220.878 207.512L220.464 207.651Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.398 208.203L222.26 208.341L222.537 208.479L222.26 208.341L222.122 208.479L222.398 208.203L222.675 208.341L222.398 208.203Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.26 208.618L222.675 208.341H222.537L222.675 208.479L222.26 208.618Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.089 208.756C223.089 208.756 222.951 208.756 222.813 208.756H222.537L222.813 208.894L222.537 208.756H222.951C222.951 208.756 222.951 208.756 223.089 208.756C223.089 208.618 223.089 208.618 223.089 208.756C222.951 208.618 222.951 208.618 222.813 208.618C222.951 208.618 222.951 208.618 222.951 208.618C223.089 208.618 223.089 208.618 223.089 208.756Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.194 209.17L224.056 209.308L224.332 209.446L224.056 209.308L223.918 209.446L224.194 209.17L224.471 209.308L224.194 209.17Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.194 209.723L224.608 209.446H224.47L224.608 209.584L224.194 209.723Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.747 209.723C224.885 209.723 224.885 209.861 224.747 209.861C224.609 209.861 224.609 209.861 224.471 209.861L224.333 209.723C224.333 209.723 224.333 209.723 224.471 209.861C224.609 209.861 224.609 209.861 224.747 209.861V209.723H225.023L224.747 209.585L225.023 209.723H224.747Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.259 206.683H201.121L201.673 206.545L201.535 206.821V206.683H201.259ZM201.535 206.683H201.259L201.397 206.821L201.535 206.683Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.535 206.959L201.95 206.821L201.535 206.959Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.812 207.098C201.812 207.098 201.673 207.098 201.812 207.098C201.673 207.098 201.673 206.96 201.812 207.098L201.95 206.96H202.088H201.95L201.812 207.098C201.673 207.098 201.673 207.098 201.812 207.098Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.791 193.695L189.377 193.972L189.791 193.695L189.653 193.557L190.068 193.695H189.791Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.93 194.11C189.792 194.11 189.792 194.11 189.653 194.11C189.515 194.11 189.515 193.972 189.653 193.972C189.653 193.972 189.792 193.972 189.93 193.972V194.11L190.068 193.972V193.833H189.93C190.068 193.833 190.068 193.833 190.068 193.833C190.206 193.833 190.206 193.972 190.068 193.972L189.93 194.11ZM189.93 194.11C189.792 193.972 189.792 193.972 189.653 193.972C189.653 193.972 189.653 193.972 189.653 194.11C189.792 194.11 189.93 194.11 189.93 194.11Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.482 194.386C190.344 194.386 190.206 194.386 190.206 194.386C190.067 194.386 190.067 194.248 190.206 194.248H190.067L190.482 193.972L190.206 194.11C190.344 194.11 190.344 194.11 190.482 194.11C190.62 194.248 190.62 194.386 190.482 194.386ZM190.482 194.386C190.62 194.386 190.62 194.248 190.482 194.248C190.344 194.248 190.344 194.248 190.206 194.248C190.067 194.248 190.067 194.386 190.206 194.386C190.344 194.386 190.344 194.386 190.482 194.386Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.245 194.11L193.936 193.695L193.798 193.557L194.074 193.695L193.245 194.11Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.587 192.867H191.725C191.587 193.005 191.587 193.005 191.587 192.867C191.449 192.867 191.449 192.729 191.449 192.729H191.311H191.449C191.449 192.729 191.449 192.867 191.587 192.867Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.008 194.939C196.008 194.939 195.87 194.939 195.594 194.939H195.041L195.455 195.215L194.903 194.939H195.455C195.732 194.939 195.87 194.939 196.008 194.939C196.008 194.801 196.008 194.801 195.87 194.663C195.732 194.663 195.732 194.524 195.594 194.524C195.732 194.524 195.87 194.524 195.87 194.663C196.146 194.801 196.146 194.939 196.008 194.939Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.39 196.044C197.528 196.183 197.528 196.183 197.39 196.321C197.251 196.459 197.113 196.321 196.837 196.321C196.699 196.321 196.699 196.183 196.699 196.183C196.699 196.183 196.699 196.321 196.837 196.321C196.975 196.459 197.113 196.459 197.251 196.321C197.528 196.183 197.528 196.183 197.39 196.044H197.804L197.39 195.768L197.804 196.044H197.39Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.463 197.288L199.739 197.15L199.463 197.288L199.601 197.426L199.463 197.288L199.186 197.426L199.463 197.288L199.048 197.15L199.877 197.011L199.048 197.15L199.463 197.288Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.397 197.979L201.121 198.117C201.121 198.117 201.259 198.117 201.259 198.255C201.397 198.393 201.397 198.393 201.259 198.531C201.121 198.669 200.983 198.669 200.707 198.531C200.568 198.531 200.568 198.393 200.568 198.393L200.707 198.531C200.845 198.669 200.983 198.669 201.121 198.531C201.259 198.531 201.259 198.393 201.121 198.255C201.121 198.255 200.983 198.117 200.845 198.117L201.397 197.979L201.812 198.117L201.397 197.979Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.746 199.36C203.608 199.36 203.608 199.222 203.608 199.222C203.47 199.084 203.193 199.084 202.917 199.36C203.055 199.36 203.193 199.36 203.332 199.36C203.47 199.499 203.47 199.499 203.332 199.637C203.193 199.775 203.055 199.775 202.779 199.637C202.641 199.499 202.641 199.36 202.779 199.222C203.055 199.084 203.332 199.084 203.47 199.222C203.746 199.222 203.746 199.36 203.746 199.36ZM202.917 199.36C202.779 199.36 202.779 199.499 202.917 199.637C203.055 199.775 203.193 199.775 203.332 199.637C203.47 199.637 203.47 199.499 203.332 199.36C203.193 199.222 203.055 199.222 202.917 199.36Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.575 200.604L205.542 200.328L205.128 200.051H204.99L205.128 199.913L205.681 200.189L204.575 200.604Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.476 201.571C207.338 201.571 207.338 201.571 207.2 201.571C207.338 201.709 207.338 201.709 207.2 201.847C207.061 201.986 206.923 201.847 206.647 201.847C206.509 201.709 206.509 201.709 206.509 201.571C206.647 201.571 206.785 201.571 206.923 201.571V201.433C207.061 201.433 207.2 201.433 207.338 201.433C207.476 201.433 207.476 201.571 207.476 201.571ZM206.923 201.295C206.785 201.295 206.785 201.433 206.923 201.433C207.061 201.571 207.2 201.571 207.338 201.433C207.476 201.433 207.476 201.295 207.338 201.295C207.2 201.295 207.061 201.295 206.923 201.295ZM206.647 201.571C206.509 201.571 206.509 201.709 206.647 201.847C206.785 201.986 206.923 201.986 207.061 201.847C207.2 201.847 207.2 201.709 206.923 201.571C206.785 201.433 206.647 201.433 206.647 201.571Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.443 202.676C208.582 202.676 208.582 202.814 208.582 202.814C208.72 202.952 208.996 202.952 209.272 202.676C209.134 202.676 208.996 202.676 208.858 202.676C208.72 202.538 208.72 202.538 208.858 202.4C208.996 202.262 209.134 202.262 209.411 202.4C209.549 202.538 209.549 202.676 209.411 202.814C209.134 202.952 208.858 202.952 208.72 202.814C208.443 202.814 208.443 202.676 208.443 202.676ZM209.272 202.676C209.411 202.676 209.411 202.538 209.272 202.4C209.134 202.262 208.996 202.262 208.858 202.4C208.72 202.4 208.72 202.538 208.858 202.676C208.996 202.676 209.134 202.676 209.272 202.676Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.345 203.92C211.069 204.058 210.793 204.058 210.655 203.92C210.516 203.782 210.516 203.643 210.655 203.505C210.931 203.367 211.207 203.367 211.345 203.505C211.484 203.643 211.484 203.782 211.345 203.92ZM210.655 203.643C210.378 203.782 210.378 203.92 210.655 203.92C210.793 204.058 211.069 204.058 211.207 203.92C211.484 203.782 211.484 203.643 211.207 203.643C211.069 203.505 210.931 203.505 210.655 203.643Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.594 197.426L196.009 196.873L195.042 197.15L195.456 196.597L195.042 197.15L196.009 196.873L195.594 197.426L196.561 197.15L195.594 197.426Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.528 197.84L197.252 197.979L197.666 198.255L197.252 197.979L196.976 198.117L197.39 198.393L196.837 198.117L197.528 197.84L198.081 198.117L197.528 197.84Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.325 199.361L199.048 199.222L198.772 199.361L199.463 198.946L199.739 199.084C199.877 199.222 200.015 199.361 199.739 199.361C199.739 199.499 199.601 199.499 199.325 199.361V199.637V199.361ZM199.325 199.361C199.463 199.499 199.601 199.499 199.739 199.361C199.877 199.222 199.877 199.222 199.739 199.084L199.463 198.946L199.048 199.222L199.325 199.361Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.535 200.189L200.844 200.604L201.535 200.189L201.259 200.051L201.811 200.327L201.535 200.189Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.779 201.709L203.055 201.571L203.193 201.156L203.055 201.571H203.746L202.917 201.709H202.779Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.265 202.814C205.127 202.953 204.851 202.953 204.575 202.814C204.436 202.676 204.298 202.538 204.575 202.4L204.989 202.124L204.575 202.4C204.436 202.538 204.436 202.538 204.575 202.676C204.851 202.953 205.127 202.953 205.265 202.814L205.68 202.538L205.265 202.814Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.509 203.92L207.2 203.505L206.509 203.92Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.41 205.163C209.272 205.302 208.858 205.302 208.581 205.163C208.305 205.025 208.305 204.887 208.581 204.749C208.719 204.611 209.134 204.611 209.41 204.749C209.548 204.887 209.548 205.025 209.41 205.163ZM208.581 204.749C208.443 204.887 208.443 205.025 208.581 205.163C208.719 205.302 209.134 205.302 209.272 205.163C209.41 205.025 209.41 204.887 209.272 204.749C209.134 204.611 208.858 204.611 208.581 204.749Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.483 205.992C211.621 206.131 211.76 206.269 211.483 206.269C211.345 206.407 211.069 206.407 210.931 206.269L210.654 206.131L210.378 206.269L211.069 205.854L211.483 205.992ZM210.792 206.131L211.069 206.269C211.207 206.407 211.345 206.407 211.483 206.269C211.621 206.131 211.621 206.131 211.483 205.992L211.207 205.854L210.792 206.131Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.319 209.308L216.595 209.17L216.319 209.308Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.009 209.584L216.871 209.723L217.009 209.584V209.446C216.871 209.446 216.871 209.446 216.733 209.446L216.595 209.584L216.871 209.446H216.733C216.871 209.446 216.871 209.446 217.009 209.446C217.147 209.446 217.147 209.446 217.009 209.584Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.424 209.723C217.424 209.585 217.424 209.585 217.424 209.723C217.286 209.585 217.286 209.585 217.148 209.585C217.01 209.585 217.286 209.723 217.148 209.861C217.148 209.861 217.01 209.861 216.872 209.861C216.872 209.861 216.733 209.861 216.733 209.723C216.733 209.723 216.733 209.723 216.872 209.861H217.01C217.148 209.861 216.872 209.723 217.01 209.585C217.148 209.585 217.286 209.585 217.424 209.723C217.424 209.585 217.424 209.585 217.424 209.723Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.667 210.276C218.529 210.276 218.529 210.276 218.391 210.276C218.391 210.276 218.391 210.276 218.391 210.138L218.253 210.276L218.529 210.138H218.667C218.806 210.138 218.806 210.138 218.667 210.276ZM218.667 210.138C218.667 210 218.529 210 218.391 210V210.138C218.529 210.276 218.667 210.276 218.667 210.138Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.806 210.414H218.667C218.667 210.414 218.667 210.414 218.667 210.276C218.667 210.276 218.806 210.276 218.806 210.414C218.944 210.276 218.944 210.276 218.944 210.276H218.806H218.944C219.082 210.276 219.082 210.276 218.806 210.414ZM218.944 210.414C218.806 210.276 218.806 210.276 218.806 210.276C218.806 210.276 218.806 210.276 218.806 210.414C218.806 210.414 218.806 210.414 218.944 210.414Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.221 210.552C219.082 210.552 219.083 210.552 218.944 210.552C218.944 210.552 218.944 210.552 218.944 210.414C218.944 210.414 218.944 210.414 218.944 210.552C219.083 210.69 219.082 210.69 219.221 210.552H219.083C218.944 210.552 218.944 210.414 219.083 210.414C219.221 210.414 219.221 210.414 219.359 210.414C219.359 210.414 219.359 210.414 219.221 210.552L219.359 210.414L219.221 210.552ZM219.221 210.552C219.359 210.552 219.359 210.414 219.221 210.552C219.221 210.414 219.083 210.414 218.944 210.414V210.552C219.083 210.552 219.221 210.552 219.221 210.552Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.635 210.69L219.359 210.552V210.69C219.359 210.69 219.497 210.828 219.635 210.69C219.497 210.69 219.497 210.69 219.359 210.69C219.22 210.69 219.22 210.552 219.359 210.552C219.497 210.552 219.497 210.552 219.635 210.552C219.635 210.69 219.635 210.69 219.635 210.69ZM219.635 210.69C219.635 210.552 219.497 210.552 219.359 210.552L219.635 210.69Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.977 210.552C217.977 210.552 217.839 210.552 217.977 210.552C217.701 210.414 217.701 210.414 217.839 210.276C217.977 210.276 217.977 210.276 218.115 210.276C218.115 210.276 218.115 210.276 218.115 210.414L218.253 210.276L217.977 210.552ZM218.115 210.552C218.115 210.414 218.115 210.414 218.115 210.552C218.115 210.414 217.977 210.414 217.839 210.414V210.552C217.977 210.552 217.977 210.552 218.115 210.552Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.392 210.69C218.254 210.69 218.254 210.69 218.115 210.69C217.977 210.69 217.977 210.552 218.115 210.552C218.254 210.552 218.254 210.552 218.392 210.552C218.53 210.552 218.53 210.69 218.392 210.69ZM218.253 210.552C218.115 210.552 218.115 210.69 218.253 210.552C218.253 210.69 218.392 210.69 218.53 210.69V210.552C218.392 210.552 218.253 210.552 218.253 210.552Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.668 210.967L218.806 210.829L218.53 210.967L218.668 210.829L218.53 210.967L218.806 210.829L218.668 210.967L219.082 210.829L218.668 210.967Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.221 211.105L219.082 211.243L219.221 211.105C219.082 210.967 219.082 210.967 218.944 210.967L218.806 211.105L219.082 210.967C219.082 210.967 219.082 210.967 219.221 211.105Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.326 211.519C220.187 211.519 220.187 211.519 220.049 211.519C220.049 211.519 220.049 211.519 220.049 211.381L219.911 211.519L220.187 211.381H220.326C220.326 211.381 220.326 211.519 220.326 211.519ZM220.326 211.519C220.326 211.519 220.326 211.381 220.326 211.519C220.326 211.381 220.187 211.381 220.049 211.381V211.519C220.187 211.519 220.187 211.519 220.326 211.519Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.464 211.519H220.602H220.464L220.326 211.657L220.464 211.519Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.602 211.795C220.602 211.795 220.464 211.795 220.602 211.795C220.464 211.795 220.464 211.795 220.602 211.795L220.74 211.657H220.879H220.74L220.602 211.795C220.464 211.795 220.464 211.795 220.602 211.795Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.155 211.795C221.155 211.795 221.017 211.795 221.155 211.795C221.017 211.657 220.878 211.657 220.878 211.657C220.74 211.657 221.017 211.795 220.878 211.934C220.878 211.934 220.74 211.934 220.602 211.934C220.602 211.934 220.464 211.934 220.464 211.795C220.464 211.795 220.464 211.795 220.602 211.934H220.74C220.878 211.934 220.602 211.795 220.74 211.657C220.878 211.657 221.017 211.657 221.155 211.795Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.293 212.072C221.293 211.934 221.293 211.934 221.293 212.072C221.155 211.934 221.017 211.934 221.017 212.072V212.21H221.155H221.017C220.879 212.21 220.879 212.072 221.017 212.072C221.155 211.934 221.155 211.934 221.293 212.072C221.293 211.934 221.293 211.934 221.293 212.072Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.253 208.203L218.115 208.341L218.253 208.203C218.392 208.065 218.392 208.065 218.253 208.203C218.115 208.065 218.115 208.065 217.977 208.065H217.839L218.253 207.927L218.115 208.065C218.115 208.065 218.253 208.065 218.253 208.203C218.392 208.065 218.392 208.065 218.253 208.203Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.668 208.341C218.53 208.341 218.53 208.341 218.392 208.341C218.254 208.341 218.254 208.203 218.392 208.203C218.53 208.203 218.53 208.203 218.668 208.203V208.341ZM218.392 208.203C218.254 208.203 218.254 208.341 218.392 208.203C218.392 208.341 218.53 208.341 218.668 208.341V208.203C218.53 208.203 218.392 208.203 218.392 208.203Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.082 208.618C218.944 208.48 218.944 208.48 218.806 208.48H218.668L218.806 208.342C218.806 208.342 218.806 208.342 218.806 208.203C218.806 208.203 218.668 208.203 218.53 208.203H218.392L218.668 208.065H218.806C218.806 208.065 218.806 208.065 218.806 208.203C219.082 208.48 219.082 208.48 219.082 208.618Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.497 208.894L219.22 208.756V208.894C219.22 208.894 219.22 208.894 219.497 208.894C219.358 208.894 219.358 208.894 219.22 208.894C219.082 208.894 219.082 208.756 219.22 208.756C219.358 208.756 219.358 208.756 219.497 208.756C219.497 208.756 219.497 208.756 219.497 208.894ZM219.358 208.894C219.497 208.756 219.497 208.756 219.358 208.894C219.358 208.756 219.22 208.756 219.082 208.756L219.358 208.894Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.588 204.749L212.45 204.887L212.588 204.749L212.312 204.611L212.588 204.749L212.727 204.611L212.588 204.749L212.865 204.887L212.588 204.749Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.865 204.887L213.279 205.163L212.865 204.887ZM212.727 204.887L213.141 205.163L212.727 204.887Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.45 207.374L213.003 206.683L212.45 207.374Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.588 207.374L213.556 206.821L212.588 207.374Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.602 209.17C220.464 209.17 220.464 209.17 220.326 209.17C220.326 209.17 220.326 209.17 220.326 209.032L220.188 209.17L220.464 209.032H220.602C220.74 209.17 220.74 209.17 220.602 209.17ZM220.602 209.17C220.74 209.17 220.74 209.17 220.602 209.17C220.602 209.032 220.464 209.032 220.326 209.032V209.17C220.464 209.17 220.602 209.17 220.602 209.17Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.878 209.446H220.74C220.74 209.446 220.74 209.446 220.74 209.308C220.74 209.308 220.74 209.308 220.878 209.446C221.016 209.308 221.016 209.308 221.016 209.308H220.878H221.016C221.016 209.308 221.016 209.308 220.878 209.446ZM220.878 209.446C220.74 209.308 220.74 209.308 220.74 209.308C220.74 209.308 220.74 209.308 220.74 209.446C220.74 209.446 220.74 209.446 220.878 209.446Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.155 209.585C221.017 209.585 221.017 209.585 220.878 209.585C220.878 209.585 220.878 209.585 220.878 209.447C220.878 209.447 220.878 209.447 220.878 209.585C221.017 209.585 221.017 209.585 221.155 209.585H221.017C220.878 209.585 220.878 209.447 221.017 209.447C221.155 209.447 221.155 209.447 221.293 209.447C221.293 209.447 221.293 209.447 221.155 209.585L221.293 209.447L221.155 209.585ZM221.293 209.585C221.293 209.447 221.293 209.447 221.293 209.585C221.293 209.447 221.155 209.447 221.017 209.447V209.585C221.017 209.585 221.155 209.585 221.293 209.585Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.569 209.723L221.293 209.584V209.723C221.431 209.723 221.431 209.723 221.569 209.723C221.431 209.723 221.431 209.723 221.293 209.723C221.155 209.723 221.155 209.584 221.293 209.584C221.431 209.584 221.431 209.584 221.569 209.584C221.708 209.584 221.708 209.723 221.569 209.723ZM221.569 209.723C221.569 209.723 221.569 209.584 221.569 209.723C221.569 209.584 221.431 209.584 221.293 209.584L221.569 209.723Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.187 209.723C220.049 209.585 220.049 209.585 220.049 209.585L220.187 209.447L220.049 209.585C220.049 209.585 220.049 209.585 220.187 209.723L220.464 209.585L220.187 209.723Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.74 209.861C220.602 209.861 220.602 209.861 220.463 209.861C220.463 209.861 220.463 209.861 220.463 209.723L220.325 209.861L220.602 209.723H220.74C220.74 209.861 220.74 209.861 220.74 209.861ZM220.74 209.861C220.74 209.723 220.602 209.723 220.463 209.723V209.861C220.463 209.861 220.602 209.861 220.74 209.861Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.122 210.414C221.983 210.414 221.983 210.414 221.845 210.414C221.845 210.414 221.845 210.414 221.845 210.276L221.707 210.414L221.983 210.276H222.122V210.414ZM222.122 210.414C222.122 210.414 222.122 210.276 222.122 210.414C222.122 210.276 221.983 210.276 221.845 210.276V210.414C221.983 210.414 221.983 210.414 222.122 210.414Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.26 210.552H222.122C222.122 210.552 222.122 210.552 222.122 210.414C222.122 210.414 222.26 210.414 222.26 210.552C222.398 210.414 222.398 210.414 222.398 210.414H222.26H222.398C222.398 210.414 222.398 210.552 222.26 210.552ZM222.26 210.552C222.122 210.414 222.122 210.414 222.122 210.414C222.122 210.414 222.122 210.414 222.122 210.552H222.26Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.536 210.828C222.397 210.69 222.397 210.69 222.397 210.69L222.536 210.552L222.397 210.69C222.397 210.69 222.397 210.69 222.536 210.828L222.812 210.69L222.536 210.828Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.089 210.828C222.951 210.828 222.951 210.828 223.089 210.828C222.951 210.828 222.951 210.69 222.951 210.828C222.951 210.828 223.089 210.967 222.951 210.967H222.812C222.812 210.967 222.812 210.967 222.812 210.828H222.951C223.089 210.828 222.813 210.69 222.951 210.69C222.813 210.69 222.951 210.69 223.089 210.828C222.951 210.828 222.951 210.828 223.089 210.828Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.227 211.105L222.95 210.967V211.105C223.088 211.105 223.088 211.105 223.227 211.105C223.088 211.105 223.088 211.105 222.95 211.105C222.812 211.105 222.812 210.967 222.95 210.967C223.088 210.967 223.088 210.967 223.227 210.967C223.365 210.967 223.365 210.967 223.227 211.105ZM223.227 211.105C223.227 210.967 223.227 210.967 223.227 211.105C223.227 210.967 223.088 210.967 222.95 210.967L223.227 211.105Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.615 210.414C228.615 210.276 228.615 210.276 228.753 210.138C228.892 210.138 229.03 210 229.168 210C229.306 210 229.444 210 229.582 210L229.997 210.276C230.135 210.414 229.997 210.552 229.859 210.69C229.721 210.829 229.582 210.829 229.306 210.829C229.168 210.829 228.892 210.829 228.753 210.69C228.615 210.69 228.615 210.552 228.615 210.414ZM229.444 210.138C229.306 210.138 229.306 210.138 229.168 210.138C229.03 210.138 228.892 210.138 228.892 210.276C228.615 210.414 228.615 210.69 228.892 210.829C229.03 210.829 229.168 210.967 229.306 210.967C229.444 210.967 229.582 210.967 229.721 210.829C229.859 210.69 229.997 210.552 229.859 210.414L229.444 210.138Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.03 210.552L229.721 210.137H229.859L229.168 210.552H229.03Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.661 212.763L215.49 212.348H215.628L214.799 212.763H214.661Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.799 212.348H215.628V212.901L214.799 212.348Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.727 213.868L213.556 213.453H213.694L212.865 213.868H212.727Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.727 213.868V213.315L213.556 213.729L212.727 213.868Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.793 212.209H210.931L211.76 212.762H211.622L210.793 212.209Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.793 212.209L211.622 212.348L210.931 212.762L210.793 212.209Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.522 214.558H214.66L215.489 214.973L214.522 214.558Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.661 214.973L215.351 214.558L215.49 215.111L214.661 214.973Z",
    fill: "#DAEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.147 181.675L202.364 153.627L240.36 175.596L234.419 204.334L196.147 181.675Z",
    fill: "#CFE8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.397 157.911L202.364 153.627L240.36 175.596L239.393 180.294L201.397 157.911Z",
    fill: "#EFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.102 161.088L210.24 159.983L231.656 172.28L231.38 173.662L210.102 161.088Z",
    fill: "#90B1B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.154 183.195L204.99 161.641L234.281 178.636L229.721 200.742L200.154 183.195Z",
    fill: "#F5FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.733 191.347L218.115 192.176L218.668 192.452L220.878 193.834L222.398 194.663L223.642 195.354L223.918 195.63L227.649 197.702L227.925 197.841L228.063 196.459L229.445 188.722L227.649 187.754L226.958 187.34L223.78 185.544L222.536 184.853L221.017 183.886L218.53 182.504L218.115 182.228L217.701 185.267L216.733 191.347Z",
    fill: "#097A57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.878 192.037L221.707 186.649L225.162 191.485L220.878 192.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.608 174.629L203.746 173.662L216.319 180.708L216.181 181.952L203.608 174.629Z",
    fill: "#BCE7F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.193 177.254L203.332 176.286L215.905 183.471L215.766 184.576L203.193 177.254Z",
    fill: "#A2D7E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.641 179.879L202.917 179.05L215.49 186.096L215.214 187.202L202.641 179.879Z",
    fill: "#A2D7E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.226 182.78L202.364 181.813L214.937 188.86L214.799 190.103L202.226 182.78Z",
    fill: "#A2D7E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.313 261.95C212.313 261.95 214.109 261.95 215.076 263.055C216.872 264.989 216.043 266.924 213.003 268.72C211.622 269.549 211.345 269.963 207.753 271.207C205.957 271.898 202.917 272.727 201.812 273.418C200.707 274.108 199.187 274.385 197.805 273.418C196.423 272.45 195.042 271.069 195.733 268.858C196.285 267.2 196.285 262.364 196.285 262.364L201.121 262.502L212.313 261.95Z",
    fill: "#313D3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.877 255.594C199.877 255.594 201.674 255.594 202.503 256.561C204.161 258.357 203.332 260.153 200.43 261.949C199.187 262.778 198.772 263.055 195.456 264.298C193.66 264.989 190.897 265.818 189.791 266.371C188.686 266.923 187.304 267.338 185.923 266.371C184.541 265.404 183.297 264.16 183.988 262.088C184.541 260.568 184.541 256.008 184.541 256.008L189.1 256.146L199.877 255.594Z",
    fill: "#242C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.772 232.106C198.772 232.106 197.667 247.442 197.39 248.686C197.114 249.929 196.147 257.39 196.147 257.39C196.147 257.39 194.213 260.292 190.62 260.844C187.028 261.397 183.574 259.601 183.574 259.048C183.436 258.495 183.436 258.495 183.436 258.495C183.436 258.495 184.817 242.054 185.094 240.119C185.37 238.047 198.772 232.106 198.772 232.106Z",
    fill: "#2B313D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.207 236.941C211.207 236.941 210.102 253.245 209.688 254.627C209.411 255.87 208.306 263.884 208.306 263.884C208.306 263.884 206.233 266.923 202.503 267.614C198.772 268.167 195.042 266.371 195.042 265.68C194.904 264.989 194.904 264.989 194.904 264.989C194.904 264.989 196.424 247.442 196.7 245.508C196.976 243.297 211.207 236.941 211.207 236.941Z",
    fill: "#373E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.249 282.536L140.328 244.678C140.604 243.297 141.295 242.191 142.539 241.501L150.138 237.079C151.105 236.527 152.21 236.25 153.316 236.527C154.836 236.803 155.941 237.77 156.632 239.014L168.099 263.193L171.001 261.811L159.533 237.632C159.257 237.079 158.842 236.389 158.428 235.974C155.803 232.934 151.658 232.52 148.618 234.316L140.881 238.737C138.808 239.843 137.427 241.915 137.15 244.264L131.071 282.26C130.933 283.089 131.485 283.78 132.314 283.918C133.143 284.056 134.111 283.365 134.249 282.536Z",
    fill: "#8FA7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.289 239.981L169.066 262.779L167.961 263.331L156.493 239.152C156.217 238.6 155.802 238.047 155.388 237.771C156.631 237.909 157.737 238.738 158.289 239.981Z",
    fill: "#798DA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.932 282.26L137.012 244.264C137.426 241.916 138.808 239.981 140.742 238.738L148.479 234.316C151.105 232.797 154.282 232.935 156.769 234.731C154.559 233.902 152.21 234.04 150.137 235.284L142.4 239.705C140.328 240.81 138.946 242.883 138.67 245.231L132.59 283.227C132.59 283.504 132.59 283.78 132.728 284.056C132.59 284.056 132.314 284.056 132.176 284.056C131.347 283.78 130.794 282.951 130.932 282.26Z",
    fill: "#BCCFE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.878 260.153L170.311 243.159L198.358 256.561C198.496 256.561 200.154 259.048 199.878 260.153Z",
    fill: "#AF8103"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.184 236.112L155.941 236.803L156.494 239.014L158.29 238.047C158.981 237.632 159.671 237.494 160.362 237.356C161.882 237.218 163.54 237.909 164.507 239.152L165.474 240.396L165.613 240.534L167.271 239.152L166.165 237.909C165.613 237.218 165.06 236.803 164.369 236.389C162.435 235.145 159.948 235.007 157.737 235.974C157.461 235.974 157.323 236.112 157.184 236.112Z",
    fill: "#B7F555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.683 245.646C148.48 250.896 158.151 260.982 162.573 265.403C163.954 266.785 164.783 267.614 164.783 267.614C164.783 267.614 166.027 268.858 168.652 268.858C170.31 268.858 172.659 268.443 175.422 266.785C176.666 266.094 178.047 265.265 179.429 264.436C185.094 261.258 191.588 257.666 193.798 256.561C194.213 256.284 194.489 256.146 194.489 256.146L198.634 255.594L164.369 235.974C164.369 235.974 159.671 235.283 157.322 235.974C153.315 237.218 150.138 240.257 147.098 242.33C146.131 243.159 146.131 244.126 146.683 245.646Z",
    fill: "#FFCE3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.302 246.06C147.098 251.311 156.77 261.397 161.191 265.818L167.271 269.272C168.929 269.272 171.278 268.858 174.041 267.2C175.284 266.509 176.666 265.68 178.048 264.851L145.302 246.06Z",
    fill: "#D6A213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.737 235.836L160.362 237.356L165.474 240.396L165.612 240.534L193.66 256.699C194.075 256.423 194.351 256.285 194.351 256.285L198.496 255.732L164.369 236.251C162.434 235.007 159.947 234.869 157.737 235.836Z",
    fill: "#D6A213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.362 165.095C160.362 165.095 159.257 165.924 159.257 166.891C159.257 167.858 159.533 169.516 160.777 170.76C161.882 172.003 163.125 165.647 160.362 165.095Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.051 200.051C140.051 200.051 140.189 207.235 142.676 211.38C145.163 215.525 148.065 207.373 148.065 207.373C148.065 207.373 143.091 198.669 140.051 200.051Z",
    fill: "#F9C8A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.341 181.26C148.341 181.26 145.44 180.57 143.229 184.715C141.019 188.86 139.637 195.353 139.361 196.873C139.084 198.393 139.361 201.433 139.361 201.433C139.361 201.433 140.88 204.196 143.367 204.058C145.854 203.782 148.341 181.26 148.341 181.26Z",
    fill: "#22AD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.302 252.001C145.302 252.001 145.716 256.975 153.315 259.462C160.915 261.949 167.132 264.989 177.218 261.396C187.304 257.666 203.47 245.369 204.161 244.817C204.851 244.264 211.069 236.803 211.069 236.803C211.069 236.803 209.135 226.026 199.048 227.684C190.068 229.204 169.343 235.283 169.343 235.283L145.302 252.001Z",
    fill: "#4A5266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.876 240.81C179.153 241.501 179.015 248.962 178.462 249.376C177.909 249.791 169.896 256.285 165.751 257.943C162.849 259.186 154.007 259.739 147.789 255.594C146.684 254.903 145.993 253.798 145.302 252.831C141.295 247.995 140.881 243.988 140.743 241.086C140.604 237.77 141.986 227.961 142.539 220.085C142.677 218.565 142.677 217.046 142.677 215.526C142.677 208.756 141.848 201.433 141.986 193.695C142.262 184.024 146.546 181.399 148.204 181.26C149.862 181.26 158.704 183.471 158.704 183.471L173.488 191.899L182.745 199.913C182.745 199.913 177.495 218.842 177.357 220.776C177.218 222.849 178.738 240.119 178.876 240.81Z",
    fill: "#097A57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.061 167.996C186.061 168.964 182.469 178.773 181.778 180.155C181.087 181.537 177.08 183.195 177.08 183.195C177.08 183.195 175.837 186.234 175.008 189.412C174.041 192.59 175.008 193.004 175.008 193.004C175.008 193.004 170.863 193.281 166.856 192.728C164.922 192.452 163.125 192.037 161.744 191.346C157.737 189.136 157.875 183.747 157.875 183.747C157.875 183.747 157.875 183.747 158.704 183.195C159.533 182.78 161.744 180.708 162.711 178.083C163.125 177.115 162.296 176.148 162.573 175.181C162.849 174.076 163.402 172.97 163.816 172.003C164.783 169.931 166.165 168.135 167.823 166.477C170.31 163.99 173.488 162.193 176.942 161.226C178.186 160.95 179.291 160.674 180.534 160.95C182.054 161.226 183.436 162.193 184.127 163.575C184.956 164.957 186.061 166.615 186.061 167.996Z",
    fill: "#F9C8A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.12 174.628C180.12 174.628 178.186 176.01 177.495 177.806C176.804 179.602 176.666 180.017 177.218 180.984C177.771 181.951 179.705 181.122 179.705 181.122C179.705 181.122 183.16 178.221 183.16 176.977C183.021 175.734 183.021 175.734 183.021 175.734L180.12 174.628Z",
    fill: "#DEA583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.146 180.57C175.146 180.57 172.382 181.813 170.862 184.715C169.481 187.478 169.895 191.07 170.034 191.347C170.172 191.623 172.382 192.176 172.382 192.176C172.382 192.176 172.659 188.307 172.797 187.616C172.797 187.063 175.56 181.399 175.56 181.399L175.146 180.57Z",
    fill: "#FAD0B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.797 179.188L172.658 181.675C172.658 181.675 169.619 183.195 168.79 185.405C167.823 187.478 167.132 190.103 166.994 193.004C165.059 192.728 163.263 192.314 161.881 191.623C157.875 189.412 158.013 184.024 158.013 184.024C158.013 184.024 158.013 184.024 158.842 183.471C159.671 183.056 161.881 180.984 162.849 178.359C163.263 177.253 162.434 175.872 161.605 173.938C166.717 176.148 172.797 179.188 172.797 179.188Z",
    fill: "#DEA583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.284 192.314C175.284 192.314 172.797 192.728 169.066 192.452C165.336 192.176 162.434 190.103 162.434 190.103C162.434 190.103 160.085 188.031 159.118 183.333C158.98 182.504 159.257 182.504 159.257 182.504H156.217C156.217 182.504 155.941 187.34 158.566 190.794C161.053 194.248 166.856 195.63 169.895 195.63C172.935 195.63 176.804 194.663 176.804 194.663L175.284 192.314Z",
    fill: "#249572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.166 164.542C186.614 167.582 186.199 166.062 186.061 167.444C185.923 168.825 185.647 171.174 185.647 171.174L184.127 174.49L183.574 174.766C183.574 174.766 183.436 174.49 183.16 174.214C182.607 173.523 181.778 172.418 181.502 172.556C181.087 172.832 179.567 173.799 178.186 176.01C178.047 176.148 178.047 176.286 177.909 176.286C176.389 178.497 172.797 181.398 172.797 181.398C172.797 181.398 168.79 180.846 167.132 180.431C166.994 180.431 166.994 180.431 166.856 180.293C165.198 179.74 163.678 178.082 163.678 177.944C163.678 177.806 161.744 173.799 160.5 169.792C159.257 165.647 161.606 158.877 164.369 157.081C166.718 155.423 170.172 153.489 175.146 153.489C175.837 153.489 176.389 153.489 177.218 153.489C183.298 153.903 186.199 159.015 186.199 159.015C186.199 159.015 187.719 161.502 187.166 164.542Z",
    fill: "#9A5132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.817 172.28C184.541 173.109 183.85 173.799 183.021 174.352C182.607 174.628 182.054 174.905 181.501 175.043C180.258 175.457 179.014 175.872 177.771 176.425C177.633 176.425 177.494 176.563 177.494 176.563C176.804 176.977 176.251 177.392 175.56 177.668C174.593 178.083 173.488 177.806 172.521 177.806C171.001 177.806 169.481 178.083 168.237 178.773C167.961 178.912 167.685 179.05 167.408 179.326C167.132 179.602 166.994 180.017 166.856 180.431C165.198 179.879 163.678 178.221 163.678 178.083C163.678 177.944 161.744 173.938 160.5 169.931C159.257 165.786 161.467 159.154 164.092 157.358C166.441 155.7 170.172 153.627 175.146 153.627C172.659 154.318 170.31 155.423 168.376 157.081C166.856 158.463 165.75 160.259 165.474 162.194C165.336 163.852 165.889 165.51 166.994 166.615C168.099 167.858 169.895 168.687 171.553 168.964C173.211 169.24 175.008 169.102 176.665 168.964C177.771 168.825 179.014 168.687 180.12 168.135C181.639 167.444 182.745 166.062 183.85 164.68C184.403 166.2 184.679 167.858 184.955 169.378C185.094 170.483 185.094 171.451 184.817 172.28Z",
    fill: "#893510"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.961 162.47C167.685 162.47 167.27 162.608 166.994 162.608C167.547 162.193 166.994 161.364 167.27 160.673C167.408 160.535 167.408 160.397 167.547 160.259C167.823 159.706 167.961 159.015 168.514 158.601C168.237 158.739 167.961 159.015 167.685 159.154C167.547 159.292 167.27 159.43 167.132 159.706C166.994 159.844 166.856 159.983 166.856 160.259C166.441 160.95 166.027 161.641 165.75 162.331C165.612 162.608 165.06 163.989 164.783 163.989C165.06 163.989 165.198 163.851 165.474 163.851C165.474 164.542 165.474 165.371 165.474 166.062C165.75 165.786 166.027 165.647 166.441 165.371C166.441 165.786 166.441 166.338 166.303 166.753C166.579 166.476 166.994 166.338 167.408 166.2C167.408 166.753 167.408 167.167 167.408 167.72C167.408 167.858 167.408 167.858 167.408 167.996C167.547 168.134 167.685 167.996 167.823 167.996C168.237 167.72 168.652 167.444 169.066 167.167C169.205 167.029 169.343 167.029 169.343 167.029C169.619 167.029 169.757 167.444 169.757 167.72C169.757 167.996 169.757 168.411 169.895 168.549C170.172 168.825 170.586 168.687 170.863 168.411C171.139 168.134 171.277 167.858 171.692 167.72C171.692 167.72 171.83 167.582 171.968 167.72C172.244 167.72 172.244 167.996 172.244 168.273C172.382 169.102 172.797 169.931 173.35 170.483C173.626 170.069 173.764 169.654 174.04 169.24C174.179 169.102 174.317 168.825 174.455 168.963C174.593 168.963 174.593 169.102 174.731 169.24C174.869 169.516 175.146 169.931 175.284 170.207C175.56 169.654 176.251 169.378 176.804 169.516C176.804 169.378 176.804 169.24 176.666 169.24C176.804 169.516 176.942 169.654 177.08 169.931C177.494 169.516 177.771 169.102 178.047 168.687C178.185 168.963 178.323 169.24 178.462 169.378C178.738 169.516 179.014 169.516 179.152 169.24C179.152 169.102 179.152 168.825 179.291 168.687C179.429 168.549 179.567 168.549 179.705 168.549C180.12 168.687 180.396 168.963 180.81 169.102C181.225 169.24 181.778 169.378 181.916 168.963C182.054 168.687 182.054 168.411 181.916 168.134C181.778 167.858 181.639 167.582 181.639 167.305C181.639 167.029 182.054 166.753 182.33 166.891C182.468 167.029 182.607 167.167 182.745 167.029C182.745 166.476 182.745 166.062 182.745 165.509C183.297 165.233 183.85 164.818 183.712 164.266C183.988 164.266 184.126 164.266 184.265 164.128C184.403 163.989 184.541 163.713 184.403 163.575C184.265 163.437 184.126 163.437 184.126 163.299C183.988 163.16 184.265 163.022 184.265 162.884C184.265 162.746 184.265 162.608 184.126 162.47C183.988 162.055 183.712 161.641 183.574 161.364C183.988 161.364 184.403 161.364 184.817 161.364C184.679 161.088 184.403 160.812 184.265 160.535L184.126 160.397C184.126 160.259 184.265 160.121 184.403 160.121C184.541 160.121 184.679 160.121 184.817 159.983C184.403 159.292 183.85 158.877 183.159 158.601C182.468 158.325 181.778 158.187 181.087 158.048C181.363 158.187 181.639 158.187 181.778 158.325C181.639 158.325 180.949 158.877 181.087 159.015C181.501 159.292 181.778 159.706 181.778 160.259V160.397H181.639C181.501 160.397 181.225 160.259 180.949 160.259C180.81 160.259 180.81 160.259 180.81 160.259V160.397C180.949 160.673 180.949 160.95 180.81 161.088C180.672 161.226 180.396 161.226 180.396 161.364V161.502C180.534 161.779 180.81 162.055 180.949 162.331C180.534 162.746 180.12 162.884 179.705 163.16C179.291 163.575 179.152 164.266 179.014 164.818C178.876 165.095 178.6 165.509 178.323 165.371C178.185 165.233 178.185 165.095 178.047 165.095C177.909 165.095 177.771 165.233 177.771 165.233C177.494 165.509 177.356 165.786 177.08 166.062C176.804 165.924 176.251 165.924 175.975 166.062C175.56 166.2 175.284 166.476 175.007 166.753C174.317 166.476 173.902 165.924 173.764 165.233C173.211 165.786 172.382 166.062 171.553 166.2C171.553 166.062 171.415 165.786 171.415 165.647C170.863 165.786 170.448 166.062 169.895 166.2C169.619 165.647 169.757 164.957 170.034 164.404C169.481 164.542 169.066 164.68 168.514 164.68C168.376 164.68 168.237 164.68 168.099 164.542C167.547 163.437 167.685 162.884 167.961 162.47Z",
    fill: "#B5734A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.85 172.556C183.85 173.108 183.574 173.799 183.297 174.214C182.883 174.766 182.192 174.766 181.777 175.181C181.501 175.457 181.363 175.734 181.087 176.01C180.81 176.286 180.534 176.563 180.258 176.839C179.981 176.977 179.705 177.115 179.429 176.977C179.29 176.839 179.152 176.563 179.152 176.424C179.014 175.872 179.152 175.319 179.29 174.766C179.567 174.214 179.843 173.661 180.396 173.108C180.81 172.694 181.639 172.279 181.777 171.865C182.054 171.45 181.777 170.345 181.639 169.792C181.501 169.102 181.225 168.411 180.948 167.858C180.258 166.476 179.152 165.095 178.047 164.128C177.771 163.851 177.356 163.575 176.942 163.299C175.284 161.641 172.935 160.812 170.862 159.844C169.204 159.015 167.546 158.325 165.75 158.601C165.059 158.601 164.507 158.877 163.816 159.154C163.263 159.43 162.987 159.706 162.572 160.121C162.158 160.535 162.02 160.259 162.158 159.706C162.434 159.154 162.71 158.601 163.263 158.325C163.816 157.91 164.368 157.634 165.059 157.496C165.888 157.357 166.717 157.357 167.408 157.357C168.513 157.357 169.481 157.634 170.448 157.91C171.415 158.325 172.382 159.015 173.349 159.43C174.178 159.844 175.145 160.121 176.113 160.535C177.771 161.364 179.29 162.746 180.672 164.128C180.948 164.404 181.363 164.818 181.639 165.233C181.777 165.509 181.916 165.924 182.054 166.2C182.606 167.858 183.159 169.516 183.85 171.036C183.574 171.589 183.85 172.003 183.85 172.556Z",
    fill: "#6A2700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.468 173.385C182.468 173.385 183.159 172.28 182.192 170.069C181.225 167.858 179.429 163.299 171.277 159.707C163.125 156.114 162.434 159.43 161.605 160.95C160.776 162.47 160.224 166.062 160.224 166.062C160.224 166.062 159.533 159.983 163.54 157.634C167.685 155.285 172.659 157.496 175.975 159.154C179.291 160.812 183.85 165.095 184.955 168.135C186.061 171.174 183.712 173.661 183.712 173.661L182.468 173.385Z",
    fill: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.159 172.141C183.159 172.141 182.192 172.141 181.087 172.97C179.982 173.799 179.014 175.457 178.738 177.53C178.462 179.74 179.843 180.569 180.672 180.431C181.501 180.293 183.712 179.05 184.265 178.083C184.817 176.977 185.232 173.109 185.232 173.109L183.159 172.141Z",
    fill: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.712 172.694C183.712 172.694 182.883 172.694 182.054 173.523C181.225 174.352 179.981 175.734 179.843 177.944C179.567 180.155 180.81 180.569 181.501 180.431C182.192 180.293 184.126 179.464 184.541 178.359C184.955 177.253 185.37 173.385 185.37 173.385L183.712 172.694Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.37 172.694C185.37 172.694 186.199 176.977 183.85 179.74C183.159 180.569 181.639 179.879 181.363 179.74C180.672 179.464 180.672 177.53 180.81 176.839C180.949 175.734 182.883 173.385 182.883 173.385L184.817 171.865C184.541 171.865 185.232 172.141 185.37 172.694Z",
    fill: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.411 219.256C208.72 220.223 207.339 222.296 206.51 222.987C205.681 223.677 204.575 223.263 203.055 225.197C202.365 226.026 200.845 228.099 199.187 230.309C199.187 230.309 199.187 230.309 199.049 230.448C196.838 233.349 194.213 236.665 192.693 238.047C190.068 240.534 188.133 242.054 183.988 242.192C179.843 242.33 175.284 228.375 175.284 227.822C175.284 227.546 175.008 225.335 174.593 222.848C174.179 220.223 173.902 217.322 173.902 217.322L187.028 220.914C187.028 220.914 188.272 225.474 188.41 227.132C188.548 228.099 188.548 228.651 188.41 228.928C188.41 229.066 188.41 229.066 188.41 229.066C188.962 228.79 192.831 226.026 194.075 224.506C195.318 222.848 197.943 219.809 197.943 219.809C197.943 219.809 197.805 216.216 197.943 215.802C198.081 215.387 199.049 213.729 199.601 213.177C200.292 212.486 200.845 213.177 200.845 213.177C200.845 213.177 201.536 212.624 202.226 212.21C202.641 211.933 203.194 211.657 203.332 211.657C203.746 211.657 204.99 212.071 205.542 212.762C206.233 213.453 206.51 214.144 207.2 214.835C207.891 215.526 208.858 216.216 208.858 216.769C208.997 217.736 210.24 218.289 209.411 219.256Z",
    fill: "#F9C8A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.186 230.586C196.976 233.487 194.351 236.803 192.831 238.185C190.206 240.672 188.271 242.191 184.126 242.33C179.981 242.468 175.422 228.513 175.422 227.96C175.422 227.684 175.145 225.473 174.731 222.986C179.29 222.296 187.304 224.092 187.719 224.368C187.719 224.368 186.337 226.855 183.988 227.408C181.639 228.099 177.356 227.822 177.356 227.822C177.356 227.822 179.014 234.316 181.225 237.494C183.297 240.533 184.403 242.053 186.475 241.777C188.548 241.501 190.758 239.704 195.18 235.007C196.423 233.349 197.805 231.829 199.186 230.586Z",
    fill: "#DEA583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.239 224.783C189.239 224.783 188.686 226.303 184.403 226.717C182.468 226.855 179.981 226.717 177.909 226.441C175.56 226.165 173.626 225.75 173.626 225.75C173.626 225.75 171.553 216.078 171.553 213.315C171.553 212.486 171.553 211.243 171.691 209.861C172.106 206.545 173.349 202.538 177.356 200.604C183.159 197.84 185.508 201.709 185.508 201.709C185.508 201.709 186.475 203.367 186.752 208.065C187.166 212.901 189.239 224.783 189.239 224.783Z",
    fill: "#22AD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.548 229.204C188.548 229.204 188.548 230.862 189.101 231.967C189.653 233.073 190.206 233.625 190.206 233.625C190.206 233.625 189.515 231.553 189.377 231.138C189.239 230.724 189.101 228.928 189.101 228.928L188.548 229.204Z",
    fill: "#FAD0B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.719 226.441C187.719 226.441 184.679 227.96 183.021 228.099C181.363 228.375 184.817 237.218 186.061 238.185C187.304 239.152 190.62 237.218 192.417 235.698C194.213 234.178 196.7 229.618 196.7 229.618C196.7 229.618 195.733 226.717 193.384 228.789C190.897 230.862 190.206 232.934 190.206 232.934C190.206 232.934 188.548 233.073 188.133 231.553C187.581 229.895 187.719 226.441 187.719 226.441Z",
    fill: "#FAD0B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.713 214.559C204.713 214.559 202.917 215.25 202.779 217.46C202.641 219.671 201.95 222.434 203.47 222.849C204.989 223.263 206.647 221.743 207.2 221.329C207.753 220.914 209.411 219.118 209.134 218.704C208.996 218.289 208.029 216.217 207.615 216.217C207.2 216.217 205.818 215.94 205.818 215.802C205.68 215.664 205.404 214.144 204.713 214.559Z",
    fill: "#FAD0B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.503 212.348C202.503 212.348 202.364 214.835 201.95 215.249C201.535 215.664 199.739 217.184 199.463 218.151C199.187 219.118 197.529 221.743 196.976 222.296C196.285 222.849 193.798 225.336 191.864 227.132C190.068 228.652 188.962 229.066 188.686 229.204C189.239 228.928 193.107 226.165 194.351 224.645C195.594 222.987 198.219 219.947 198.219 219.947C198.219 219.947 198.081 216.355 198.219 215.94C198.358 215.526 199.325 213.868 199.877 213.315C200.568 212.624 201.121 213.315 201.121 213.315C201.121 213.315 201.812 212.762 202.503 212.348Z",
    fill: "#DEA583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.508 172.279L183.573 173.799C183.573 173.799 183.988 172.556 183.021 170.483C182.054 168.273 179.428 162.746 171.277 159.154C163.816 155.838 162.019 158.601 161.052 160.397C161.052 160.259 161.19 160.259 161.19 160.121C161.881 158.463 164.092 156.943 164.368 156.805C168.237 155.147 172.796 157.219 175.836 158.739C179.152 160.397 183.711 164.68 184.679 167.72C185.922 170.621 185.508 172.279 185.508 172.279Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.337 173.109C186.337 173.109 186.752 176.424 184.403 179.188C182.054 181.951 182.192 178.359 182.192 177.254C182.331 176.148 183.574 173.661 183.574 173.661L185.508 172.141C185.508 172.28 186.337 172.556 186.337 173.109Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.624 249.376L129.552 248.133C130.104 248.547 130.657 248.962 131.348 249.238C131.486 249.376 131.486 249.376 131.624 249.376Z",
    fill: "#B7F555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.551 248.271C129.413 248.271 129.413 248.133 129.551 248.271V248.271Z",
    fill: "#A1DE36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.083 211.657C119.188 213.038 120.017 214.558 120.432 216.354C120.432 216.493 120.432 216.493 120.57 216.631L120.708 216.907L125.268 238.046L125.406 238.599L126.235 242.33C126.649 244.402 127.755 246.198 129.413 247.442C129.413 247.442 129.413 247.442 129.551 247.442L131.623 248.685L162.434 266.371C161.467 265.265 160.776 263.884 160.5 262.502L159.533 258.357L154.835 236.665C154.283 234.316 150.967 230.724 149.585 229.342L140.466 225.197C135.492 222.986 130.794 220.223 126.373 217.183L118.083 211.657Z",
    fill: "#D49F34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.083 211.657C119.188 213.038 120.017 214.558 120.432 216.354C120.432 216.493 120.432 216.493 120.57 216.631L120.708 216.907L154.835 236.665C154.283 234.316 150.967 230.724 149.585 229.342L140.466 225.197C135.492 222.986 130.794 220.223 126.373 217.183L118.083 211.657Z",
    fill: "#C48616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.458 209.861L126.373 217.184C130.933 220.223 135.63 222.848 140.466 225.197L149.585 229.342L150.829 227.546L141.295 223.125C136.459 220.914 131.762 218.151 127.202 215.111L116.563 207.927L115.458 209.861Z",
    fill: "#F1C335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.431 257.528C198.22 254.903 194.489 254.074 191.45 255.87L172.659 266.785C170.725 267.891 168.514 268.029 166.442 267.062C164.369 266.233 162.988 264.437 162.573 262.226L156.908 236.389C156.079 232.796 151.105 228.099 150.967 227.823L150.829 227.684L149.585 229.48C150.967 230.862 154.283 234.454 154.836 236.803L160.501 262.64C161.191 265.404 162.988 267.753 165.613 268.858C166.718 269.411 167.962 269.687 169.205 269.687C170.725 269.687 172.245 269.272 173.626 268.443L192.417 257.528C194.489 256.285 197.115 256.837 198.634 258.634L199.74 259.877L201.398 258.495L200.431 257.528Z",
    fill: "#B98800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.824 302.708L173.903 264.851C174.18 263.469 174.87 262.364 176.114 261.673L183.713 257.252C184.68 256.699 185.786 256.423 186.891 256.699C188.411 256.975 189.516 257.943 190.207 259.186L200.846 281.845C201.26 282.674 202.227 283.089 203.195 282.674C203.885 282.26 204.3 281.431 203.885 280.74L193.108 257.942C192.832 257.252 192.418 256.699 192.003 256.146C189.378 253.107 185.233 252.554 182.193 254.35L174.456 258.772C172.383 259.877 171.002 261.949 170.725 264.298L164.646 302.294C164.508 303.123 165.061 303.814 165.89 303.952C166.857 304.366 167.686 303.676 167.824 302.708Z",
    fill: "#8FA7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.003 260.291L202.642 282.95C201.951 283.089 201.26 282.674 200.846 281.983L190.207 259.324C189.931 258.771 189.516 258.219 189.102 257.942C190.345 258.219 191.45 259.048 192.003 260.291Z",
    fill: "#798DA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.646 302.432L170.725 264.436C171.14 262.087 172.522 260.153 174.456 258.91L182.193 254.488C184.68 252.968 187.996 253.107 190.483 254.903C188.273 254.074 185.924 254.35 183.851 255.455L176.114 259.877C174.041 260.982 172.66 263.055 172.383 265.403L166.304 303.399C166.304 303.675 166.304 303.952 166.442 304.228C166.304 304.228 166.028 304.228 165.89 304.228C165.061 304.09 164.508 303.261 164.646 302.432Z",
    fill: "#BCCFE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.268 238.599L126.235 243.02C126.649 245.093 127.755 246.889 129.413 248.133C129.413 248.133 129.413 248.133 129.551 248.133L131.623 249.376L163.954 268.029C163.401 267.614 162.849 267.2 162.434 266.647C161.467 265.542 160.776 264.16 160.5 262.778L159.533 258.633L125.268 238.599Z",
    fill: "#C48616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.323 201.709L238.703 212.072L252.796 220.914L272.278 210.414L258.323 201.709Z",
    fill: "#EB4E4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.796 221.605V220.914L238.703 212.072V212.901L252.796 221.605Z",
    fill: "#9F0B08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.138 220.085L251.691 220.362L271.172 209.861L270.62 209.585L251.138 220.085Z",
    fill: "#C32A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.138 220.086V219.809L270.62 209.447V209.585L251.138 220.086Z",
    fill: "#8D0B0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.895 206.821L240.36 211.795L253.21 219.809L270.757 210.414L270.895 206.821Z",
    fill: "#67D6EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.046 198.808L240.36 208.203L253.348 216.217L270.895 206.821L258.046 198.808Z",
    fill: "#90EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.21 219.809L253.348 216.217L240.36 208.203V211.795L253.21 219.809Z",
    fill: "#D8E2ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.348 217.598V214.006L240.36 207.927V209.585L253.348 217.598Z",
    fill: "#B3BBC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.487 220.638C253.349 221.053 253.072 221.329 252.796 221.605L272.277 211.105C272.277 211.105 272.415 210.967 272.415 210.828C272.554 210.552 272.692 210.276 272.83 209.999C273.244 209.032 273.245 207.927 272.968 207.098C272.692 206.131 272.416 205.578 272.277 205.44L252.796 215.941C252.796 215.941 253.21 216.631 253.487 217.599C253.763 218.566 253.901 219.533 253.487 220.638Z",
    fill: "#760806"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.934 216.078C252.934 216.078 253.349 216.769 253.625 217.736L273.106 207.236C272.83 206.268 272.554 205.716 272.416 205.578L252.934 216.078Z",
    fill: "#8D0B0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.796 221.605L272.277 211.105C272.277 211.105 272.415 210.966 272.415 210.828C272.554 210.552 272.692 210.276 272.83 209.999L253.349 220.5C253.349 220.914 253.072 221.329 252.796 221.605Z",
    fill: "#640806"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.979 207.236L258.461 196.735L260.395 197.979V198.117C260.395 198.393 260.395 198.808 260.533 199.084C260.81 200.051 261.362 200.742 262.053 201.295C263.02 202.124 264.126 202.676 265.231 202.953C265.507 203.091 265.784 203.091 265.922 203.091C266.751 203.229 267.442 203.367 268.133 203.229C268.409 203.229 268.685 203.229 269.1 203.091L270.481 203.92L270.896 204.196V204.334L271.449 204.611L271.587 204.473L272.692 205.163L253.211 215.664L251.553 214.697L251 214.421L238.979 207.236Z",
    fill: "#EB4E4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.395 197.979L268.961 203.367C268.685 203.367 268.409 203.505 267.994 203.505C267.303 203.505 266.612 203.505 265.783 203.367C265.507 203.367 265.369 203.229 265.093 203.229C263.987 202.953 262.882 202.4 261.915 201.571C261.224 201.018 260.671 200.189 260.395 199.36C260.257 199.084 260.257 198.67 260.257 198.393C260.395 198.117 260.395 198.117 260.395 197.979Z",
    fill: "#EB4E4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.934 216.77V216.079L238.979 207.236L238.841 208.065L252.934 216.77Z",
    fill: "#9F0B08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.935 216.079L252.796 215.94L252.382 216.079C252.382 216.079 253.764 218.704 252.658 220.914L252.796 221.743C255.421 219.671 252.935 216.079 252.935 216.079Z",
    fill: "#9F0B08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.276 215.25L251.829 215.526L271.31 205.025L270.895 204.749L251.276 215.25Z",
    fill: "#C32A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.276 215.25V214.973L270.895 204.473V204.749L251.276 215.25Z",
    fill: "#8D0B0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.323 195.906L238.703 206.406L252.796 215.111L272.278 204.61L258.323 195.906Z",
    fill: "#B0D879"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.796 215.94V215.111L238.703 206.407V207.098L252.796 215.94Z",
    fill: "#648C29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.138 214.282L251.691 214.696L271.172 204.196L270.62 203.781L251.138 214.282Z",
    fill: "#8DB051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.138 214.282V214.006L270.62 203.643V203.781L251.138 214.282Z",
    fill: "#5A7A26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.895 201.018L240.36 206.13L253.21 214.144L270.757 204.748L270.895 201.018Z",
    fill: "#D8939D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.046 193.004L240.36 202.399L253.348 210.551L270.895 201.018L258.046 193.004Z",
    fill: "#ECBFC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.21 214.144L253.348 210.551L240.36 202.399V206.13L253.21 214.144Z",
    fill: "#D8E2ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.348 211.933V208.34L240.36 202.261V203.919L253.348 211.933Z",
    fill: "#B3BBC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.487 214.835C253.349 215.249 253.072 215.526 252.796 215.802L272.277 205.301C272.277 205.301 272.415 205.163 272.415 205.025C272.554 204.749 272.692 204.472 272.83 204.196C273.244 203.229 273.245 202.123 272.968 201.294C272.692 200.327 272.416 199.775 272.277 199.636L252.796 210.137C252.796 210.137 253.21 210.828 253.487 211.795C253.763 212.762 253.901 213.868 253.487 214.835Z",
    fill: "#47631D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.934 210.275C252.934 210.275 253.349 210.966 253.625 211.933L273.106 201.432C272.83 200.465 272.554 199.913 272.416 199.774L252.934 210.275Z",
    fill: "#5A7A26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.796 215.94L272.277 205.439C272.277 205.439 272.415 205.301 272.415 205.163C272.554 204.887 272.692 204.61 272.83 204.334L253.349 214.835C253.349 215.249 253.072 215.525 252.796 215.94Z",
    fill: "#3A5119"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.979 201.571L258.461 191.07L260.395 192.314V192.452C260.395 192.728 260.395 193.143 260.533 193.419C260.81 194.386 261.362 195.077 262.053 195.63C263.02 196.459 264.126 197.011 265.231 197.288C265.507 197.426 265.784 197.426 265.922 197.426C266.751 197.564 267.442 197.702 268.133 197.564C268.409 197.564 268.685 197.564 269.1 197.426L270.481 198.255L270.896 198.531V198.669L271.449 198.946L271.587 198.807L272.692 199.498L253.211 209.999L251.553 209.032L251 208.755L238.979 201.571Z",
    fill: "#B0D879"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.395 192.313L268.961 197.702C268.685 197.702 268.409 197.84 267.994 197.84C267.303 197.84 266.612 197.84 265.783 197.702C265.507 197.702 265.369 197.564 265.093 197.564C263.987 197.287 262.882 196.735 261.915 195.906C261.224 195.353 260.671 194.524 260.395 193.695C260.257 193.419 260.257 193.004 260.257 192.728C260.395 192.452 260.395 192.313 260.395 192.313Z",
    fill: "#B0D879"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.934 211.105V210.275L238.979 201.571L238.841 202.262L252.934 211.105Z",
    fill: "#648C29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.935 210.275L252.796 210.137L252.382 210.275C252.382 210.275 253.764 212.9 252.658 215.111L252.796 215.94C255.421 213.867 252.935 210.275 252.935 210.275Z",
    fill: "#648C29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.276 209.446L251.829 209.723L271.31 199.36L270.895 198.946L251.276 209.446Z",
    fill: "#8DB051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.276 209.446V209.17L270.895 198.808V198.946L251.276 209.446Z",
    fill: "#5A7A26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.433 213.315C242.157 213.315 242.018 213.176 241.742 213.038C241.466 212.9 241.328 213.038 241.051 213.038C239.393 212.9 237.735 214.005 237.044 215.663C236.768 216.492 236.63 216.907 236.63 217.736C236.768 219.67 237.183 221.743 238.426 223.263C238.702 223.677 239.117 223.953 239.67 224.23C239.946 224.368 240.222 224.506 240.637 224.644C240.913 224.782 241.189 224.782 241.604 224.782C242.295 225.059 243.262 224.921 243.953 224.644C244.229 224.506 244.644 224.368 244.92 224.092C245.611 223.677 246.163 223.263 246.578 222.572C246.716 222.157 246.854 221.881 246.992 221.466C247.269 220.776 247.407 220.085 247.545 219.394C247.821 218.012 247.683 216.492 247.131 215.387C246.992 214.973 246.716 214.558 246.302 214.282C245.196 213.453 243.676 213.591 242.433 213.315Z",
    fill: "#A3210F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.807 214.42C240.636 214.282 241.465 214.282 242.294 214.42C243.123 214.558 243.952 214.42 244.781 214.696C245.472 214.973 246.163 215.525 246.439 216.216C246.578 216.631 246.716 217.183 246.716 217.598C246.716 218.841 246.716 220.223 246.163 221.467C245.887 222.296 245.196 223.125 244.505 223.677C243.814 224.23 242.709 224.644 241.88 224.368C241.327 224.23 240.775 224.092 240.222 223.954C239.393 223.815 239.117 223.125 238.702 222.572C238.149 221.743 237.873 221.052 237.597 220.085C237.32 219.118 237.044 218.151 237.182 217.045C237.182 216.354 237.182 214.835 238.011 214.42C238.564 214.282 239.255 214.42 239.807 214.42Z",
    fill: "#BA2511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.775 213.038C242.018 212.9 243.4 213.038 244.367 213.591C245.611 214.282 246.854 215.387 245.611 216.769C244.367 218.15 242.295 218.15 240.775 217.874C239.531 217.598 236.906 216.216 238.012 214.558C238.702 213.729 239.946 213.176 240.775 213.038Z",
    fill: "#D14230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.597 217.736C237.735 216.907 238.012 216.216 238.564 215.525C238.841 215.111 239.531 214.835 240.084 214.973C240.36 215.111 240.499 215.249 240.637 215.525C240.913 215.802 241.604 216.078 242.018 216.078C242.295 216.078 242.433 216.078 242.709 216.078C242.847 216.078 243.124 216.216 243.262 216.354C243.538 216.631 243.815 216.907 244.091 217.183C244.505 217.736 244.505 218.565 244.505 219.256C244.505 219.947 244.505 220.776 244.367 221.467C244.367 221.881 244.229 222.157 244.091 222.572C243.815 223.125 243.4 223.677 242.709 223.954C242.433 224.092 242.157 224.23 241.88 224.092C241.742 224.092 241.604 223.954 241.466 223.815C241.189 223.677 240.913 223.677 240.637 223.677C240.499 223.677 240.499 223.677 240.36 223.677C239.808 223.539 239.531 223.125 239.255 222.848C238.702 222.157 238.426 221.467 238.15 220.638C237.874 219.809 237.735 218.841 237.873 217.874C237.597 217.874 237.597 217.874 237.597 217.736Z",
    fill: "#D0321D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.913 214.558C240.775 214.282 240.637 213.729 241.189 213.729C241.328 213.729 241.466 213.867 241.604 213.867C241.742 214.005 242.018 214.005 242.157 213.867H242.295C242.433 213.867 242.571 213.867 242.709 214.005C242.847 214.144 242.986 214.42 242.847 214.558C242.709 214.834 242.295 214.834 242.018 214.834C241.742 214.834 241.466 214.696 241.189 214.558C241.051 214.696 241.051 214.696 240.913 214.558Z",
    fill: "#B92A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.88 214.972C241.88 214.696 241.88 213.867 241.328 213.176C240.775 212.347 240.637 211.104 240.637 211.104C240.637 211.104 240.637 210.965 240.913 210.965C241.051 210.965 241.189 211.104 241.189 211.104C241.189 211.104 241.189 211.932 241.88 213.038C242.295 213.867 242.433 214.558 242.295 214.834C242.295 214.834 242.295 214.834 242.157 214.834C242.018 215.11 242.018 215.11 241.88 214.972Z",
    fill: "#753800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.913 210.965C241.051 210.965 241.051 211.104 241.051 211.104C241.051 211.104 241.051 211.932 241.742 213.038C242.157 213.867 242.295 214.558 242.157 214.834C242.157 214.834 242.157 214.834 242.018 214.834C242.018 214.558 242.018 213.729 241.466 212.9C240.913 212.209 240.913 211.242 240.913 210.965Z",
    fill: "#8F531D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.019 213.591C242.019 213.591 241.466 212.762 242.986 212.209C244.506 211.656 243.815 210.551 243.815 210.551C243.815 210.551 244.92 211.242 245.197 212.209C245.335 213.176 245.059 213.867 244.23 214.005C243.401 214.143 243.124 214.143 242.019 213.591Z",
    fill: "#5FBD57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.985 212.209C244.505 211.656 243.814 210.551 243.814 210.551C244.091 210.827 244.367 211.104 244.505 211.656C244.643 212.624 244.091 213.176 243.4 213.453C242.985 213.591 242.571 213.867 241.88 213.591C241.88 213.314 241.604 212.624 242.985 212.209Z",
    fill: "#50AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.979 215.249C239.255 215.387 239.117 215.663 238.979 215.94C238.979 216.216 238.979 216.492 238.841 216.769C238.841 216.907 238.703 217.045 238.703 217.045C238.564 217.183 238.15 217.321 238.012 217.183C237.735 217.183 237.735 216.907 237.735 216.769C237.735 216.492 237.735 216.216 237.735 215.94C237.735 215.801 237.874 215.525 238.012 215.387C238.15 215.249 238.288 215.111 238.426 215.111C238.564 215.111 238.841 215.111 238.979 215.249Z",
    fill: "#FF6854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.735 218.703C237.735 218.565 237.735 218.288 237.735 218.15C237.735 218.012 237.735 217.597 237.874 217.459C238.15 217.321 238.564 217.459 238.703 217.597C238.841 217.736 238.841 217.874 238.841 218.012C238.841 218.565 238.841 218.979 238.841 219.532C238.841 219.808 238.979 219.946 238.979 220.223C238.979 220.361 239.117 220.637 239.117 220.775V220.913C239.117 221.052 238.841 221.052 238.841 221.052C238.426 220.913 238.288 220.499 238.15 220.223C238.012 219.808 237.874 219.532 237.874 219.117C237.735 219.117 237.735 218.979 237.735 218.703Z",
    fill: "#FF6854"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_293_11642",
    x: 23.5586,
    y: 0.753906,
    width: 424.692,
    height: 408.525,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_293_11642"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_293_11642",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_293_11642",
    x1: 408.321,
    y1: 196.708,
    x2: 293.795,
    y2: -1.65641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7A76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0114869,
    stopColor: "#807C78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0156251,
    stopColor: "#86827F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.018563,
    stopColor: "#918E8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0209336,
    stopColor: "#A19E9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0214572,
    stopColor: "#A6A3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4128,
    stopColor: "#A6A3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4165,
    stopColor: "#AFACA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#BFBDBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4378,
    stopColor: "#CBC8C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4544,
    stopColor: "#D1CFCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5005,
    stopColor: "#D3D1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5019,
    stopColor: "#D1CFCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5025,
    stopColor: "#CCCAC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6218,
    stopColor: "#D9D7D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6291,
    stopColor: "#E8E6E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8431,
    stopColor: "#E8E8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9644,
    stopColor: "#E8E8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9844,
    stopColor: "#E8E8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9907,
    stopColor: "#E8E6E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_293_11642",
    x1: 435.324,
    y1: 181.118,
    x2: 321.589,
    y2: -15.8753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0115427,
    stopColor: "#686562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0157008,
    stopColor: "#6E6B69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.018654,
    stopColor: "#7A7774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0210355,
    stopColor: "#8A8785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0214572,
    stopColor: "#8E8B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4128,
    stopColor: "#8E8B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4165,
    stopColor: "#979492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#A7A5A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4378,
    stopColor: "#B3B0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4544,
    stopColor: "#B9B7B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5005,
    stopColor: "#BBB9B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5019,
    stopColor: "#B9B7B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5025,
    stopColor: "#B4B2AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6218,
    stopColor: "#C1BFBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6291,
    stopColor: "#D0CECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8431,
    stopColor: "#D0D0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9644,
    stopColor: "#D0D0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9844,
    stopColor: "#D0D0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9907,
    stopColor: "#D0CECC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_293_11642",
    x1: 193.699,
    y1: 191.26,
    x2: 193.72,
    y2: 192.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_293_11642",
    x1: 197.507,
    y1: 193.481,
    x2: 197.528,
    y2: 194.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_293_11642",
    x1: 199.411,
    y1: 194.591,
    x2: 199.432,
    y2: 195.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_293_11642",
    x1: 201.315,
    y1: 195.701,
    x2: 201.336,
    y2: 196.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_293_11642",
    x1: 205.123,
    y1: 197.922,
    x2: 205.144,
    y2: 199.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_293_11642",
    x1: 207.027,
    y1: 199.032,
    x2: 207.048,
    y2: 200.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_293_11642",
    x1: 208.931,
    y1: 200.142,
    x2: 208.951,
    y2: 201.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_293_11642",
    x1: 212.739,
    y1: 202.363,
    x2: 212.759,
    y2: 203.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_293_11642",
    x1: 214.643,
    y1: 203.473,
    x2: 214.664,
    y2: 204.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_293_11642",
    x1: 216.547,
    y1: 204.584,
    x2: 216.568,
    y2: 205.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_293_11642",
    x1: 218.451,
    y1: 205.694,
    x2: 218.471,
    y2: 206.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_293_11642",
    x1: 191.81,
    y1: 192.092,
    x2: 191.837,
    y2: 193.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_293_11642",
    x1: 193.713,
    y1: 193.203,
    x2: 193.74,
    y2: 194.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_293_11642",
    x1: 195.617,
    y1: 194.313,
    x2: 195.644,
    y2: 196.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_293_11642",
    x1: 197.522,
    y1: 195.423,
    x2: 197.549,
    y2: 197.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_293_11642",
    x1: 199.425,
    y1: 196.534,
    x2: 199.452,
    y2: 198.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_293_11642",
    x1: 201.329,
    y1: 197.644,
    x2: 201.356,
    y2: 199.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_293_11642",
    x1: 203.233,
    y1: 198.754,
    x2: 203.26,
    y2: 200.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_293_11642",
    x1: 205.137,
    y1: 199.864,
    x2: 205.164,
    y2: 201.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_293_11642",
    x1: 207.041,
    y1: 200.975,
    x2: 207.068,
    y2: 202.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_293_11642",
    x1: 208.945,
    y1: 202.085,
    x2: 208.972,
    y2: 203.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_293_11642",
    x1: 210.849,
    y1: 203.195,
    x2: 210.876,
    y2: 204.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_293_11642",
    x1: 212.753,
    y1: 204.305,
    x2: 212.78,
    y2: 206.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_293_11642",
    x1: 215.508,
    y1: 205.402,
    x2: 215.553,
    y2: 208.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_293_11642",
    x1: 220.635,
    y1: 206.986,
    x2: 220.656,
    y2: 208.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_293_11642",
    x1: 222.539,
    y1: 208.096,
    x2: 222.559,
    y2: 209.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_293_11642",
    x1: 224.443,
    y1: 209.206,
    x2: 224.463,
    y2: 210.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_293_11642",
    x1: 218.744,
    y1: 207.818,
    x2: 218.771,
    y2: 209.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_293_11642",
    x1: 220.648,
    y1: 208.928,
    x2: 220.675,
    y2: 210.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_293_11642",
    x1: 222.552,
    y1: 210.039,
    x2: 222.579,
    y2: 211.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_293_11642",
    x1: 216.882,
    y1: 208.854,
    x2: 216.909,
    y2: 210.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_293_11642",
    x1: 218.786,
    y1: 209.965,
    x2: 218.813,
    y2: 211.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_293_11642",
    x1: 220.69,
    y1: 211.075,
    x2: 220.717,
    y2: 212.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_293_11642",
    x1: 190.803,
    y1: 193.115,
    x2: 190.848,
    y2: 195.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_293_11642",
    x1: 193.76,
    y1: 195.349,
    x2: 193.787,
    y2: 197.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_293_11642",
    x1: 195.664,
    y1: 196.46,
    x2: 195.691,
    y2: 198.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_293_11642",
    x1: 197.568,
    y1: 197.57,
    x2: 197.595,
    y2: 199.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_293_11642",
    x1: 199.472,
    y1: 198.68,
    x2: 199.499,
    y2: 200.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_293_11642",
    x1: 201.376,
    y1: 199.791,
    x2: 201.403,
    y2: 201.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_293_11642",
    x1: 203.28,
    y1: 200.901,
    x2: 203.307,
    y2: 202.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_293_11642",
    x1: 205.184,
    y1: 202.011,
    x2: 205.211,
    y2: 203.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_293_11642",
    x1: 207.088,
    y1: 203.121,
    x2: 207.115,
    y2: 204.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_293_11642",
    x1: 208.992,
    y1: 204.232,
    x2: 209.019,
    y2: 205.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_293_11642",
    x1: 210.895,
    y1: 205.342,
    x2: 210.922,
    y2: 207.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_293_11642",
    x1: 212.8,
    y1: 206.452,
    x2: 212.827,
    y2: 208.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_293_11642",
    x1: 188.945,
    y1: 194.152,
    x2: 188.99,
    y2: 196.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_293_11642",
    x1: 191.903,
    y1: 196.386,
    x2: 191.93,
    y2: 198.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_293_11642",
    x1: 193.807,
    y1: 197.496,
    x2: 193.834,
    y2: 199.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_293_11642",
    x1: 195.711,
    y1: 198.607,
    x2: 195.738,
    y2: 200.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_293_11642",
    x1: 197.615,
    y1: 199.717,
    x2: 197.642,
    y2: 201.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_293_11642",
    x1: 199.518,
    y1: 200.827,
    x2: 199.545,
    y2: 202.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_293_11642",
    x1: 201.423,
    y1: 201.937,
    x2: 201.45,
    y2: 203.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_293_11642",
    x1: 203.326,
    y1: 203.048,
    x2: 203.353,
    y2: 204.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_293_11642",
    x1: 205.23,
    y1: 204.158,
    x2: 205.257,
    y2: 205.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_293_11642",
    x1: 207.134,
    y1: 205.268,
    x2: 207.161,
    y2: 206.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_293_11642",
    x1: 209.038,
    y1: 206.378,
    x2: 209.065,
    y2: 208.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_293_11642",
    x1: 212.811,
    y1: 207.459,
    x2: 212.856,
    y2: 210.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_293_11642",
    x1: 187.939,
    y1: 195.175,
    x2: 188.002,
    y2: 199.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_293_11642",
    x1: 191.949,
    y1: 198.533,
    x2: 191.976,
    y2: 200.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_293_11642",
    x1: 193.853,
    y1: 199.643,
    x2: 193.88,
    y2: 201.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_293_11642",
    x1: 195.757,
    y1: 200.753,
    x2: 195.784,
    y2: 202.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_293_11642",
    x1: 197.661,
    y1: 201.863,
    x2: 197.688,
    y2: 203.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_293_11642",
    x1: 199.565,
    y1: 202.974,
    x2: 199.592,
    y2: 204.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_293_11642",
    x1: 201.469,
    y1: 204.084,
    x2: 201.496,
    y2: 205.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_293_11642",
    x1: 203.373,
    y1: 205.194,
    x2: 203.4,
    y2: 206.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_293_11642",
    x1: 205.277,
    y1: 206.304,
    x2: 205.304,
    y2: 208.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_293_11642",
    x1: 185.236,
    y1: 196.225,
    x2: 185.281,
    y2: 199.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_293_11642",
    x1: 188.188,
    y1: 198.459,
    x2: 188.215,
    y2: 200.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_293_11642",
    x1: 190.092,
    y1: 199.569,
    x2: 190.119,
    y2: 201.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_293_11642",
    x1: 201.516,
    y1: 206.231,
    x2: 201.543,
    y2: 207.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_293_11642",
    x1: 203.419,
    y1: 207.341,
    x2: 203.446,
    y2: 209.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_293_11642",
    x1: 205.323,
    y1: 208.451,
    x2: 205.35,
    y2: 210.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_293_11642",
    x1: 208.078,
    y1: 209.548,
    x2: 208.123,
    y2: 212.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_293_11642",
    x1: 215.086,
    y1: 212.019,
    x2: 215.113,
    y2: 213.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_293_11642",
    x1: 211.325,
    y1: 211.945,
    x2: 211.352,
    y2: 213.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_293_11642",
    x1: 213.229,
    y1: 213.056,
    x2: 213.256,
    y2: 214.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_293_11642",
    x1: 215.133,
    y1: 214.166,
    x2: 215.16,
    y2: 215.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_293_11642",
    x1: 195.398,
    y1: 200.625,
    x2: 195.497,
    y2: 206.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_293_11642",
    x1: 208.883,
    y1: 207.388,
    x2: 208.946,
    y2: 211.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00706227,
    stopColor: "#0C0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00740747,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    stopColor: "#202727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#181C1C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErpOffer);
export default __webpack_public_path__ + "static/media/erpOffer.2c7bba04a7401e4abfbfce3e39c79902.svg";
export { ForwardRef as ReactComponent };